function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("f45ZV", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuesArchive", ()=>$697762d2b55a987c$export$1f6588d350835164);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $3Rnof;
    var $9dbF6;
    var $9NiTW;
    var $4dRjY;
    var $dZw8H;
    var $l8ruj;
    const $697762d2b55a987c$export$1f6588d350835164 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-archives"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jira-issues-archives",
            packageName: "jira-archives",
            teamName: "kenji",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Rnof")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)))));
});
parcelRegister("3Rnof", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2bcf43769e8ba32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $01SST;
    var $39xOx;
    var $iXVV6;
    var $dWVXT;
    var $58lzA;
    var $84j7q;
    var $2jUmR;
    var $lAbPh;
    var $je0WH;
    var $66gBN;
    var $8TTKp;
    var $Jc0QV;
    var $h5kQv;
    var $gA8E0;
    const $e2bcf43769e8ba32$var$Archives = ()=>{
        const { archivesIssueDataPresent: archivesIssueDataPresent } = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const { setArchivesIssueDataPresent: setArchivesIssueDataPresent } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                !archivesIssueDataPresent && setArchivesIssueDataPresent(true);
            };
        }, [
            archivesIssueDataPresent,
            setArchivesIssueDataPresent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jiraArchiveIssuesPage",
            packageName: "jiraIssueArchivalArchives",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lAbPh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "archivesPage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gA8E0")).LayoutMainWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("66gBN")).default), {
            bottomBar: archivesIssueDataPresent === false ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("01SST")).default), {
                justifyContent: "space-between"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h5kQv")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("je0WH")).Filters), null))
        }), archivesIssueDataPresent === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2jUmR")).ArchivesTableEmptyState), {
            noDataState: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e2bcf43769e8ba32$var$ContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TTKp")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Jc0QV")).IssueManageBar), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWVXT")).default), null)))));
    };
    const $e2bcf43769e8ba32$var$ContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41930 _16jlkb7n _1o9zkb7n _i0dlf1ug _otyrxy5q",
                __cmplp.className
            ])
        });
    });
    var $e2bcf43769e8ba32$export$2e2bcd8739ae039 = $e2bcf43769e8ba32$var$Archives;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("dWVXT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17bec3dcbb6b348a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $aIfBd;
    const $17bec3dcbb6b348a$var$runtimeProps = {};
    const $17bec3dcbb6b348a$var$entryPointParams = {};
    const $17bec3dcbb6b348a$var$AsyncUnarchiveModal = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aIfBd")).unarchiveModalEntryPoint), $17bec3dcbb6b348a$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
            return ()=>{
                entryPointActions.unload();
            };
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-unarchive-issue-modal",
            packageName: "jiraUnarchiveModal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $17bec3dcbb6b348a$var$runtimeProps
        });
    };
    var $17bec3dcbb6b348a$export$2e2bcd8739ae039 = $17bec3dcbb6b348a$var$AsyncUnarchiveModal;
});
parcelRegister("aIfBd", function(module, exports) {
    $parcel$export(module.exports, "unarchiveModalEntryPoint", ()=>$bd2096e46b3bfcd1$export$ea1ad361ecb74284);
    var $fuQSj;
    var $5pTlS;
    const $bd2096e46b3bfcd1$export$ea1ad361ecb74284 = (0, (0, parcelRequire("5pTlS")).createEntryPoint)({
        root: (0, (0, parcelRequire("fuQSj")).JSResourceForInteraction)(()=>(parcelRequire("eXYL7")), {
            moduleId: "675b37a7"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eXYL7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("itGvo")
    ]).then(()=>parcelRequire('bS8A4'));
});
parcelRegister("58lzA", function(module, exports) {
    $parcel$export(module.exports, "ArchiveIssuesStore", ()=>$631c220fc35cc2d1$export$4b4186aed8f7ee90);
    $parcel$export(module.exports, "useArchiveIssueActions", ()=>$631c220fc35cc2d1$export$9cf896227421597b);
    var $7JoAD = parcelRequire("7JoAD");
    var $hqMMB;
    var $8SmpT;
    const $631c220fc35cc2d1$export$4b4186aed8f7ee90 = (0, $7JoAD.createStore)({
        initialState: (0, parcelRequire("8SmpT")).initialState,
        actions: (0, (0, parcelRequire("hqMMB")).ArchiveIssueTableActions),
        name: 'archiveIssuesStore'
    });
    const $631c220fc35cc2d1$export$9cf896227421597b = (0, $7JoAD.createActionsHook)($631c220fc35cc2d1$export$4b4186aed8f7ee90);
});
parcelRegister("hqMMB", function(module, exports) {
    $parcel$export(module.exports, "ArchiveIssueTableActions", ()=>$1b418f3ed07ec037$export$59c3a0901053708c);
    const $1b418f3ed07ec037$export$59c3a0901053708c = {
        setIssuesInCurrentPage: (issues)=>({ setState: setState })=>{
                setState({
                    issuesInCurrentPage: issues
                });
            },
        setProjectId: (projectId)=>({ setState: setState })=>{
                setState({
                    projectId: projectId
                });
            },
        setLoading: (isLoading)=>({ setState: setState })=>{
                setState({
                    isLoading: isLoading
                });
            },
        updateIssueDetails: (issueDetails)=>{
            return ({ setState: setState })=>{
                setState({
                    issueDetails: {
                        ...issueDetails
                    }
                });
            };
        },
        selectIssue: ({ issueId: issueId, pageNumber: pageNumber })=>({ setState: setState, getState: getState })=>{
                const { selectedIssues: selectedIssues, numberOfSelectedIssues: numberOfSelectedIssues } = getState();
                const isSelected = selectedIssues[pageNumber]?.includes(issueId);
                if (!isSelected) {
                    const updatedSelectedIssuesForPage = selectedIssues[pageNumber] ? [
                        ...selectedIssues[pageNumber],
                        issueId
                    ] : [
                        issueId
                    ];
                    setState({
                        selectedIssues: {
                            ...selectedIssues,
                            [pageNumber]: updatedSelectedIssuesForPage
                        },
                        numberOfSelectedIssues: numberOfSelectedIssues + 1
                    });
                }
            },
        deselectIssue: ({ issueId: issueId, pageNumber: pageNumber })=>({ setState: setState, getState: getState })=>{
                const { selectedIssues: selectedIssues, numberOfSelectedIssues: numberOfSelectedIssues } = getState();
                const isSelected = selectedIssues[pageNumber]?.includes(issueId);
                if (isSelected) {
                    const updatedSelectedIssuesForPage = selectedIssues[pageNumber].filter((id)=>id !== issueId);
                    setState({
                        selectedIssues: {
                            ...selectedIssues,
                            [pageNumber]: updatedSelectedIssuesForPage
                        },
                        numberOfSelectedIssues: numberOfSelectedIssues - 1
                    });
                }
            },
        selectAllIssuesInCurrentPage: ()=>({ setState: setState, getState: getState })=>{
                const { selectedIssues: selectedIssues, issuesInCurrentPage: issuesInCurrentPage, numberOfSelectedIssues: numberOfSelectedIssues, currentPage: currentPage } = getState();
                const updatedSelectedIssuesForPage = [];
                issuesInCurrentPage.forEach((issueId)=>{
                    updatedSelectedIssuesForPage.push(issueId);
                });
                const updatedNumberOfSelectedIssues = numberOfSelectedIssues + issuesInCurrentPage.length;
                setState({
                    selectedIssues: {
                        ...selectedIssues,
                        [currentPage]: updatedSelectedIssuesForPage
                    },
                    numberOfSelectedIssues: updatedNumberOfSelectedIssues
                });
            },
        clearSelectionsInCurrentPage: ()=>({ setState: setState, getState: getState })=>{
                const { numberOfSelectedIssues: numberOfSelectedIssues, selectedIssues: selectedIssues, currentPage: currentPage } = getState();
                const selectedIssuesForCurrentPage = selectedIssues[currentPage];
                const numberOfSelectedIssuesOnCurrentPage = selectedIssuesForCurrentPage?.length || 0;
                const updatedselectedIssuesInPage = {
                    ...selectedIssues,
                    [currentPage]: []
                };
                setState({
                    selectedIssues: updatedselectedIssuesInPage,
                    numberOfSelectedIssues: numberOfSelectedIssues - numberOfSelectedIssuesOnCurrentPage
                });
            },
        clearAllSelections: ()=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    ...state,
                    selectedIssues: {},
                    numberOfSelectedIssues: 0
                });
            },
        addIssueInCurrentPage: (issueId)=>({ setState: setState, getState: getState })=>{
                const { issuesInCurrentPage: issuesInCurrentPage } = getState();
                const isIssueInCurrentPage = issuesInCurrentPage.includes(issueId);
                if (!isIssueInCurrentPage) setState({
                    issuesInCurrentPage: [
                        ...issuesInCurrentPage,
                        issueId
                    ]
                });
            },
        clearIssuesInCurrentPage: ()=>({ setState: setState })=>{
                setState({
                    issuesInCurrentPage: []
                });
            },
        setCurrentPage: (pageNumber)=>({ setState: setState })=>{
                setState({
                    currentPage: pageNumber
                });
            },
        setFilters: (filterValue)=>({ setState: setState })=>{
                const updatedFilterValue = {
                    ...filterValue
                };
                Object.keys(updatedFilterValue).forEach((key)=>{
                    const value = updatedFilterValue[key];
                    if (!Array.isArray(value) && value?.value && Object.keys(value.value).length === 0) delete updatedFilterValue[key];
                });
                setState({
                    filters: updatedFilterValue,
                    refetchArchivesIssuesData: true,
                    currentPage: 1
                });
            },
        setSearchBy: (searchBy)=>({ setState: setState })=>{
                setState({
                    searchBy: searchBy,
                    refetchArchivesIssuesData: true,
                    currentPage: 1
                });
            },
        setArchivesIssueDataPresent: (archivesIssueDataPresent)=>({ setState: setState })=>{
                setState({
                    archivesIssueDataPresent: archivesIssueDataPresent
                });
            },
        setRefetchArchivesIssuesData: (refetchArchivesIssuesData)=>({ setState: setState })=>{
                setState({
                    refetchArchivesIssuesData: refetchArchivesIssuesData
                });
            }
    };
});
parcelRegister("8SmpT", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$6a0390ea44cc7b98$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "filterFields", ()=>$6a0390ea44cc7b98$export$488edbb91e4d1f17);
    var $ay8aw;
    const $6a0390ea44cc7b98$export$d4c72bab9d6cc13a = {
        isLoading: false,
        issuesInCurrentPage: [],
        selectedIssues: {},
        numberOfSelectedIssues: 0,
        currentPage: 1,
        totalPages: 2,
        issuesMockData: (0, parcelRequire("ay8aw")).issuesMockData,
        filters: {},
        projectId: '',
        searchBy: '',
        issueDetails: {},
        archivesIssueDataPresent: true,
        refetchArchivesIssuesData: true
    };
    const $6a0390ea44cc7b98$export$488edbb91e4d1f17 = {
        issueType: {
            label: 'ISSUE TYPE',
            options: [],
            type: 'AvatarSelectFilter'
        },
        reporter: {
            label: 'REPORTER',
            options: [],
            type: 'AvatarAsyncSelectFilter',
            defaultOptions: [],
            cacheOptions: true
        },
        archivedDate: {
            label: 'ARCHIVED DATE',
            type: 'DateFilter'
        },
        archivedBy: {
            label: 'ARCHIVED BY',
            options: [],
            type: 'AvatarAsyncSelectFilter',
            defaultOptions: [],
            cacheOptions: true
        }
    };
});
parcelRegister("ay8aw", function(module, exports) {
    $parcel$export(module.exports, "issuesMockData", ()=>$d2d393c5dbe845fa$export$3e446492b22c602e);
    const $d2d393c5dbe845fa$export$3e446492b22c602e = {
        1: [
            {
                issueId: 10412,
                issueType: {
                    issueTypeId: '10004',
                    name: 'Story',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                    }
                },
                issueKey: 'KAN-363',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-05T08:34:03.07Z'
            },
            {
                issueId: 10411,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'KAN-362',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            },
            {
                issueId: 10410,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-361',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10408,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-359',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10409,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-360',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10398,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-353',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10352,
                issueType: {
                    issueTypeId: '10004',
                    name: 'Story',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                    }
                },
                issueKey: 'KAN-397',
                summary: 'Dummy Issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-05T08:34:03.07Z'
            },
            {
                issueId: 10007,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'SE-2',
                summary: 'testing',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            },
            {
                issueId: 10008,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'test summary',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10009,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'test summary',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10010,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'dummy issues',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10011,
                issueType: {
                    issueTypeId: '10004',
                    name: 'Story',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                    }
                },
                issueKey: 'SS-1',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-05T08:34:03.07Z'
            },
            {
                issueId: 10012,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'SE-2',
                summary: 'testing',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            },
            {
                issueId: 10013,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'SE-2',
                summary: 'testing',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            },
            {
                issueId: 10014,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'test summary',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10015,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'dummy issues',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10016,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'test summary',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10017,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-4',
                summary: 'dummy issues',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10018,
                issueType: {
                    issueTypeId: '10004',
                    name: 'Story',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                    }
                },
                issueKey: 'SS-1',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-05T08:34:03.07Z'
            },
            {
                issueId: 10019,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'SE-2',
                summary: 'testing',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            }
        ],
        2: [
            {
                issueId: 10407,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-358',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10406,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-357',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10404,
                issueType: {
                    issueTypeId: '10005',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-355',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-09-19T08:34:03.07Z'
            },
            {
                issueId: 10399,
                issueType: {
                    issueTypeId: '10008',
                    name: 'Task',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium'
                    }
                },
                issueKey: 'KAN-354',
                summary: 'This is a archived issue',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-02T08:34:03.07Z'
            },
            {
                issueId: 10024,
                issueType: {
                    issueTypeId: '10004',
                    name: 'Story',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                    }
                },
                issueKey: 'SS-1',
                summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-03-05T08:34:03.07Z'
            },
            {
                issueId: 10025,
                issueType: {
                    issueTypeId: '10006',
                    name: 'Epic',
                    avatar: {
                        medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                    }
                },
                issueKey: 'SE-2',
                summary: 'testing',
                archivedBy: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: '',
                        name: 'Unassigned',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                reporter: {
                    user: {
                        id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                        accountStatus: 'active',
                        avatarUrl: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                        name: 'Rohit Kumar',
                        __typename: 'AtlassianAccountUser'
                    }
                },
                archivedDate: '2024-04-24T08:34:03.07Z'
            }
        ]
    };
});
parcelRegister("84j7q", function(module, exports) {
    $parcel$export(module.exports, "useArchiveIssueStates", ()=>$fba1dec5b5c46a13$export$486b776c8b816793);
    $parcel$export(module.exports, "getAllSelectedIssuesWithDetails", ()=>$fba1dec5b5c46a13$export$583fa87c588f3d49);
    $parcel$export(module.exports, "isIssueSelected", ()=>$fba1dec5b5c46a13$export$32568110248dd20a);
    $parcel$export(module.exports, "getNumberOfSelectedIssues", ()=>$fba1dec5b5c46a13$export$89dc5c606d599ac2);
    $parcel$export(module.exports, "getNumberOfSelectedIssuesForPage", ()=>$fba1dec5b5c46a13$export$d43a8ad2f8ecedd);
    $parcel$export(module.exports, "getNumberOfIssuesForCurrentPage", ()=>$fba1dec5b5c46a13$export$61283cd79b4124c4);
    $parcel$export(module.exports, "getLoadingState", ()=>$fba1dec5b5c46a13$export$2786ecc2e2951fe3);
    $parcel$export(module.exports, "getCurrentPage", ()=>$fba1dec5b5c46a13$export$7945ba8eb1c827e6);
    var $7JoAD = parcelRequire("7JoAD");
    var $58lzA;
    const $fba1dec5b5c46a13$export$486b776c8b816793 = (0, $7JoAD.createStateHook)((0, (0, parcelRequire("58lzA")).ArchiveIssuesStore));
    const $fba1dec5b5c46a13$export$3d538825a61bfe9b = ({ state: state, pageNumber: pageNumber })=>{
        const selectedIssues = state.selectedIssues?.[pageNumber];
        return selectedIssues || [];
    };
    const $fba1dec5b5c46a13$export$6f1b9c3714a8d26e = ({ state: state })=>{
        if (!state.selectedIssues) return [];
        const selectedIssues = Object.values(state.selectedIssues);
        return selectedIssues.flat();
    };
    const $fba1dec5b5c46a13$export$583fa87c588f3d49 = ({ state: state })=>{
        if (!state.selectedIssues) return [];
        const issueDetails = state.issueDetails;
        const selectedIssues = Object.values(state.selectedIssues);
        return selectedIssues.flat().map((issueId)=>{
            return issueDetails[issueId];
        });
    };
    const $fba1dec5b5c46a13$export$c2e4f22ccec99b46 = ({ state: state, issueId: issueId })=>{
        let selectedIssuePagenumber;
        for(const pageNumber in state.selectedIssues)if (state.selectedIssues[pageNumber].includes(issueId)) selectedIssuePagenumber = Number(pageNumber);
        if (selectedIssuePagenumber === undefined) return undefined;
        return state.issuesMockData[selectedIssuePagenumber].find((issue)=>issue.issueId.toString() === issueId)?.issueKey;
    };
    const $fba1dec5b5c46a13$export$32568110248dd20a = ({ state: state, pageNumber: pageNumber, issueId: issueId })=>{
        const selectedIssues = state.selectedIssues[pageNumber];
        return !!selectedIssues && selectedIssues.includes(issueId);
    };
    const $fba1dec5b5c46a13$export$89dc5c606d599ac2 = ({ state: state })=>state.numberOfSelectedIssues;
    const $fba1dec5b5c46a13$export$d43a8ad2f8ecedd = ({ state: state, pageNumber: pageNumber })=>{
        const selectedIssues = state.selectedIssues[pageNumber];
        return selectedIssues ? selectedIssues.length : 0;
    };
    const $fba1dec5b5c46a13$export$ff8213a8fac8bd8b = ({ state: state })=>state.issuesInCurrentPage;
    const $fba1dec5b5c46a13$export$61283cd79b4124c4 = ({ state: state })=>state.issuesInCurrentPage.length;
    const $fba1dec5b5c46a13$export$2786ecc2e2951fe3 = ({ state: state })=>state.isLoading;
    const $fba1dec5b5c46a13$export$7945ba8eb1c827e6 = ({ state: state })=>state.currentPage;
    const $fba1dec5b5c46a13$export$652b307566494a6 = ({ state: state })=>state.totalPages;
    const $fba1dec5b5c46a13$export$89040d072f281f85 = ({ state: state })=>state.projectId;
    const $fba1dec5b5c46a13$export$f6546bb98204a0ca = ({ state: state })=>state.filters;
    const $fba1dec5b5c46a13$export$b4497a6ae2ff3a2a = ({ state: state, currentPage: currentPage })=>state.issuesMockData[currentPage] || [];
});
parcelRegister("2jUmR", function(module, exports) {
    $parcel$export(module.exports, "ArchivesTableEmptyState", ()=>$71bc1a4ed575544d$export$7acb0f18fcb70012);
    var $5uXOq = parcelRequire("5uXOq");
    var $YIdgD;
    var $ktx1d;
    var $e65Lk;
    var $2zROn;
    var $ii5wQ;
    var $fRlWz;
    var $c7i3D;
    var $koVbs;
    var $36OOP;
    var $58lzA;
    var $84j7q;
    var $5NRpK;
    const $71bc1a4ed575544d$var$NoIssuesIllustration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: $71bc1a4ed575544d$var$imageWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c7i3D")).default), {
            alt: ""
        }));
    const $71bc1a4ed575544d$export$7acb0f18fcb70012 = ({ noDataState: noDataState })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { setFilters: setFilters, setSearchBy: setSearchBy, setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const { filters: filters, searchBy: searchBy } = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const showClearButton = Object.keys(filters).length > 0 || searchBy;
        const clearSearchOnClick = ()=>{
            setFilters({});
            setSearchBy('');
            setRefetchArchivesIssuesData(true);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: $71bc1a4ed575544d$var$emptyIssuesContainerStyles,
            testId: `${(0, (0, parcelRequire("36OOP")).ARCHIVES_TABLE_TEST_ID)}.empty-state`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ktx1d")).default), {
            imageWidth: 228,
            header: noDataState ? formatMessage((0, (0, parcelRequire("5NRpK")).default).emptyStateNoDataMessage) : formatMessage((0, (0, parcelRequire("5NRpK")).default).emptyStateMessage),
            description: noDataState ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2zROn")).default), {
                as: "p"
            }, formatMessage((0, (0, parcelRequire("5NRpK")).default).emptyStateNoDataDescriptionMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fRlWz")).default), {
                href: "https://support.atlassian.com/jira-software-cloud/docs/archive-an-issue"
            }, formatMessage((0, (0, parcelRequire("5NRpK")).default).emptyStateArchiveIssueSupportMessage))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2zROn")).default), {
                as: "p"
            }, formatMessage((0, (0, parcelRequire("5NRpK")).default).emptyStateMessagePartTwo)),
            headingLevel: 2,
            primaryAction: showClearButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YIdgD")).default), {
                appearance: "primary",
                onClick: ()=>clearSearchOnClick(),
                testId: `${(0, (0, parcelRequire("36OOP")).ARCHIVES_TABLE_TEST_ID)}.empty-state.clear-search-button`
            }, formatMessage((0, (0, parcelRequire("5NRpK")).default).clearSearchMessage)) : null,
            renderImage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($71bc1a4ed575544d$var$NoIssuesIllustration, null)
        }));
    };
    const $71bc1a4ed575544d$var$imageWrapperStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        maxHeight: '146px',
        maxWidth: '160px',
        margin: 'auto',
        marginBottom: 'space.300'
    });
    const $71bc1a4ed575544d$var$emptyIssuesContainerStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        position: 'sticky',
        left: 'space.0',
        paddingBlock: 'space.800'
    });
});
parcelRegister("fRlWz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a01c81efca58d914$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    const $a01c81efca58d914$var$SectionMessageAction = (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
        return onClick || href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
    $a01c81efca58d914$var$SectionMessageAction.displayName = 'SectionMessageAction';
    var $a01c81efca58d914$export$2e2bcd8739ae039 = $a01c81efca58d914$var$SectionMessageAction;
});
parcelRegister("c7i3D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5BNLu")))));
    var $dCLgq;
    var $f3FKt = parcelRequire("f3FKt");
    var $5BNLu = parcelRequire("5BNLu");
    const $e6eff2dc5f73fdbc$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5BNLu)),
        srcDark: ($parcel$interopDefault($f3FKt))
    });
    var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
    const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
        0,
        0,
        208,
        190
    ];
});
parcelRegister("f3FKt", function(module, exports) {
    module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();
});
parcelRegister("5BNLu", function(module, exports) {
    module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();
});
parcelRegister("36OOP", function(module, exports) {
    $parcel$export(module.exports, "ARCHIVE_TABLE_COLUMN_KEYS", ()=>$e098daead7e6be6b$export$c5500cf522a3f99b);
    $parcel$export(module.exports, "ARCHIVE_TABLE_COLUMN_WIDTHS", ()=>$e098daead7e6be6b$export$5e400327feaf148);
    $parcel$export(module.exports, "ARCHIVES_TABLE_TEST_ID", ()=>$e098daead7e6be6b$export$d04a7179b5d2214e);
    $parcel$export(module.exports, "NUMBER_OF_ISSUES_PER_PAGE", ()=>$e098daead7e6be6b$export$ec00768bb4b64a4);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$e098daead7e6be6b$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$e098daead7e6be6b$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$e098daead7e6be6b$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$e098daead7e6be6b$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$e098daead7e6be6b$export$fb22dccd99438559);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$e098daead7e6be6b$export$39aa3a14ebf850c7);
    const $e098daead7e6be6b$export$c5500cf522a3f99b = {
        SELECT: 'select',
        TYPE: 'type',
        KEY: 'key',
        SUMMARY: 'summary',
        ARCHIVED_BY: 'archivedBy',
        REPORTER: 'reporter',
        ARCHIVED_DATE: 'archived-date'
    };
    const $e098daead7e6be6b$export$5e400327feaf148 = {
        SELECT: 4,
        TYPE: 5,
        KEY: 12,
        SUMMARY: 42,
        ARCHIVED_BY: 16,
        REPORTER: 16,
        ARCHIVED_DATE: 12
    };
    const $e098daead7e6be6b$export$d04a7179b5d2214e = 'issue-archival-archives.archives-table';
    const $e098daead7e6be6b$export$ec00768bb4b64a4 = 50;
    const $e098daead7e6be6b$export$b6d617db656efcca = 360;
    const $e098daead7e6be6b$export$90bfd0dcc25478e1 = 20;
    const $e098daead7e6be6b$export$dd535f74d98d8b3 = 32;
    const $e098daead7e6be6b$export$dba112976ea61483 = $e098daead7e6be6b$export$b6d617db656efcca - $e098daead7e6be6b$export$90bfd0dcc25478e1 * 2;
    const $e098daead7e6be6b$export$fe1082abeeda69ed = 4;
    const $e098daead7e6be6b$export$17ed91292eb6c163 = 16;
    const $e098daead7e6be6b$export$fb22dccd99438559 = 14;
    const $e098daead7e6be6b$export$de3cbeaaf9d2669 = 28;
    const $e098daead7e6be6b$export$39aa3a14ebf850c7 = 150;
});
parcelRegister("5NRpK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c83da33d1f00770$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0c83da33d1f00770$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateMessage: {
            "id": "issue-archival-archives.archives-table.empty-state.empty-state-message",
            "defaultMessage": "We couldn\u2019t find what you\u2019re looking for"
        },
        emptyStateMessagePartTwo: {
            "id": "issue-archival-archives.archives-table.empty-state.empty-state-message-part-two",
            "defaultMessage": "Try using different search terms or filters."
        },
        emptyStateNoDataMessage: {
            "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-message",
            "defaultMessage": "There are no archived issues"
        },
        emptyStateNoDataDescriptionMessage: {
            "id": "issue-archival-archives.archives-table.empty-state.empty-state-no-data-description-message",
            "defaultMessage": "Any archived issues in your project will appear here."
        },
        emptyStateArchiveIssueSupportMessage: {
            "id": "issue-archival-archives.archives-table.empty-state.empty-state-archive-issue-support-message",
            "defaultMessage": "More about archiving issues"
        },
        clearSearchMessage: {
            "id": "issue-archival-archives.archives-table.empty-state.clear-search-message",
            "defaultMessage": "Clear search"
        }
    });
});
parcelRegister("lAbPh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe8ecd97defb1e93$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ktx1d;
    var $bTyOW;
    var $iVgQf;
    var $koVbs;
    var $gFmSP;
    const $fe8ecd97defb1e93$var$MAX_IMAGE_WIDTH_PX = 188;
    const $fe8ecd97defb1e93$var$MAX_IMAGE_HEIGHT_PX = 250;
    const $fe8ecd97defb1e93$var$IMAGE_WIDTH_PX = 188;
    const $fe8ecd97defb1e93$var$renderImage = ()=>(0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default))({
            imageWidth: $fe8ecd97defb1e93$var$IMAGE_WIDTH_PX,
            maxImageWidth: $fe8ecd97defb1e93$var$MAX_IMAGE_WIDTH_PX,
            maxImageHeight: $fe8ecd97defb1e93$var$MAX_IMAGE_HEIGHT_PX
        });
    const $fe8ecd97defb1e93$var$ErrorState = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fe8ecd97defb1e93$export$412bc65ea3f44cf1, {
            "data-testid": "issue-archival-archives.ui.error-state.fetch-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ktx1d")).default), {
            renderImage: $fe8ecd97defb1e93$var$renderImage,
            header: formatMessage((0, (0, parcelRequire("gFmSP")).default).header),
            description: formatMessage((0, (0, parcelRequire("gFmSP")).default).description),
            width: "narrow"
        }));
    });
    var $fe8ecd97defb1e93$export$2e2bcd8739ae039 = $fe8ecd97defb1e93$var$ErrorState;
    const $fe8ecd97defb1e93$export$412bc65ea3f44cf1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("gFmSP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43bbfe5d5107b372$export$2e2bcd8739ae039);
    var $7VHMR;
    var $43bbfe5d5107b372$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "issue-archival-archives.error-state.header",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "issue-archival-archives.error-state.description",
            "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
        }
    });
});
parcelRegister("je0WH", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$00bc9618ec8fa9ac$export$92a576f896a9bf72);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $bRHJ4;
    var $39xOx;
    var $8zOmE;
    var $2Dcc2;
    var $gAHjC;
    var $2qg13;
    var $58lzA;
    var $84j7q;
    var $e0AlY;
    var $6w0Dt;
    const $00bc9618ec8fa9ac$export$92a576f896a9bf72 = (0, $5uXOq.memo)(()=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const close = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const { filters: filters, projectId: projectId } = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const { setFilters: setFilters } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2Dcc2")).useAnalyticsEvents)();
        const { fieldConfig: fieldConfig } = (0, (0, parcelRequire("2qg13")).getFilterFieldConfig)();
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("gAHjC")).default));
        const toggle = (0, $5uXOq.useCallback)(()=>{
            projectId && loadQuery({
                projectId: projectId
            });
            setIsOpen((prevIsOpen)=>!prevIsOpen);
        }, [
            loadQuery,
            projectId
        ]);
        const count = Object.values(filters).flat().length;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "issue.issue-view.activity.archived-issues-filter-selected",
            packageName: "jiraArchivedIssues",
            teamName: "kenji",
            fallback: "unmount",
            onError: (error)=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'Filters Set', {
                    error: error,
                    meta: {
                        id: 'issue.issue-view.activity.archived-issues-filter-selectedr',
                        teamName: 'kenji'
                    },
                    attributes: {
                        experience: 'archivedIssuesFilterSelectionFailed',
                        analyticsSource: 'jiraArchivedIssues',
                        error: error
                    }
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRHJ4")).default), {
            isOpen: isOpen,
            onClose: close,
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, queryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0AlY")).MenuContent), {
                    "data-testid": "issue-archival-archives.ui.filter.filter",
                    count: count,
                    fieldConfig: fieldConfig,
                    filters: filters,
                    setFilters: setFilters,
                    queryReference: queryReference,
                    projectId: projectId
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6w0Dt")).Trigger), {
                    ...triggerProps,
                    count: count,
                    hasFiltersApplied: count > 0,
                    isSelected: isOpen,
                    onClick: toggle
                })
        }));
    });
});
parcelRegister("gAHjC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a65ff6a629adcc26$export$2e2bcd8739ae039);
    const $a65ff6a629adcc26$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v6 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v7 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 16
            }
        ], v8 = [
            {
                "concreteType": "JiraUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3,
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            v2,
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            },
                            v4
                        ]
                    },
                    v5
                ]
            },
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_getArchivedIssuesFilterOptionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraArchivedIssuesFilterOptions",
                                "kind": "LinkedField",
                                "name": "getArchivedIssuesFilterOptions",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueTypeFilter_issueArchivalArchives"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "reporterFilter_issueArchivalArchives"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "archivedByFilter_issueArchivalArchives"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_getArchivedIssuesFilterOptionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraArchivedIssuesFilterOptions",
                                "kind": "LinkedField",
                                "name": "getArchivedIssuesFilterOptions",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 7
                                            }
                                        ],
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueTypeId"
                                                            },
                                                            v2,
                                                            {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                    v3,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "medium"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                "kind": "LinkedField",
                                                                "name": "hierarchy",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "level"
                                                                    },
                                                                    v2
                                                                ]
                                                            },
                                                            v4
                                                        ]
                                                    },
                                                    v5
                                                ]
                                            },
                                            v6
                                        ],
                                        "storageKey": "issueTypes(first:7)"
                                    },
                                    {
                                        "args": v7,
                                        "concreteType": "JiraUserConnection",
                                        "kind": "LinkedField",
                                        "name": "reporters",
                                        "plural": false,
                                        "selections": v8,
                                        "storageKey": "reporters(first:16)"
                                    },
                                    {
                                        "args": v7,
                                        "concreteType": "JiraUserConnection",
                                        "kind": "LinkedField",
                                        "name": "archivedBy",
                                        "plural": false,
                                        "selections": v8,
                                        "storageKey": "archivedBy(first:16)"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b0ed954688ed8e457d933100d3b4e1720e9c4e7f3022b071b7e794744efb2186",
                "metadata": {},
                "name": "main_getArchivedIssuesFilterOptionsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a65ff6a629adcc26$var$node.hash = "b02eec471fa1758425d0f3d68d9a1be0";
    var $a65ff6a629adcc26$export$2e2bcd8739ae039 = $a65ff6a629adcc26$var$node;
});
parcelRegister("2qg13", function(module, exports) {
    $parcel$export(module.exports, "getFilterFieldConfig", ()=>$2ab1bb2bbc704ca3$export$10be1aa6d05cbb70);
    var $j9Nva;
    var $8SmpT;
    var $3LILD;
    var $gH98x;
    const $2ab1bb2bbc704ca3$export$10be1aa6d05cbb70 = ()=>{
        const issueTypes = (0, (0, parcelRequire("3LILD")).issueTypeFields)?.data?.node?.getArchivedIssuesFilterOptions?.issueTypes?.edges;
        const reporters = (0, (0, parcelRequire("gH98x")).reporterFilterOptions)?.data?.node?.getArchivedIssuesFilterOptions?.reporters?.edges;
        const archivedBy = (0, (0, parcelRequire("j9Nva")).archivedByFilterOptions)?.data?.node?.getArchivedIssuesFilterOptions?.archivedBy?.edges;
        const fieldConfig = {};
        const filterFieldsMap = {
            issueType: issueTypes.map((issueType)=>({
                    ...issueType,
                    label: issueType.name,
                    avatar: issueType.avatar.medium,
                    square: true,
                    value: issueType.name,
                    hierarchyLevel: issueType?.hierarchy?.level,
                    id: issueType.issueTypeId
                })),
            reporter: reporters.map((reporter)=>({
                    ...reporter,
                    label: reporter.name,
                    value: reporter.accountId,
                    avatar: reporter.picture
                })),
            archivedBy: archivedBy.map((archivedByNode)=>({
                    ...archivedByNode,
                    label: archivedByNode.name,
                    value: archivedByNode.accountId,
                    avatar: archivedByNode.picture
                }))
        };
        Object.keys((0, (0, parcelRequire("8SmpT")).filterFields)).forEach((field)=>{
            if (filterFieldsMap[field] && (0, (0, parcelRequire("8SmpT")).filterFields)[field]) {
                (0, (0, parcelRequire("8SmpT")).filterFields)[field].options = filterFieldsMap[field];
                fieldConfig[field] = (0, (0, parcelRequire("8SmpT")).filterFields)[field];
            } else fieldConfig[field] = (0, (0, parcelRequire("8SmpT")).filterFields)[field];
        });
        return {
            fieldConfig: fieldConfig
        };
    };
});
parcelRegister("j9Nva", function(module, exports) {
    $parcel$export(module.exports, "archivedByFilterOptions", ()=>$e9e619e6d8b13d31$export$34dc078ecb3cb160);
    const $e9e619e6d8b13d31$export$34dc078ecb3cb160 = {
        data: {
            node: {
                getArchivedIssuesFilterOptions: {
                    projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                    archivedBy: {
                        edges: [
                            {
                                accountId: '7456224230842',
                                name: 'a1',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            },
                            {
                                accountId: '8456225230842',
                                name: 'a2',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            },
                            {
                                accountId: '2456224230840',
                                name: 'a3',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            }
                        ]
                    }
                }
            }
        }
    };
});
parcelRegister("3LILD", function(module, exports) {
    $parcel$export(module.exports, "issueTypeFields", ()=>$2d3e1caf861c6442$export$c05597541d190f45);
    const $2d3e1caf861c6442$export$c05597541d190f45 = {
        data: {
            node: {
                getArchivedIssuesFilterOptions: {
                    projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                    issueTypes: {
                        edges: [
                            {
                                id: 'ari:cloud:jira:28dfbea9-9711-4ee8-8d84-454e910384a9:issue-type/10029',
                                issueTypeId: '10029',
                                name: 'Task',
                                description: 'A small, distinct piece of work.',
                                avatar: {
                                    __typename: 'JiraAvatar',
                                    small: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=small',
                                    medium: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557?size=medium',
                                    large: 'https://suniti.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10557'
                                },
                                avatarId: '10557',
                                hierarchy: {
                                    level: 0,
                                    name: 'Story'
                                }
                            },
                            {
                                issueTypeId: '10006',
                                name: 'Epic',
                                avatar: {
                                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium'
                                }
                            },
                            {
                                issueTypeId: '10004',
                                name: 'Story',
                                avatar: {
                                    medium: 'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium'
                                }
                            }
                        ]
                    }
                }
            }
        }
    };
});
parcelRegister("gH98x", function(module, exports) {
    $parcel$export(module.exports, "reporterFilterOptions", ()=>$a1d490aacfdbefbd$export$79e2d3699b379f83);
    const $a1d490aacfdbefbd$export$79e2d3699b379f83 = {
        data: {
            node: {
                getArchivedIssuesFilterOptions: {
                    projectId: 'ari:cloud:jira:TEST--e16459ae-437f-4e97-8a64-3eec474df71b:project/10001',
                    reporters: {
                        edges: [
                            {
                                accountId: '7456224230842',
                                name: 'a1',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            },
                            {
                                accountId: '8456225230842',
                                name: 'a2',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            },
                            {
                                accountId: '2456224230840',
                                name: 'a3',
                                picture: 'https://secure.gravatar.com/avatar/eefe13ecfcc28010658791ac870922b8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FMS-6.png'
                            },
                            {
                                accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
                                picture: 'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
                                name: 'Rohit Kumar'
                            }
                        ]
                    }
                }
            }
        }
    };
});
parcelRegister("e0AlY", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$6369303d57e7a5c9$export$479f0f2f71193efe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $7B17s;
    var $cc4yx;
    const $6369303d57e7a5c9$var$LazyMenuContent = (0, (0, parcelRequire("7B17s")).lazy)(()=>(parcelRequire("249TO")), {
        moduleId: "./src/packages/issue-archival/archives/src/ui/filter/menu-content/main.tsx"
    });
    const $6369303d57e7a5c9$export$479f0f2f71193efe = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cc4yx")).DropdownWrapper), {
            "data-testid": "issue-archival-archives.ui.filter.menu-content.menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6369303d57e7a5c9$var$LazyMenuContent, props)));
});
parcelRegister("cc4yx", function(module, exports) {
    $parcel$export(module.exports, "DropdownWrapper", ()=>$61ef2aa678c92b92$export$5f7211d21bfdae05);
    $parcel$export(module.exports, "DropdownHeaderWrapper", ()=>$61ef2aa678c92b92$export$e23294aded7a8a49);
    $parcel$export(module.exports, "DropdownHeaderButtons", ()=>$61ef2aa678c92b92$export$53ca7a3701b98335);
    $parcel$export(module.exports, "FiltersListWrapper", ()=>$61ef2aa678c92b92$export$a5a9080bd2c85987);
    $parcel$export(module.exports, "Section", ()=>$61ef2aa678c92b92$export$6e2c8f0811a474ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $61ef2aa678c92b92$var$POPUP_WIDTH = 360;
    const $61ef2aa678c92b92$var$DEFAULT_POPUP_OFFSET_TOP = 215;
    const $61ef2aa678c92b92$var$DROPDOWN_HEADER_HEIGHT = 52;
    const $61ef2aa678c92b92$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
    const $61ef2aa678c92b92$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91gwv",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$6c560fdadeb11d78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1by48d2": (0, (0, parcelRequire("lD23V")).default)(`calc(${__cmplp.offsetTop && __cmplp.offsetTop > $61ef2aa678c92b92$var$DEFAULT_POPUP_OFFSET_TOP ? '95vh' : '85vh'} - ${(__cmplp.offsetTop ?? $61ef2aa678c92b92$var$DEFAULT_POPUP_OFFSET_TOP) + $61ef2aa678c92b92$var$DROPDOWN_HEADER_HEIGHT}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo1wug _18m91wug _ln19p27b _c71l16u6",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$e23294aded7a8a49 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71bhr _2rko1sit _16qsglyw _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$53ca7a3701b98335 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$1a67069896d998b9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8pbhm _x3do13y8",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$a5a9080bd2c85987 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1gwv",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$6e2c8f0811a474ce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulp1cfm _n3td1cfm",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$1faf3c7558df435 = (0, $5uXOq.forwardRef)(({ as: C = $61ef2aa678c92b92$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdidpf _zulpidpf",
                __cmplp.className
            ])
        });
    });
    const $61ef2aa678c92b92$export$c5e20d5e200edfe2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("249TO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("a7U1g")
    ]).then(()=>parcelRequire('d5pHw'));
});
parcelRegister("6w0Dt", function(module, exports) {
    $parcel$export(module.exports, "Trigger", ()=>$ba5abbd553a9e9d6$export$41fb9f06171c75f4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    var $8yQtU;
    var $koVbs;
    var $8K51r;
    const $ba5abbd553a9e9d6$var$FILTER_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8yQtU"))))), {
        label: "",
        size: "small"
    });
    const $ba5abbd553a9e9d6$export$41fb9f06171c75f4 = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, isDisabled: isDisabled, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterMessage = (0, $5uXOq.useMemo)(()=>{
            if (count > 0) return formatMessage((0, (0, parcelRequire("8K51r")).default).filtersCount, {
                filters: count
            });
            if (hasFiltersApplied) return formatMessage((0, (0, parcelRequire("8K51r")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("8K51r")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            ...otherProps,
            ref: ref,
            testId: "issue-archival-archives.ui.filter.trigger.button-wrapper",
            iconBefore: $ba5abbd553a9e9d6$var$FILTER_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle",
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ba5abbd553a9e9d6$var$ButtonContents, null, filterMessage));
    });
    const $ba5abbd553a9e9d6$var$ButtonContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _zulp1b66 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8K51r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa5347e664fc859$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8fa5347e664fc859$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filtersCount: {
            "id": "issue-archival-archives.filter.trigger.filters-count",
            "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
        },
        filterButton: {
            "id": "issue-archival-archives.filter.trigger.filter-button",
            "defaultMessage": "Filter"
        },
        buttonWithFilters: {
            "id": "issue-archival-archives.filter.trigger.button-with-filters",
            "defaultMessage": "Filters applied"
        },
        newLozenge: {
            "id": "issue-archival-archives.filter.trigger.new-lozenge",
            "defaultMessage": "New"
        },
        newLozengeTooltip: {
            "id": "issue-archival-archives.filter.trigger.new-lozenge-tooltip",
            "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
        }
    });
});
parcelRegister("66gBN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65588017188371c7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $cS37j;
    var $koVbs;
    var $fUxEE;
    var $koeKL;
    var $dIdda = parcelRequire("dIdda");
    var $dFiNv;
    var $8TarN;
    const $65588017188371c7$var$ArchiveIssuePageHeader = ({ bottomBar: bottomBar })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectKey = match.params.projectKey || '';
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("fUxEE")).default));
        (0, $5uXOq.useEffect)(()=>{
            loadQuery({
                projectKey: projectKey,
                cloudId: cloudId
            });
        }, [
            loadQuery,
            projectKey,
            cloudId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($65588017188371c7$var$HeaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            breadcrumbs: queryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dFiNv")).ArchiveIssueBreadcrumbs), {
                queryReference: queryReference,
                projectKey: projectKey
            }),
            bottomBar: bottomBar
        }, formatMessage((0, (0, parcelRequire("8TarN")).default).issueArchiveTitle)));
    };
    var $65588017188371c7$export$2e2bcd8739ae039 = $65588017188371c7$var$ArchiveIssuePageHeader;
    const $65588017188371c7$var$HeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41930",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4mGzM;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mGzM")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4mGzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69e894dbadf73bd3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvBlW;
    const $69e894dbadf73bd3$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvBlW")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $69e894dbadf73bd3$export$2e2bcd8739ae039 = $69e894dbadf73bd3$var$PageHeader;
});
parcelRegister("kvBlW", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$f668b39d4b38db17$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$f668b39d4b38db17$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$f668b39d4b38db17$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$f668b39d4b38db17$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$f668b39d4b38db17$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$f668b39d4b38db17$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e65Lk;
    var $ii5wQ;
    function $f668b39d4b38db17$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f668b39d4b38db17$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $f668b39d4b38db17$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $f668b39d4b38db17$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $f668b39d4b38db17$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $f668b39d4b38db17$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $f668b39d4b38db17$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $f668b39d4b38db17$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $f668b39d4b38db17$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $f668b39d4b38db17$var$bottomBarStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $f668b39d4b38db17$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f668b39d4b38db17$var$outerStyles
        }, children);
    };
    const $f668b39d4b38db17$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $f668b39d4b38db17$var$titleStyles,
                truncateTitle && $f668b39d4b38db17$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $f668b39d4b38db17$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $f668b39d4b38db17$var$titleWrapperStyles,
                truncateTitle && $f668b39d4b38db17$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $f668b39d4b38db17$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $f668b39d4b38db17$var$titleContainerStyles,
                truncateTitle && $f668b39d4b38db17$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $f668b39d4b38db17$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f668b39d4b38db17$var$actionStyles
        }, children);
    };
    const $f668b39d4b38db17$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e65Lk")).default), {
            xcss: $f668b39d4b38db17$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("fUxEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c199638182bada1c$export$2e2bcd8739ae039);
    const $c199638182bada1c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v2 = [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "key",
                                "variableName": "projectKey"
                            }
                        ],
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "jiraProjectByKey",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "mainArcivedIssuesProjectNameQuery",
                "selections": v2,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "mainArcivedIssuesProjectNameQuery",
                "selections": v2
            },
            "params": {
                "id": "63145884bb9041214fe3460df121f3c176229f55baa620e32e723f8283d86dee",
                "metadata": {},
                "name": "mainArcivedIssuesProjectNameQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c199638182bada1c$var$node.hash = "7697dc80c1c8d6b9f572e8750cb6c130";
    var $c199638182bada1c$export$2e2bcd8739ae039 = $c199638182bada1c$var$node;
});
parcelRegister("dFiNv", function(module, exports) {
    $parcel$export(module.exports, "ArchiveIssueBreadcrumbs", ()=>$aa366aec4455857c$export$613314e61200a8e8);
    var $fUxEE;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $jS4lj;
    var $gEFwt;
    var $lfTZh;
    var $58lzA;
    const $aa366aec4455857c$export$613314e61200a8e8 = ({ projectKey: projectKey, queryReference: queryReference })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-archive-breadcrumbs",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($aa366aec4455857c$var$BreadcrumbFallback, {
                projectKey: projectKey,
                projectName: ""
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa366aec4455857c$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }));
    const $aa366aec4455857c$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fUxEE")).default), queryReference);
        const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
        const projectId = data?.jira?.jiraProjectByKey?.id ?? '';
        const { setProjectId: setProjectId } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (projectId) setProjectId(projectId);
        }, [
            projectId,
            setProjectId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            projectKey: projectKey,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null)));
    };
    const $aa366aec4455857c$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            projectKey: projectKey,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null));
});
parcelRegister("8TarN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a9d6d8670579ff9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7a9d6d8670579ff9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueArchiveTitle: {
            "id": "issue-archival-archives.header.issue-archive-title",
            "defaultMessage": "Archived issues"
        }
    });
});
parcelRegister("8TTKp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9df795353a6d43d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $h0leX;
    var $3ZuB3;
    var $koeKL;
    var $dIdda = parcelRequire("dIdda");
    var $36OOP;
    var $58lzA;
    var $84j7q;
    var $i3soF;
    const $9df795353a6d43d5$var$Archives = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("h0leX")).default));
        const [projectKey] = (0, $dIdda.usePathParam)('projectKey');
        const { filters: filters, currentPage: currentPage, searchBy: searchBy, refetchArchivesIssuesData: refetchArchivesIssuesData } = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const { setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const selectedIssueTypes = (0, $5uXOq.useMemo)(()=>filters?.issueType?.map((issueType)=>({
                    issueTypeId: issueType?.id || ''
                })) || [], [
            filters
        ]);
        const selectedReporters = (0, $5uXOq.useMemo)(()=>filters?.reporter?.map((reporter)=>`ari:cloud:identity::user/${reporter.value}`) || [], [
            filters
        ]);
        const selectedArchivedBy = (0, $5uXOq.useMemo)(()=>filters?.archivedBy?.map((archivedBy)=>`ari:cloud:identity::user/${archivedBy.value}`) || [], [
            filters
        ]);
        const archivalDateRange = (0, $5uXOq.useMemo)(()=>filters?.archivedDate?.value || {}, [
            filters
        ]);
        const first = currentPage * (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE);
        const last = (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE);
        const fetchData = (0, $5uXOq.useCallback)(()=>{
            if (projectKey && cloudId) loadQuery({
                projectKey: projectKey,
                cloudId: cloudId,
                selectedIssueTypes: selectedIssueTypes,
                selectedArchivedBy: selectedArchivedBy,
                selectedReporters: selectedReporters,
                archivalDateRange: archivalDateRange,
                first: first,
                last: last,
                searchBy: searchBy
            }, {
                fetchPolicy: 'network-only'
            });
        }, [
            archivalDateRange,
            cloudId,
            first,
            last,
            loadQuery,
            projectKey,
            searchBy,
            selectedArchivedBy,
            selectedIssueTypes,
            selectedReporters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (refetchArchivesIssuesData) setRefetchArchivesIssuesData(false);
            fetchData();
        }, [
            fetchData,
            refetchArchivesIssuesData,
            setRefetchArchivesIssuesData
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "archives-main",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ZuB3")).NativeIssueTableSkeleton), null)
        }, queryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i3soF")).ArchivesTable), {
            queryReference: queryReference
        }));
    };
    var $9df795353a6d43d5$export$2e2bcd8739ae039 = $9df795353a6d43d5$var$Archives;
});
parcelRegister("h0leX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6161ea397b9463be$export$2e2bcd8739ae039);
    const $6161ea397b9463be$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "archivalDateRange"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchBy"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedArchivedBy"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedIssueTypes"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedReporters"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9,
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "byArchivalDateRange",
                        "variableName": "archivalDateRange"
                    },
                    {
                        "kind": "Variable",
                        "name": "byArchivedBy",
                        "variableName": "selectedArchivedBy"
                    },
                    {
                        "kind": "Variable",
                        "name": "byIssueType",
                        "variableName": "selectedIssueTypes"
                    },
                    {
                        "kind": "Variable",
                        "name": "byProject",
                        "variableName": "projectKey"
                    },
                    {
                        "kind": "Variable",
                        "name": "byReporter",
                        "variableName": "selectedReporters"
                    }
                ],
                "kind": "ObjectValue",
                "name": "filterBy"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            {
                "kind": "Variable",
                "name": "last",
                "variableName": "last"
            },
            {
                "kind": "Variable",
                "name": "searchBy",
                "variableName": "searchBy"
            }
        ], v11 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v12 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v13 = {
            "kind": "ScalarField",
            "name": "key"
        }, v14 = {
            "kind": "ScalarField",
            "name": "name"
        }, v15 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "medium"
                }
            ]
        }, v16 = {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchy",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "level"
                }
            ]
        }, v17 = {
            "kind": "ScalarField",
            "name": "id"
        }, v18 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v19 = [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "reporter"
                ]
            }
        ], v20 = {
            "kind": "ScalarField",
            "name": "archivedOn"
        }, v21 = {
            "kind": "ScalarField",
            "name": "text"
        }, v22 = {
            "alias": "unarchiveIssuePermission",
            "args": [
                v9,
                {
                    "kind": "Literal",
                    "name": "permission",
                    "value": "UNARCHIVE_ISSUES"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                }
            ],
            "kind": "ScalarField",
            "name": "hasProjectPermission"
        }, v23 = {
            "kind": "ScalarField",
            "name": "__typename"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8
                ],
                "kind": "Fragment",
                "name": "main_getArchivedIssuesForProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "getArchivedIssuesForProject",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v12,
                                                    v13,
                                                    {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v14,
                                                                    v15,
                                                                    v16
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "archivedBy",
                                                        "plural": false,
                                                        "selections": [
                                                            v17,
                                                            v18,
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "args": v19,
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "user",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v17,
                                                                                            v14,
                                                                                            v18
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"reporter\"])"
                                                    },
                                                    v20,
                                                    {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                            v21
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v22
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v4,
                    v1,
                    v7,
                    v8,
                    v0,
                    v6,
                    v5,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "main_getArchivedIssuesForProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "getArchivedIssuesForProject",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v12,
                                                    v13,
                                                    {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v14,
                                                                    v15,
                                                                    v16,
                                                                    v17
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "archivedBy",
                                                        "plural": false,
                                                        "selections": [
                                                            v23,
                                                            v17,
                                                            v18,
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "args": v19,
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v23,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "user",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v23,
                                                                                            v17,
                                                                                            v14,
                                                                                            v18
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"reporter\"])"
                                                    },
                                                    v20,
                                                    {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                            v21,
                                                            v17
                                                        ]
                                                    },
                                                    v17
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v22
                        ]
                    }
                ]
            },
            "params": {
                "id": "2cdf282128aedbae37919f8086e582b2f8228a0c742a9c35de5a5b789174c666",
                "metadata": {},
                "name": "main_getArchivedIssuesForProjectQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6161ea397b9463be$var$node.hash = "057ef912015668de758a06351fea8bcf";
    var $6161ea397b9463be$export$2e2bcd8739ae039 = $6161ea397b9463be$var$node;
});
parcelRegister("3ZuB3", function(module, exports) {
    $parcel$export(module.exports, "NativeIssueTableSkeleton", ()=>$7ccc2556c713810d$export$309a6db85e3f2aaa);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $8g71g = parcelRequire("8g71g");
    const $7ccc2556c713810d$var$customCssStyles = null;
    const $7ccc2556c713810d$var$containerStyles = {
        height: '448px'
    };
    const $7ccc2556c713810d$export$309a6db85e3f2aaa = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8g71g))),
            containerStyles: $7ccc2556c713810d$var$containerStyles,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("8g71g", function(module, exports) {
    module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();
});
parcelRegister("i3soF", function(module, exports) {
    $parcel$export(module.exports, "ArchivesTable", ()=>$9c8cfae789198c6d$export$a7e6298ee2d38c94);
    var $h0leX;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $95Dhy;
    var $e65Lk;
    var $ii5wQ;
    var $39xOx;
    var $koVbs;
    var $l8ruj;
    var $36OOP;
    var $58lzA;
    var $84j7q;
    var $2jUmR;
    var $eO28v;
    var $cx42O;
    var $4tKWn;
    var $7fCBi;
    var $lKBOQ;
    var $jcy2W;
    var $au3pr;
    var $5CSl3;
    var $cURsR;
    const $9c8cfae789198c6d$export$a7e6298ee2d38c94 = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const state = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const { setIssuesInCurrentPage: setIssuesInCurrentPage, setArchivesIssueDataPresent: setArchivesIssueDataPresent, updateIssueDetails: updateIssueDetails } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const isLoading = (0, (0, parcelRequire("84j7q")).getLoadingState)({
            state: state
        });
        const currentPage = (0, (0, parcelRequire("84j7q")).getCurrentPage)({
            state: state
        });
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("h0leX")).default), queryReference);
        const unarchiveIssuePermission = data?.jira?.unarchiveIssuePermission || false;
        const head = (0, (0, parcelRequire("cx42O")).default)(unarchiveIssuePermission);
        const rows = data?.jira?.getArchivedIssuesForProject?.edges?.map((issueNode)=>{
            const issue = issueNode?.node;
            const issueId = issue?.issueId?.toString() ?? '';
            const reporter = issue?.fieldsById?.edges?.[0]?.node?.user;
            const shouldHighlightRow = (0, (0, parcelRequire("84j7q")).isIssueSelected)({
                state: state,
                pageNumber: currentPage,
                issueId: issueId
            });
            const issueTypeName = issue?.issueTypeField?.issueType?.name ?? '';
            const hierarchyLevel = issue?.issueTypeField?.issueType?.hierarchy?.level ?? 0;
            const selectCell = unarchiveIssuePermission && [
                {
                    key: `select-${issueId}`,
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcy2W")).SelectCell), {
                        isChecked: shouldHighlightRow,
                        isDisabled: hierarchyLevel === -1,
                        issueId: issueId ?? '',
                        pageNumber: currentPage
                    })
                }
            ] || [];
            return {
                key: issueId,
                cells: [
                    ...selectCell,
                    {
                        key: `type-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CSl3")).TypeCell), {
                            iconUrl: issue?.issueTypeField?.issueType?.avatar?.medium ?? '',
                            name: issueTypeName
                        })
                    },
                    {
                        key: `key-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lKBOQ")).KeyCell), {
                            issueKey: issue?.key ?? ''
                        })
                    },
                    {
                        key: `summary-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("au3pr")).TextCell), {
                            text: issue?.summaryField?.text ?? ''
                        })
                    },
                    {
                        key: `reporter-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cURsR")).UserCell), {
                            user: {
                                id: reporter?.id || '',
                                name: reporter?.name || '',
                                avatarUrl: reporter?.picture || ''
                            }
                        })
                    },
                    {
                        key: `archivedDate-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7fCBi")).default), {
                            archivedDate: issue?.archivedOn ?? ''
                        })
                    },
                    {
                        key: `archviedBy-${issueId}`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cURsR")).UserCell), {
                            user: {
                                id: issue?.archivedBy?.id || '',
                                name: issue?.archivedBy?.name || '',
                                avatarUrl: issue?.archivedBy?.picture || ''
                            }
                        })
                    }
                ],
                testId: `issue-archival-archives.archives-table.row-${issueId}`
            };
        }) || [];
        (0, $5uXOq.useEffect)(()=>{
            const issuesInCurrentPage = [];
            const issuesDetails = {};
            data?.jira?.getArchivedIssuesForProject?.edges?.forEach((issueNode)=>{
                const issue = issueNode?.node;
                const issueId = issueNode?.node?.issueId?.toString() ?? '';
                const issueKey = issue?.key?.toString() ?? '';
                const hierarchyLevel = issue?.issueTypeField?.issueType?.hierarchy?.level ?? 0;
                if (hierarchyLevel !== -1) issuesInCurrentPage.push(issueId);
                issuesDetails[issueId] = {
                    issueId: issueId,
                    issueKey: issueKey,
                    hierarchyLevel: hierarchyLevel
                };
            });
            if (issuesInCurrentPage.length > 0) {
                setIssuesInCurrentPage(issuesInCurrentPage);
                updateIssueDetails(issuesDetails);
            }
        }, [
            setIssuesInCurrentPage,
            updateIssueDetails,
            data
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!state.refetchArchivesIssuesData && rows?.length === 0 && Object.keys(state.filters).length === 0 && state.searchBy === '') setArchivesIssueDataPresent(false);
        }, [
            rows?.length,
            setArchivesIssueDataPresent,
            state.filters,
            state.refetchArchivesIssuesData,
            state.searchBy
        ]);
        const totalIssueCount = data?.jira?.getArchivedIssuesForProject?.totalCount ?? 0;
        const firstIssuePosition = totalIssueCount ? 1 + (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE) * (currentPage - 1) : totalIssueCount;
        const lastIssuePosition = (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE) * currentPage > totalIssueCount ? totalIssueCount : (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE) * currentPage;
        const countRendererData = {
            issueNavigatorPageInfo: {
                firstIssuePosition: firstIssuePosition,
                lastIssuePosition: lastIssuePosition
            },
            totalIssueSearchResultCount: totalIssueCount
        };
        const totalPages = Math.ceil(totalIssueCount / (0, (0, parcelRequire("36OOP")).NUMBER_OF_ISSUES_PER_PAGE));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "issue-view-archived-issues-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "issue.issue-view.activity.archived-issues-table",
            packageName: "jiraArchivedIssues",
            teamName: "kenji",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9c8cfae789198c6d$var$BorderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo1wug _18m91wug _c71ln9zg _19itzgxb _13liu2gc _qrwqu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: $9c8cfae789198c6d$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95Dhy")).default), {
            isLoading: isLoading,
            head: head,
            rows: rows,
            isFixedSize: true,
            label: formatMessage((0, (0, parcelRequire("4tKWn")).default).archivesTableLabel),
            loadingLabel: formatMessage((0, (0, parcelRequire("4tKWn")).default).loadingArchivesTableLabel),
            testId: (0, (0, parcelRequire("36OOP")).ARCHIVES_TABLE_TEST_ID)
        })), !rows || rows.length === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2jUmR")).ArchivesTableEmptyState), null) : null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eO28v")).FooterRenderer), {
            currentPage: currentPage,
            totalPages: totalPages,
            countRendererData: countRendererData
        }))));
    };
    const $9c8cfae789198c6d$var$BorderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _1lmscfaq _1akgglyw _1ik0glyw _jznw1pfj _1b4t1pfj _1rg5cfaq _1l74cfaq _8k75nkob _10wbnkob _cnoh1oud _gstti7a9 _1j52i8ux _opvxel4l _ye9xglyw _fw9p1if8 _7oeaidpf _1h3evuon _1qlckb7n _19zk17ej _823bu2gc _1td7u2gc _15r0glyw _im2gglyw _ihu1u2gc _8o61u2gc _mgodu2gc _1ydjglyw _i38zglyw",
                __cmplp.className
            ])
        });
    });
    const $9c8cfae789198c6d$var$overflowStyles = null;
    const $9c8cfae789198c6d$var$wrapperStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        maxHeight: '75vh',
        width: '100%',
        minWidth: '1120px',
        marginBottom: 'space.negative.300'
    });
});
parcelRegister("95Dhy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c41c872638d4d646$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $13czV;
    var $lIXTq;
    var $l2Gdt;
    class $c41c872638d4d646$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("13czV")).default),
                onSort: (0, (0, parcelRequire("13czV")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l2Gdt")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            };
            this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            };
            this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            };
            this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            };
            this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("lIXTq")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("lIXTq", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$77390f0cb3c25144$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$77390f0cb3c25144$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$77390f0cb3c25144$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$77390f0cb3c25144$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$77390f0cb3c25144$export$c476bbe5da59992d);
    const $77390f0cb3c25144$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $77390f0cb3c25144$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $77390f0cb3c25144$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $77390f0cb3c25144$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $77390f0cb3c25144$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $77390f0cb3c25144$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $77390f0cb3c25144$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $77390f0cb3c25144$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("l2Gdt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$452fe922f8cbd26c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7UFJi;
    var $13czV;
    var $lIXTq;
    var $hI2AC;
    var $9yvNW;
    var $3IpUs;
    var $6s0eM;
    var $i3lbJ;
    var $iiVsX;
    var $bkohW;
    var $lNlei;
    function $452fe922f8cbd26c$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $317a2796b868ae26$export$b6abcf7fa1d94f65:
                return 0, $317a2796b868ae26$export$1dee026a19752d6b;
            case 0, $317a2796b868ae26$export$1dee026a19752d6b:
                return 0, $317a2796b868ae26$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $452fe922f8cbd26c$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("13czV")).default), onSort: providedOnSort = (0, (0, parcelRequire("13czV")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("13czV")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("13czV")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("lIXTq")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("lIXTq")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $317a2796b868ae26$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $317a2796b868ae26$export$1dee026a19752d6b) : $452fe922f8cbd26c$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("lIXTq")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $317a2796b868ae26$export$7b93a10c0fefe3e3) : (0, $317a2796b868ae26$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yvNW")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yvNW")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iiVsX")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hI2AC")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hI2AC")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lNlei")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($452fe922f8cbd26c$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hI2AC")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bkohW")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i3lbJ")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $317a2796b868ae26$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $452fe922f8cbd26c$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("4oceU")));
    const $452fe922f8cbd26c$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IpUs")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6s0eM")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($452fe922f8cbd26c$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $452fe922f8cbd26c$export$2e2bcd8739ae039 = $452fe922f8cbd26c$var$DynamicTable;
});
const $317a2796b868ae26$export$1dee026a19752d6b = 'ASC';
const $317a2796b868ae26$export$b6abcf7fa1d94f65 = 'DESC';
const $317a2796b868ae26$export$71dd4c8ecd45e95f = 'small';
const $317a2796b868ae26$export$7b93a10c0fefe3e3 = 'large';
const $317a2796b868ae26$export$3843c586a90b9cbf = 0.22;
parcelRegister("hI2AC", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$11ee2fc874769936$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$11ee2fc874769936$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$11ee2fc874769936$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$11ee2fc874769936$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hee8U;
    function $11ee2fc874769936$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $11ee2fc874769936$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $11ee2fc874769936$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $11ee2fc874769936$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $11ee2fc874769936$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("hee8U")).tableBorder).borderColor}`
    });
    const $11ee2fc874769936$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$11ee2fc874769936$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("hee8U")).row).hoverBackground,
                [$11ee2fc874769936$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("hee8U")).row).highlightedBackground,
                [$11ee2fc874769936$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("hee8U")).row).hoverHighlightedBackground,
                [$11ee2fc874769936$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("hee8U")).row).focusOutline
            },
            css: [
                $11ee2fc874769936$var$tableStyles,
                isFixedSize && $11ee2fc874769936$var$fixedSizeTableStyles,
                hasDataRow && $11ee2fc874769936$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $11ee2fc874769936$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $11ee2fc874769936$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $11ee2fc874769936$var$captionStyles
        }, children);
    const $11ee2fc874769936$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $11ee2fc874769936$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $11ee2fc874769936$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("hee8U", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$7b8d37611e048be1$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$7b8d37611e048be1$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$7b8d37611e048be1$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$7b8d37611e048be1$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$7b8d37611e048be1$export$38d703b73e2cf64d);
    const $7b8d37611e048be1$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $7b8d37611e048be1$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$dbda9f692ace54dd$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$dbda9f692ace54dd$export$e2ef2124cf4024b1})`
    };
    const $7b8d37611e048be1$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$dbda9f692ace54dd$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$dbda9f692ace54dd$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$dbda9f692ace54dd$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$dbda9f692ace54dd$export$8c13c2ee36917869})`
    };
    const $7b8d37611e048be1$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$dbda9f692ace54dd$export$e2ef2124cf4024b1})`
    };
    const $7b8d37611e048be1$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$dbda9f692ace54dd$export$1ce2d1575d444ceb})`
    };
});
var $dbda9f692ace54dd$exports = {};
$parcel$export($dbda9f692ace54dd$exports, "R50", ()=>$dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", ()=>$dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", ()=>$dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", ()=>$dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", ()=>$dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", ()=>$dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", ()=>$dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", ()=>$dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", ()=>$dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", ()=>$dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", ()=>$dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", ()=>$dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", ()=>$dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", ()=>$dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", ()=>$dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", ()=>$dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", ()=>$dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", ()=>$dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", ()=>$dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", ()=>$dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", ()=>$dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", ()=>$dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", ()=>$dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", ()=>$dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", ()=>$dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", ()=>$dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", ()=>$dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", ()=>$dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", ()=>$dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", ()=>$dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", ()=>$dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", ()=>$dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", ()=>$dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", ()=>$dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", ()=>$dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", ()=>$dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", ()=>$dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", ()=>$dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", ()=>$dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", ()=>$dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", ()=>$dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", ()=>$dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", ()=>$dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", ()=>$dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", ()=>$dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", ()=>$dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", ()=>$dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", ()=>$dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", ()=>$dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", ()=>$dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", ()=>$dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", ()=>$dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", ()=>$dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", ()=>$dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", ()=>$dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", ()=>$dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", ()=>$dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", ()=>$dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", ()=>$dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", ()=>$dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", ()=>$dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", ()=>$dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", ()=>$dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", ()=>$dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", ()=>$dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", ()=>$dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", ()=>$dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", ()=>$dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", ()=>$dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", ()=>$dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", ()=>$dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", ()=>$dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", ()=>$dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", ()=>$dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", ()=>$dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", ()=>$dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", ()=>$dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", ()=>$dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", ()=>$dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", ()=>$dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", ()=>$dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", ()=>$dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", ()=>$dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", ()=>$dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", ()=>$dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", ()=>$dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", ()=>$dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", ()=>$dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", ()=>$dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", ()=>$dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", ()=>$dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", ()=>$dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", ()=>$dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", ()=>$dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", ()=>$dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", ()=>$dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", ()=>$dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", ()=>$dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", ()=>$dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", ()=>$dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", ()=>$dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", ()=>$dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", ()=>$dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", ()=>$dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", ()=>$dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", ()=>$dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", ()=>$dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", ()=>$dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", ()=>$dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", ()=>$dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", ()=>$dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", ()=>$dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", ()=>$dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", ()=>$dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", ()=>$dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", ()=>$dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", ()=>$dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", ()=>$dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", ()=>$dbda9f692ace54dd$export$95e26d54def96891);
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';
parcelRegister("9yvNW", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$d3342b3c795a2fd1$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$d3342b3c795a2fd1$export$381ea436de119582);
    var $f8Sb3;
    function $d3342b3c795a2fd1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d3342b3c795a2fd1$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $d3342b3c795a2fd1$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d3342b3c795a2fd1$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $d3342b3c795a2fd1$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $d3342b3c795a2fd1$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d3342b3c795a2fd1$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("3IpUs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4536e6170b2a0224$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Q1fk;
    var $1QN1a;
    class $4536e6170b2a0224$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QN1a")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $4536e6170b2a0224$var$Body = (0, (0, parcelRequire("7Q1fk")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4536e6170b2a0224$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $4536e6170b2a0224$export$2e2bcd8739ae039 = $4536e6170b2a0224$var$Body;
});
parcelRegister("7Q1fk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bca0c2030d19a09$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lIXTq;
    const $0bca0c2030d19a09$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $0bca0c2030d19a09$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $317a2796b868ae26$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $0bca0c2030d19a09$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $0bca0c2030d19a09$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $0bca0c2030d19a09$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("lIXTq")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $0bca0c2030d19a09$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("lIXTq")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("1QN1a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6dcc7222fa83382$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6cT2k;
    var $XYaDy;
    const $e6dcc7222fa83382$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("XYaDy")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6cT2k")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $e6dcc7222fa83382$export$2e2bcd8739ae039 = $e6dcc7222fa83382$var$Row;
});
parcelRegister("6cT2k", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$c1588971be729889$export$948e91fcef170792);
    var $f8Sb3;
    var $hFqqY;
    const $c1588971be729889$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("hFqqY")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("hFqqY")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("hFqqY")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("hFqqY")).overflowTruncateStyles),
                (0, (0, parcelRequire("hFqqY")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("hFqqY", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$cc720e1e3f816832$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$cc720e1e3f816832$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$cc720e1e3f816832$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$cc720e1e3f816832$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$cc720e1e3f816832$export$f7913df521f684e2);
    var $f8Sb3;
    function $cc720e1e3f816832$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $cc720e1e3f816832$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $cc720e1e3f816832$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$cc720e1e3f816832$var$CSS_VAR_WIDTH})`
    });
    const $cc720e1e3f816832$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $cc720e1e3f816832$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $cc720e1e3f816832$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$cc720e1e3f816832$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $cc720e1e3f816832$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("XYaDy", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$a83b05ff7ad6b287$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hI2AC;
    const $a83b05ff7ad6b287$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hI2AC")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $a83b05ff7ad6b287$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hI2AC")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $a83b05ff7ad6b287$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hI2AC")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hI2AC")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $a83b05ff7ad6b287$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $a83b05ff7ad6b287$var$rowStyles,
                isHighlighted ? $a83b05ff7ad6b287$var$rowHighlightedBackgroundStyles : $a83b05ff7ad6b287$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("6s0eM", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$ff1d12dbaa121406$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $ff1d12dbaa121406$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("i3lbJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c7af671ee864a1e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dyckQ;
    var $dVS8c;
    class $8c7af671ee864a1e$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $317a2796b868ae26$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $317a2796b868ae26$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVS8c")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVS8c")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVS8c")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dyckQ")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("dVS8c", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$119555e026ae3211$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$119555e026ae3211$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$119555e026ae3211$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $119555e026ae3211$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $119555e026ae3211$export$c335a80381ec61f5 = '--contents-opacity';
    const $119555e026ae3211$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $119555e026ae3211$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $119555e026ae3211$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $119555e026ae3211$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$119555e026ae3211$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $119555e026ae3211$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$119555e026ae3211$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $119555e026ae3211$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $119555e026ae3211$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $119555e026ae3211$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $119555e026ae3211$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("iiVsX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70312dc36e2a1a61$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dyckQ;
    var $eFjHK;
    class $70312dc36e2a1a61$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $317a2796b868ae26$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $317a2796b868ae26$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eFjHK")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eFjHK")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eFjHK")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dyckQ")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("eFjHK", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$0e20abeb933988ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$0e20abeb933988ad$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$0e20abeb933988ad$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $0e20abeb933988ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0e20abeb933988ad$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $0e20abeb933988ad$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0e20abeb933988ad$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $0e20abeb933988ad$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $0e20abeb933988ad$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0e20abeb933988ad$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $0e20abeb933988ad$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $0e20abeb933988ad$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0e20abeb933988ad$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("bkohW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c14a3c2beee38e9e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cGXGk;
    class $c14a3c2beee38e9e$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cGXGk")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("cGXGk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3346d942fc973e89$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7UFJi;
    var $13czV;
    var $aJhcs;
    var $fcdd5;
    var $eXAaW;
    var $e65Lk;
    var $48zIy;
    var $ii5wQ;
    var $ljOBK;
    var $fnzWf;
    var $1k8Xf;
    var $lejA1;
    var $cwVe3;
    const $3346d942fc973e89$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3346d942fc973e89$var$paginationMenuStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $3346d942fc973e89$var$paginationMenuItemStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $3346d942fc973e89$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        paddingInline: 'space.075'
    });
    function $3346d942fc973e89$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fcdd5"))))) : (0, ($parcel$interopDefault((0, parcelRequire("eXAaW")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            as: "span",
            xcss: $3346d942fc973e89$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $3346d942fc973e89$var$InnerPagination({ components: components = (0, (0, parcelRequire("lejA1")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("lejA1")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("13czV")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("1k8Xf")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("aJhcs")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$3346d942fc973e89$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("48zIy")).default), {
                as: "li",
                xcss: $3346d942fc973e89$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fnzWf")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("48zIy")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljOBK")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($3346d942fc973e89$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("48zIy")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $3346d942fc973e89$var$paginationMenuStyles
        }, (0, (0, parcelRequire("cwVe3")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljOBK")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($3346d942fc973e89$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $3346d942fc973e89$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($3346d942fc973e89$var$InnerPagination));
    var $3346d942fc973e89$export$2e2bcd8739ae039 = $3346d942fc973e89$var$Pagination;
});
parcelRegister("fcdd5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b102393f182a79a0$var$_react = $b102393f182a79a0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b102393f182a79a0$var$_chevronLeft = $b102393f182a79a0$var$_interopRequireDefault((parcelRequire("l8fXA")));
    var $b102393f182a79a0$var$_chevronLeftLarge = $b102393f182a79a0$var$_interopRequireDefault((parcelRequire("h3fex")));
    function $b102393f182a79a0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b102393f182a79a0$var$ChevronLeftIcon = (props)=>$b102393f182a79a0$var$_react.default.createElement($b102393f182a79a0$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b102393f182a79a0$var$_chevronLeftLarge.default
        }, props));
    $b102393f182a79a0$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b102393f182a79a0$var$_default = module.exports.default = $b102393f182a79a0$var$ChevronLeftIcon;
});
parcelRegister("l8fXA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f626b9abd78d20cb$var$_react = $f626b9abd78d20cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f626b9abd78d20cb$var$_UNSAFE_baseNew = $f626b9abd78d20cb$var$_interopRequireDefault((parcelRequire("9ogAd")));
    function $f626b9abd78d20cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f626b9abd78d20cb$var$ChevronLeftIcon = (props)=>$f626b9abd78d20cb$var$_react.default.createElement($f626b9abd78d20cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $f626b9abd78d20cb$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $f626b9abd78d20cb$var$_default = module.exports.default = $f626b9abd78d20cb$var$ChevronLeftIcon;
});
parcelRegister("h3fex", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c69e888f0955f066$var$_react = $c69e888f0955f066$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $hD6Dj;
    var $c69e888f0955f066$var$_chevronLeft = $c69e888f0955f066$var$_interopRequireDefault((parcelRequire("l8fXA")));
    function $c69e888f0955f066$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c69e888f0955f066$var$ChevronLeftLargeIcon = (props)=>$c69e888f0955f066$var$_react.default.createElement((0, parcelRequire("hD6Dj")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $c69e888f0955f066$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $c69e888f0955f066$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $c69e888f0955f066$var$_default = module.exports.default = $c69e888f0955f066$var$ChevronLeftLargeIcon;
});
parcelRegister("eXAaW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ae42a3100731a182$var$_react = $ae42a3100731a182$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ae42a3100731a182$var$_chevronRight = $ae42a3100731a182$var$_interopRequireDefault((parcelRequire("hOMSp")));
    var $ae42a3100731a182$var$_chevronRightLarge = $ae42a3100731a182$var$_interopRequireDefault((parcelRequire("77vXR")));
    function $ae42a3100731a182$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ae42a3100731a182$var$ChevronRightIcon = (props)=>$ae42a3100731a182$var$_react.default.createElement($ae42a3100731a182$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $ae42a3100731a182$var$_chevronRightLarge.default
        }, props));
    $ae42a3100731a182$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $ae42a3100731a182$var$_default = module.exports.default = $ae42a3100731a182$var$ChevronRightIcon;
});
parcelRegister("77vXR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $01567bcbbca9056e$var$_react = $01567bcbbca9056e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $hD6Dj;
    var $01567bcbbca9056e$var$_chevronRight = $01567bcbbca9056e$var$_interopRequireDefault((parcelRequire("hOMSp")));
    function $01567bcbbca9056e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $01567bcbbca9056e$var$ChevronRightLargeIcon = (props)=>$01567bcbbca9056e$var$_react.default.createElement((0, parcelRequire("hD6Dj")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $01567bcbbca9056e$var$_chevronRight.default,
            iconType: "utility"
        }));
    $01567bcbbca9056e$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $01567bcbbca9056e$var$_default = module.exports.default = $01567bcbbca9056e$var$ChevronRightLargeIcon;
});
parcelRegister("ljOBK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7d3f6773dd94464$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    function $b7d3f6773dd94464$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("fnzWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ef62650f8e63dea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    function $7ef62650f8e63dea$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("1k8Xf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$446699de01cc995a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e65Lk;
    var $2zROn;
    var $ii5wQ;
    var $8iEvh;
    const $446699de01cc995a$var$containerStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $446699de01cc995a$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $446699de01cc995a$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2zROn")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8iEvh")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("lejA1", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$4b255bfebb585832$export$3f860eba1218f8d3);
    const $4b255bfebb585832$export$3f860eba1218f8d3 = {};
});
parcelRegister("cwVe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$324038e2d6560f3c$export$2e2bcd8739ae039);
    var $8QpSo;
    const $324038e2d6560f3c$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $324038e2d6560f3c$export$2e2bcd8739ae039 = $324038e2d6560f3c$var$collapseRange;
});
parcelRegister("lNlei", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eed14cb6e1c83d35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lIXTq;
    var $kMcw0;
    var $a9z8M;
    var $j3i4o;
    class $eed14cb6e1c83d35$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("lIXTq")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("lIXTq")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a9z8M")).default) : (0, (0, parcelRequire("j3i4o")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kMcw0")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $eed14cb6e1c83d35$export$2e2bcd8739ae039 = $eed14cb6e1c83d35$var$TableHead;
});
parcelRegister("kMcw0", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$2a52e87b94a99231$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$2a52e87b94a99231$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hee8U;
    var $hFqqY;
    function $2a52e87b94a99231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2a52e87b94a99231$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $2a52e87b94a99231$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $2a52e87b94a99231$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $2a52e87b94a99231$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $2a52e87b94a99231$var$headStyles,
                isRanking && $2a52e87b94a99231$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $2a52e87b94a99231$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("hee8U")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$2a52e87b94a99231$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $2a52e87b94a99231$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $dbda9f692ace54dd$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $2a52e87b94a99231$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("hee8U")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("hee8U")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("hee8U")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("hee8U")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("hee8U")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $2a52e87b94a99231$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("hee8U")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("hee8U")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $2a52e87b94a99231$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("hee8U")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("hee8U")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $2a52e87b94a99231$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("hFqqY")).getTruncationStyleVars)({
                width: width
            }),
            [$2a52e87b94a99231$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("hee8U")).head).textColor
        };
        const isASC = sortOrder === (0, $317a2796b868ae26$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $317a2796b868ae26$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("hFqqY")).cellStyles),
                $2a52e87b94a99231$var$headCellBaseStyles,
                onClick && $2a52e87b94a99231$var$onClickStyles,
                (0, (0, parcelRequire("hFqqY")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("hFqqY")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("hFqqY")).overflowTruncateStyles),
                isSortable && $2a52e87b94a99231$var$baseStyles,
                isASC && $2a52e87b94a99231$var$ascendingStyles,
                isDESC && $2a52e87b94a99231$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a9z8M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$214fc45fa8bc14a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3Stfv;
    var $lIXTq;
    var $j3i4o;
    class $214fc45fa8bc14a6$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("lIXTq")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3i4o")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $214fc45fa8bc14a6$var$RankableTableHeadCell = (0, (0, parcelRequire("3Stfv")).default)($214fc45fa8bc14a6$var$RankableTableHeadCellComponent);
    var $214fc45fa8bc14a6$export$2e2bcd8739ae039 = $214fc45fa8bc14a6$var$RankableTableHeadCell;
});
parcelRegister("3Stfv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47404b780a48184b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $47404b780a48184b$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("j3i4o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9e865e2a82fa492$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kMcw0;
    const $d9e865e2a82fa492$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kMcw0")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9e865e2a82fa492$export$2e2bcd8739ae039 = $d9e865e2a82fa492$var$TableHeadCell;
});
parcelRegister("4oceU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7egJV")
    ]).then(()=>parcelRequire('8LsuZ'));
});
parcelRegister("eO28v", function(module, exports) {
    $parcel$export(module.exports, "FooterRenderer", ()=>$c5905138f5e0f654$export$806a4619165e1410);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3OuGz;
    var $9pH03;
    const $c5905138f5e0f654$export$806a4619165e1410 = ({ currentPage: currentPage, totalPages: totalPages, countRendererData: countRendererData })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c5905138f5e0f654$var$FooterContainer, {
            "data-testid": "issue-archival-archives.ui.archives-table.footer-renderer.footer-container"
        }, $c5905138f5e0f654$var$SpacerElement, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OuGz")).default), {
            issueNavigatorPageInfo: countRendererData.issueNavigatorPageInfo,
            totalIssueSearchResultCount: countRendererData.totalIssueSearchResultCount
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pH03")).PaginationControls), {
            currentPage: currentPage,
            totalPages: totalPages
        }));
    const $c5905138f5e0f654$var$FooterContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _1yt4xtwq _19ith6cr _mrkbu2gc _1o0zu2gc _x3doglyw",
                __cmplp.className
            ])
        });
    });
    const $c5905138f5e0f654$export$d7a54cba636a8cd6 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $c5905138f5e0f654$var$SpacerElement = (0, ($parcel$interopDefault($5uXOq))).createElement($c5905138f5e0f654$export$d7a54cba636a8cd6, null);
});
parcelRegister("3OuGz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e423a73503b2d0eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g1v4z;
    const $e423a73503b2d0eb$var$IssueCountRenderer = ({ issueNavigatorPageInfo: issueNavigatorPageInfo, totalIssueSearchResultCount: totalIssueSearchResultCount })=>{
        const startIssueRange = issueNavigatorPageInfo?.firstIssuePosition ?? 0;
        const endIssueRange = issueNavigatorPageInfo?.lastIssuePosition ?? 0;
        const total = totalIssueSearchResultCount ?? 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g1v4z")).IssueCount), {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange,
            total: total
        });
    };
    var $e423a73503b2d0eb$export$2e2bcd8739ae039 = $e423a73503b2d0eb$var$IssueCountRenderer;
});
parcelRegister("g1v4z", function(module, exports) {
    $parcel$export(module.exports, "IssueCount", ()=>$84d0f512b742344f$export$542fba90cc9c1bd1);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $3y25h;
    const $84d0f512b742344f$export$542fba90cc9c1bd1 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, total: total })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-archival-archives.ui.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-count",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o"
            ])
        }, total <= 0 ? formatMessage((0, (0, parcelRequire("3y25h")).default).issueRangeUnknown, {
            startIssueRange: 0,
            endIssueRange: 0
        }) : formatMessage((0, (0, parcelRequire("3y25h")).default).issueRangeKnown, {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange,
            totalNumberIssues: total
        }));
    };
    const $84d0f512b742344f$var$issueCountContainerStyles = null;
});
parcelRegister("3y25h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c4dc2be6956fe6f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6c4dc2be6956fe6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueRangeKnown: {
            "id": "issue-archival-archives.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-range-known",
            "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
        },
        issueRangeUnknown: {
            "id": "issue-archival-archives.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-range-unknown",
            "defaultMessage": "{startIssueRange}-{endIssueRange}"
        }
    });
});
parcelRegister("9pH03", function(module, exports) {
    $parcel$export(module.exports, "PaginationControls", ()=>$10bdbdf310323cd5$export$ff17519edeb6015d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cGXGk;
    var $39xOx;
    var $koVbs;
    var $l8ruj;
    var $58lzA;
    var $cfFcs;
    const $10bdbdf310323cd5$export$ff17519edeb6015d = ({ currentPage: currentPage, totalPages: totalPages })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { setCurrentPage: setCurrentPage, clearIssuesInCurrentPage: clearIssuesInCurrentPage } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const pages = (0, $5uXOq.useMemo)(()=>{
            const firstPage = 1;
            const lastPage = totalPages ?? 1;
            return Array(lastPage - firstPage + 1).fill(undefined).map((_, i)=>firstPage + i);
        }, [
            totalPages
        ]);
        const onChange = (0, $5uXOq.useCallback)((_, page)=>{
            if (page === currentPage) return;
            setCurrentPage(page);
            clearIssuesInCurrentPage();
        }, [
            clearIssuesInCurrentPage,
            currentPage,
            setCurrentPage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "issue-view-archived-issues-paginated-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "issue.issue-view.activity.archived-issues-paginated-table",
            packageName: "jiraArchivedIssues",
            teamName: "kenji",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($10bdbdf310323cd5$var$PaginationContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cGXGk")).default), {
            testId: "issue-archival-archives.ui.archives-table.footer-renderer.pagination-controls.pagination-controls",
            pages: pages,
            onChange: onChange,
            selectedIndex: currentPage - 1,
            max: 7,
            nextLabel: formatMessage((0, (0, parcelRequire("cfFcs")).default).nextButton),
            previousLabel: formatMessage((0, (0, parcelRequire("cfFcs")).default).prevButton)
        }))));
    };
    const $10bdbdf310323cd5$var$PaginationContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bahesu3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cfFcs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$624570a77623e64a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $624570a77623e64a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nextButton: {
            "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.next-button",
            "defaultMessage": "Next page"
        },
        prevButton: {
            "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.prev-button",
            "defaultMessage": "Previous page"
        },
        pageButtonPrefix: {
            "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.page-button-prefix",
            "defaultMessage": "Page {page}"
        },
        disabledButtonTooltip: {
            "id": "issue-archival-archives.archives-table.footer-renderer.pagination-controls.disabled-button-tooltip",
            "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
        }
    });
});
parcelRegister("cx42O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b44e25f704ada7b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $36OOP;
    var $iTVQ8;
    var $WWtmb;
    const $0b44e25f704ada7b$var$useTableHeadCells = (unarchiveIssuePermission)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const checkboxHeader = unarchiveIssuePermission && [
            {
                key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).SELECT,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WWtmb")).SelectCell), null),
                width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).SELECT
            }
        ] || [];
        const headCells = {
            cells: [
                ...checkboxHeader,
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).TYPE,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).issueTypeColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).TYPE
                },
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).KEY,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).issueKeyColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).KEY
                },
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).SUMMARY,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).summaryColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).SUMMARY
                },
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).REPORTER,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).reporterColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).REPORTER
                },
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).ARCHIVED_DATE,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).archivedDateColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).ARCHIVED_DATE
                },
                {
                    key: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_KEYS).ARCHIVED_BY,
                    content: formatMessage((0, (0, parcelRequire("iTVQ8")).default).archivedByColumnHeaderText),
                    width: (0, (0, parcelRequire("36OOP")).ARCHIVE_TABLE_COLUMN_WIDTHS).ARCHIVED_BY
                }
            ]
        };
        return headCells;
    };
    var $0b44e25f704ada7b$export$2e2bcd8739ae039 = $0b44e25f704ada7b$var$useTableHeadCells;
});
parcelRegister("iTVQ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe0006661bbac8f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fe0006661bbac8f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueKeyColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.issue-key-column-header-text",
            "defaultMessage": "Key"
        },
        issueTypeColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.issue-type-column-header-text",
            "defaultMessage": "Type"
        },
        summaryColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.summary-column-header-text",
            "defaultMessage": "Summary"
        },
        reporterColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.reporter-column-header-text",
            "defaultMessage": "Reporter"
        },
        archivedByColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.archived-by-column-header-text",
            "defaultMessage": "Archived by"
        },
        archivedDateColumnHeaderText: {
            "id": "issue-archival-archives.archives-table.head.archived-date-column-header-text",
            "defaultMessage": "Date archived"
        }
    });
});
parcelRegister("WWtmb", function(module, exports) {
    $parcel$export(module.exports, "SelectCell", ()=>$af8d0cc504d0908f$export$9bd5f7aae57b2fd6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $9uNxp;
    var $58lzA;
    var $84j7q;
    const $af8d0cc504d0908f$export$9bd5f7aae57b2fd6 = (0, $5uXOq.memo)(()=>{
        const [isChecked, setIsChecked] = (0, $5uXOq.useState)(false);
        const [isIndeterminate, setIsIndeterminate] = (0, $5uXOq.useState)(false);
        const state = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const pageNumber = (0, (0, parcelRequire("84j7q")).getCurrentPage)({
            state: state
        });
        const numberOfIssuesInPage = (0, (0, parcelRequire("84j7q")).getNumberOfIssuesForCurrentPage)({
            state: state
        });
        (0, $5uXOq.useEffect)(()=>{
            const numberOfSelectedIssues = (0, (0, parcelRequire("84j7q")).getNumberOfSelectedIssuesForPage)({
                state: state,
                pageNumber: pageNumber
            });
            setIsIndeterminate(numberOfSelectedIssues > 0 && numberOfSelectedIssues < numberOfIssuesInPage);
            setIsChecked(numberOfSelectedIssues > 0);
        }, [
            numberOfIssuesInPage,
            pageNumber,
            state
        ]);
        const { selectAllIssuesInCurrentPage: selectAllIssuesInCurrentPage, clearSelectionsInCurrentPage: clearSelectionsInCurrentPage } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const onChange = (0, $5uXOq.useCallback)(()=>{
            if (!isChecked) {
                selectAllIssuesInCurrentPage();
                setIsChecked(true);
            } else {
                clearSelectionsInCurrentPage();
                setIsChecked(false);
            }
        }, [
            clearSelectionsInCurrentPage,
            isChecked,
            selectAllIssuesInCurrentPage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testId": "archives-checkbox",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9uNxp")).default), {
            isChecked: isChecked,
            onChange: onChange,
            isIndeterminate: isIndeterminate,
            value: "Archives table checkbox",
            name: "archives-table-checkbox"
        }));
    });
    const $af8d0cc504d0908f$var$selectCellStyles = null;
});
parcelRegister("9uNxp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa9ceba39c19b1d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7UFJi;
    var $jE7nX;
    var $dFSOR;
    var $hHlt3;
    var $iGDAi;
    var $cBR6L;
    const $fa9ceba39c19b1d6$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $fa9ceba39c19b1d6$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("jE7nX")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hHlt3")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $fa9ceba39c19b1d6$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dFSOR")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iGDAi")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cBR6L")).default), null)));
    }));
    $fa9ceba39c19b1d6$var$Checkbox.displayName = 'Checkbox';
    var $fa9ceba39c19b1d6$export$2e2bcd8739ae039 = $fa9ceba39c19b1d6$var$Checkbox;
});
parcelRegister("dFSOR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00ccfdc63faaba48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eX0Ia;
    function $00ccfdc63faaba48$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $00ccfdc63faaba48$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$00ccfdc63faaba48$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eX0Ia")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $00ccfdc63faaba48$export$2e2bcd8739ae039 = $00ccfdc63faaba48$var$CheckboxIcon;
});
parcelRegister("hHlt3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$515d584ddc990bf4$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $515d584ddc990bf4$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $dbda9f692ace54dd$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $515d584ddc990bf4$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $515d584ddc990bf4$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $dbda9f692ace54dd$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $515d584ddc990bf4$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $dbda9f692ace54dd$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $dbda9f692ace54dd$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $dbda9f692ace54dd$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $dbda9f692ace54dd$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $dbda9f692ace54dd$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $dbda9f692ace54dd$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $dbda9f692ace54dd$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $dbda9f692ace54dd$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $515d584ddc990bf4$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $515d584ddc990bf4$var$baseStyles,
                label && $515d584ddc990bf4$var$textLabelLayoutStyles,
                isDisabled && $515d584ddc990bf4$var$disabledStyles,
                $515d584ddc990bf4$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("iGDAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a84324763383b3f5$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $a84324763383b3f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a84324763383b3f5$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $a84324763383b3f5$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a84324763383b3f5$var$labelTextStyles
        }, children);
    }
});
parcelRegister("cBR6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0bf7ed61515bf50$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $a0bf7ed61515bf50$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $dbda9f692ace54dd$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $a0bf7ed61515bf50$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a0bf7ed61515bf50$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("4tKWn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84a5488d96893578$export$2e2bcd8739ae039);
    var $7VHMR;
    var $84a5488d96893578$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        archivesTableLabel: {
            "id": "issue-archival-archives.archives-table.archives-table-label",
            "defaultMessage": "Archives Table"
        },
        loadingArchivesTableLabel: {
            "id": "issue-archival-archives.archives-table.loading-archives-table-label",
            "defaultMessage": "Loading archives Table"
        }
    });
});
parcelRegister("7fCBi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$366610412a6cb034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3E9jZ;
    var $koVbs;
    var $4kK95;
    const $366610412a6cb034$var$DATE_FORMAT_OPTIONS = {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };
    const $366610412a6cb034$var$DateCell = (0, $5uXOq.memo)(({ archivedDate: archivedDate })=>{
        const { formatDate: formatDateIntl } = (0, (0, parcelRequire("koVbs")).default)();
        const formatDate = (0, $5uXOq.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $366610412a6cb034$var$DATE_FORMAT_OPTIONS) : '', [
            formatDateIntl
        ]);
        const dateOnlyInstance = archivedDate.split('T')[0];
        const currentValue = (0, $5uXOq.useMemo)(()=>formatDate(dateOnlyInstance !== null ? (0, (0, parcelRequire("4kK95")).DateOnly).fromISODateString(dateOnlyInstance) : null), [
            dateOnlyInstance,
            formatDate
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3E9jZ")).default), {
            text: currentValue,
            color: "standard"
        });
    });
    var $366610412a6cb034$export$2e2bcd8739ae039 = $366610412a6cb034$var$DateCell;
});
parcelRegister("3E9jZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfabdb153d0c61cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2zUaG;
    var $cEdCI;
    var $8IGAQ;
    const $dfabdb153d0c61cb$var$SimpleTagComponent = (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8IGAQ")).default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2zUaG")).default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cEdCI")).default), {
                elemBefore: elemBefore
            }),
            contentElement: content
        });
    });
    const $dfabdb153d0c61cb$var$SimpleTag = (0, $5uXOq.memo)($dfabdb153d0c61cb$var$SimpleTagComponent);
    var $dfabdb153d0c61cb$export$2e2bcd8739ae039 = $dfabdb153d0c61cb$var$SimpleTag;
});
parcelRegister("2zUaG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4de29ec5c8fa583$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hFKXd;
    var $8PIsm;
    var $74IN5;
    function $b4de29ec5c8fa583$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b4de29ec5c8fa583$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        minWidth: 0,
        height: (0, (0, parcelRequire("8PIsm")).tagHeight),
        margin: (0, (0, parcelRequire("8PIsm")).defaultMargin),
        padding: "var(--ds-space-0, 0px)",
        position: 'relative',
        backgroundColor: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.background.default})`,
        borderRadius: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).borderRadius})`,
        color: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.text.default})`,
        cursor: 'default'
    });
    const $b4de29ec5c8fa583$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        minWidth: 0,
        height: (0, (0, parcelRequire("8PIsm")).tagHeight),
        margin: (0, (0, parcelRequire("8PIsm")).defaultMargin),
        position: 'relative',
        alignItems: 'center',
        gap: "var(--ds-space-050, 4px)",
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        border: 'solid',
        borderColor: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.borderColor})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        color: "var(--ds-text, #172B4D)",
        cursor: 'default',
        paddingInline: "var(--ds-space-050, 4px)"
    });
    const $b4de29ec5c8fa583$var$interactiveStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.background.hover})`
        },
        '&:active': {
            backgroundColor: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.background.active})`
        }
    });
    const $b4de29ec5c8fa583$var$interactiveStyles = {
        name: "jcdcgl",
        styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    };
    const $b4de29ec5c8fa583$var$focusRingStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            boxShadow: `0 0 0 2px var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.focusRing})`,
            outline: 'none'
        }
    });
    const $b4de29ec5c8fa583$var$focusRingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            outline: `2px solid ${(0, parcelRequire("74IN5")).focusRingColors}`,
            outlineOffset: '2px '
        }
    });
    const $b4de29ec5c8fa583$var$nonStandardLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:active': {
            color: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.text.active})`
        }
    });
    const $b4de29ec5c8fa583$var$BaseTag = (0, ($parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
        const isLink = Boolean(href);
        const isRemovable = Boolean(after);
        const isInteractive = isLink || isRemovable;
        const isStandardLink = isLink && color === 'standard';
        const textLinkColors = isStandardLink ? (0, parcelRequire("74IN5")).textColors['standardLink'] : (0, parcelRequire("74IN5")).textColors[color];
        const backgroundHoverColors = isRemovable && !isLink ? (0, parcelRequire("74IN5")).backgroundColors[color] : (0, parcelRequire("74IN5")).linkHoverBackgroundColors[color];
        const backgroundActiveColors = isRemovable && !isLink ? (0, parcelRequire("74IN5")).backgroundColors[color] : (0, parcelRequire("74IN5")).linkActiveBackgroundColors[color];
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...other,
            ref: ref,
            css: [
                (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $b4de29ec5c8fa583$var$baseStyles : $b4de29ec5c8fa583$var$baseStylesOld,
                isInteractive && ((0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $b4de29ec5c8fa583$var$focusRingStyles : $b4de29ec5c8fa583$var$focusRingStylesOld),
                (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? isLink && $b4de29ec5c8fa583$var$interactiveStyles : undefined,
                !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $b4de29ec5c8fa583$var$nonStandardLinkStyles,
                !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') && isInteractive && $b4de29ec5c8fa583$var$interactiveStylesOld
            ],
            style: {
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.borderColor]: (0, parcelRequire("74IN5")).borderColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.text.default]: (0, parcelRequire("74IN5")).textColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.text.hover]: (0, parcelRequire("74IN5")).textHoverColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.text.active]: (0, parcelRequire("74IN5")).textActiveColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.text.link]: textLinkColors,
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.background.default]: (0, parcelRequire("74IN5")).backgroundColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.background.hover]: backgroundHoverColors,
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.background.active]: backgroundActiveColors,
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.focusRing]: (0, parcelRequire("74IN5")).focusRingColors,
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.removeButton.default]: (0, parcelRequire("74IN5")).removeButtonColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).color.removeButton.hover]: (0, parcelRequire("74IN5")).removeButtonHoverColors[color],
                [(0, (0, parcelRequire("8PIsm")).cssVar).borderRadius]: (0, parcelRequire("74IN5")).borderRadius[appearance],
                ...style
            },
            className: className,
            "data-testid": testId
        }, before, contentElement, after);
    });
    var $b4de29ec5c8fa583$export$2e2bcd8739ae039 = $b4de29ec5c8fa583$var$BaseTag;
});
parcelRegister("8PIsm", function(module, exports) {
    $parcel$export(module.exports, "tagHeight", ()=>$f91a49cac67dd5d2$export$5b2b1030a679f37);
    $parcel$export(module.exports, "buttonWidthUnitless", ()=>$f91a49cac67dd5d2$export$c6f3ea2b4cffd0ca);
    $parcel$export(module.exports, "maxTextWidthUnitless", ()=>$f91a49cac67dd5d2$export$2e3bcb01bf928995);
    $parcel$export(module.exports, "maxTextWidth", ()=>$f91a49cac67dd5d2$export$982d4a1a6de11130);
    $parcel$export(module.exports, "defaultBorderRadius", ()=>$f91a49cac67dd5d2$export$35d5d1e251b985cf);
    $parcel$export(module.exports, "defaultRoundedBorderRadius", ()=>$f91a49cac67dd5d2$export$c49771100fee18c8);
    $parcel$export(module.exports, "defaultMargin", ()=>$f91a49cac67dd5d2$export$6728fea658cfb92e);
    $parcel$export(module.exports, "defaultTextPadding", ()=>$f91a49cac67dd5d2$export$c2d03c4c68282362);
    $parcel$export(module.exports, "textPaddingRight", ()=>$f91a49cac67dd5d2$export$b5686dedf408caa0);
    $parcel$export(module.exports, "textMarginLeft", ()=>$f91a49cac67dd5d2$export$b824cac86306f7a2);
    $parcel$export(module.exports, "cssVar", ()=>$f91a49cac67dd5d2$export$8b4981022bd80a4e);
    var $1wToE;
    const $f91a49cac67dd5d2$var$gridSizeValue = (0, (0, parcelRequire("1wToE")).gridSize)();
    const $f91a49cac67dd5d2$var$borderRadiusValue = (0, (0, parcelRequire("1wToE")).borderRadius)();
    const $f91a49cac67dd5d2$export$b4d89c3994664204 = 2.5 * $f91a49cac67dd5d2$var$gridSizeValue;
    const $f91a49cac67dd5d2$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$f91a49cac67dd5d2$export$b4d89c3994664204}px`})`;
    const $f91a49cac67dd5d2$export$c6f3ea2b4cffd0ca = $f91a49cac67dd5d2$export$b4d89c3994664204;
    const $f91a49cac67dd5d2$export$aba002ef70684916 = $f91a49cac67dd5d2$export$5b2b1030a679f37;
    const $f91a49cac67dd5d2$export$d5949a2c2ea9dcea = 25 * $f91a49cac67dd5d2$var$gridSizeValue;
    const $f91a49cac67dd5d2$export$488fda99655ff65a = `${$f91a49cac67dd5d2$export$d5949a2c2ea9dcea}px`;
    const $f91a49cac67dd5d2$export$2e3bcb01bf928995 = $f91a49cac67dd5d2$export$d5949a2c2ea9dcea - $f91a49cac67dd5d2$export$b4d89c3994664204;
    const $f91a49cac67dd5d2$export$982d4a1a6de11130 = `${$f91a49cac67dd5d2$export$2e3bcb01bf928995}px`;
    const $f91a49cac67dd5d2$export$35d5d1e251b985cf = `${$f91a49cac67dd5d2$var$borderRadiusValue}px`;
    const $f91a49cac67dd5d2$export$c49771100fee18c8 = `${$f91a49cac67dd5d2$export$c6f3ea2b4cffd0ca / 2}px`;
    const $f91a49cac67dd5d2$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$f91a49cac67dd5d2$var$gridSizeValue / 2}px`})`;
    const $f91a49cac67dd5d2$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$f91a49cac67dd5d2$var$gridSizeValue / 2}px`})`;
    const $f91a49cac67dd5d2$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $f91a49cac67dd5d2$var$gridSizeValue}px`})`;
    const $f91a49cac67dd5d2$export$b824cac86306f7a2 = $f91a49cac67dd5d2$export$5b2b1030a679f37;
    const $f91a49cac67dd5d2$export$8b4981022bd80a4e = {
        color: {
            background: {
                default: '--ds-cb',
                hover: '--ds-cbh',
                active: '--ds-cba'
            },
            borderColor: '--ds-bc',
            focusRing: '--ds-cfr',
            text: {
                default: '--ds-ct',
                hover: '--ds-cth',
                active: '--ds-ctp',
                link: '--ds-ctl'
            },
            removeButton: {
                default: '--ds-rb',
                hover: '--ds-rbh'
            }
        },
        borderRadius: '--ds-br'
    };
});
parcelRegister("74IN5", function(module, exports) {
    $parcel$export(module.exports, "textColors", ()=>$6929b6db50023505$export$daa0ace263cb20d2);
    $parcel$export(module.exports, "borderColors", ()=>$6929b6db50023505$export$1c1b571cf296eca7);
    $parcel$export(module.exports, "textHoverColors", ()=>$6929b6db50023505$export$7c7104a5f052cab7);
    $parcel$export(module.exports, "textActiveColors", ()=>$6929b6db50023505$export$382469baad253eb7);
    $parcel$export(module.exports, "backgroundColors", ()=>$6929b6db50023505$export$b9d7c59a579c23c6);
    $parcel$export(module.exports, "linkHoverBackgroundColors", ()=>$6929b6db50023505$export$4410079763249c74);
    $parcel$export(module.exports, "linkActiveBackgroundColors", ()=>$6929b6db50023505$export$76be99c5e13e3566);
    $parcel$export(module.exports, "focusRingColors", ()=>$6929b6db50023505$export$2a31dbe82788f940);
    $parcel$export(module.exports, "borderRadius", ()=>$6929b6db50023505$export$7a57f79000377ca2);
    $parcel$export(module.exports, "removalHoverBackgroundColors", ()=>$6929b6db50023505$export$1202b7eb21da7b58);
    $parcel$export(module.exports, "removalActiveBackgroundColors", ()=>$6929b6db50023505$export$62ace793ebb16bda);
    $parcel$export(module.exports, "removalTextColors", ()=>$6929b6db50023505$export$17d206ccea111bbb);
    $parcel$export(module.exports, "removeButtonColors", ()=>$6929b6db50023505$export$f64c7641cbc22da7);
    $parcel$export(module.exports, "removeButtonHoverColors", ()=>$6929b6db50023505$export$b03fbc2a369c563e);
    var $8PIsm;
    const $6929b6db50023505$export$daa0ace263cb20d2 = {
        standard: `var(--ds-text, ${$dbda9f692ace54dd$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-link, ${$dbda9f692ace54dd$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$dbda9f692ace54dd$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$dbda9f692ace54dd$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$dbda9f692ace54dd$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`
    };
    const $6929b6db50023505$export$1c1b571cf296eca7 = {
        standard: '#B7B9BE',
        blue: '#669DF1',
        red: '#F87168',
        yellow: '#DDB30E',
        green: '#4BCE97',
        teal: '#6CC3E0',
        purple: '#C97CF4',
        lime: '#94C748',
        magenta: '#E774BB',
        orange: '#FCA700',
        grey: '#B7B9BE',
        standardLink: '#B7B9BE',
        blueLight: '#669DF1',
        redLight: '#F87168',
        yellowLight: '#DDB30E',
        greenLight: '#4BCE97',
        tealLight: '#6CC3E0',
        purpleLight: '#C97CF4',
        limeLight: '#94C748',
        magentaLight: '#E774BB',
        orangeLight: '#FCA700',
        greyLight: '#B7B9BE'
    };
    const $6929b6db50023505$export$7c7104a5f052cab7 = {
        standard: `var(--ds-link, ${$dbda9f692ace54dd$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$dbda9f692ace54dd$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$dbda9f692ace54dd$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$dbda9f692ace54dd$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`
    };
    const $6929b6db50023505$export$382469baad253eb7 = {
        standard: `var(--ds-link-pressed, ${$dbda9f692ace54dd$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime, #4C6B1F)",
        magenta: "var(--ds-text-accent-magenta, #943D73)",
        orange: "var(--ds-text-accent-orange, #974F0C)",
        grey: `var(--ds-text-accent-gray, ${$dbda9f692ace54dd$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue-bolder, ${$dbda9f692ace54dd$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green-bolder, ${$dbda9f692ace54dd$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple-bolder, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
        magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
        greyLight: `var(--ds-text-accent-gray-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`
    };
    const $6929b6db50023505$export$b9d7c59a579c23c6 = {
        standard: `var(--ds-background-neutral, ${$dbda9f692ace54dd$export$9fdfb749e33cdf97})`,
        blue: `var(--ds-background-accent-blue-subtle, ${$dbda9f692ace54dd$export$ecfc1dff386a3e7a})`,
        red: `var(--ds-background-accent-red-subtle, ${$dbda9f692ace54dd$export$be802dd0d8b57f35})`,
        yellow: `var(--ds-background-accent-yellow-subtle, ${$dbda9f692ace54dd$export$5aae31392d72caaa})`,
        green: `var(--ds-background-accent-green-subtle, ${$dbda9f692ace54dd$export$747d86715d4175de})`,
        teal: `var(--ds-background-accent-teal-subtle, ${$dbda9f692ace54dd$export$69cb3ca10c1e330e})`,
        purple: `var(--ds-background-accent-purple-subtle, ${$dbda9f692ace54dd$export$6011520a64d9a187})`,
        lime: "var(--ds-background-accent-lime-subtle, #94C748)",
        magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        grey: `var(--ds-background-accent-gray-subtle, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-background-accent-blue-subtler, ${$dbda9f692ace54dd$export$8c13c2ee36917869})`,
        redLight: `var(--ds-background-accent-red-subtler, ${$dbda9f692ace54dd$export$b34b069eff244586})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler, ${$dbda9f692ace54dd$export$1cc05bbbf340e559})`,
        greenLight: `var(--ds-background-accent-green-subtler, ${$dbda9f692ace54dd$export$afbce1382ec95f73})`,
        tealLight: `var(--ds-background-accent-teal-subtler, ${$dbda9f692ace54dd$export$776c9c497ef08533})`,
        purpleLight: `var(--ds-background-accent-purple-subtler, ${$dbda9f692ace54dd$export$4b0a4417ed59760f})`,
        limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
        greyLight: `var(--ds-background-accent-gray-subtler, ${$dbda9f692ace54dd$export$3e51e8f1440314ba})`
    };
    const $6929b6db50023505$export$4410079763249c74 = {
        standard: `var(--ds-background-neutral-hovered, ${$dbda9f692ace54dd$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-hovered, ${$dbda9f692ace54dd$export$8c13c2ee36917869})`,
        red: `var(--ds-background-accent-red-subtle-hovered, ${$dbda9f692ace54dd$export$b34b069eff244586})`,
        yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$dbda9f692ace54dd$export$1cc05bbbf340e559})`,
        green: `var(--ds-background-accent-green-subtle-hovered, ${$dbda9f692ace54dd$export$afbce1382ec95f73})`,
        teal: `var(--ds-background-accent-teal-subtle-hovered, ${$dbda9f692ace54dd$export$776c9c497ef08533})`,
        purple: `var(--ds-background-accent-purple-subtle-hovered, ${$dbda9f692ace54dd$export$4b0a4417ed59760f})`,
        lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
        magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
        orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
        grey: `var(--ds-background-accent-gray-subtle-hovered, ${$dbda9f692ace54dd$export$eece5f492e429f08})`,
        blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$dbda9f692ace54dd$export$226de0355ed012f8})`,
        redLight: `var(--ds-background-accent-red-subtler-hovered, ${$dbda9f692ace54dd$export$4b84fd0e2c617bd})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$dbda9f692ace54dd$export$41060a744ab0b7ae})`,
        greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$dbda9f692ace54dd$export$69a3bf21b9686c2b})`,
        tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$dbda9f692ace54dd$export$7a8f4d33f6f9772c})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$dbda9f692ace54dd$export$363e4475840015bb})`,
        limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
        orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
        greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$dbda9f692ace54dd$export$1ce2d1575d444ceb})`
    };
    const $6929b6db50023505$export$76be99c5e13e3566 = {
        standard: `var(--ds-background-neutral-pressed, ${$dbda9f692ace54dd$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-pressed, ${$dbda9f692ace54dd$export$226de0355ed012f8})`,
        red: `var(--ds-background-accent-red-subtle-pressed, ${$dbda9f692ace54dd$export$4b84fd0e2c617bd})`,
        yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$dbda9f692ace54dd$export$41060a744ab0b7ae})`,
        green: `var(--ds-background-accent-green-subtle-pressed, ${$dbda9f692ace54dd$export$69a3bf21b9686c2b})`,
        teal: `var(--ds-background-accent-teal-subtle-pressed, ${$dbda9f692ace54dd$export$7a8f4d33f6f9772c})`,
        purple: `var(--ds-background-accent-purple-subtle-pressed, ${$dbda9f692ace54dd$export$363e4475840015bb})`,
        grey: `var(--ds-background-accent-gray-subtle-pressed, ${$dbda9f692ace54dd$export$e2ef2124cf4024b1})`,
        lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
        magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
        orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
        blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$dbda9f692ace54dd$export$ecfc1dff386a3e7a})`,
        redLight: `var(--ds-background-accent-red-subtler-pressed, ${$dbda9f692ace54dd$export$be802dd0d8b57f35})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$dbda9f692ace54dd$export$5aae31392d72caaa})`,
        greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$dbda9f692ace54dd$export$747d86715d4175de})`,
        tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$dbda9f692ace54dd$export$69cb3ca10c1e330e})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$dbda9f692ace54dd$export$6011520a64d9a187})`,
        limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
        orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
        greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$dbda9f692ace54dd$export$8754fc7e6d8b3000})`
    };
    const $6929b6db50023505$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$dbda9f692ace54dd$export$ecfc1dff386a3e7a})`;
    const $6929b6db50023505$export$7a57f79000377ca2 = {
        default: (0, (0, parcelRequire("8PIsm")).defaultBorderRadius),
        rounded: (0, (0, parcelRequire("8PIsm")).defaultRoundedBorderRadius)
    };
    const $6929b6db50023505$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$dbda9f692ace54dd$export$4b84fd0e2c617bd})`;
    const $6929b6db50023505$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$dbda9f692ace54dd$export$4b84fd0e2c617bd})`;
    const $6929b6db50023505$export$17d206ccea111bbb = `var(--ds-text-danger, ${$dbda9f692ace54dd$export$2837b5a1a71d5c02})`;
    const $6929b6db50023505$export$f64c7641cbc22da7 = {
        standard: `var(--ds-text, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        red: `var(--ds-text-accent-red-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        green: `var(--ds-text-accent-green-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        lime: `var(--ds-text-accent-lime-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        magenta: `var(--ds-text-accent-magenta-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        orange: `var(--ds-text-accent-orange-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        grey: `var(--ds-text-accent-gray-bolder, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-text-accent-blue, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        redLight: `var(--ds-text-accent-red, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        tealLight: `var(--ds-text-accent-teal, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        limeLight: `var(--ds-text-accent-lime, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        magentaLight: `var(--ds-text-accent-magenta, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        orangeLight: `var(--ds-text-accent-orange, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greyLight: `var(--ds-text-accent-gray, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`
    };
    const $6929b6db50023505$export$b03fbc2a369c563e = {
        standard: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        red: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        green: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        lime: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        magenta: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        orange: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$7d61b15e0da132af})`,
        grey: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        limeLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        magentaLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        orangeLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$147899de772240ec})`,
        greyLight: `var(--ds-text-danger, ${$dbda9f692ace54dd$export$c39c0fe0f26207ae})`
    };
});
parcelRegister("cEdCI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84be9f74b61ab22e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $hFKXd;
    var $8PIsm;
    function $84be9f74b61ab22e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $84be9f74b61ab22e$var$beforeElementStyles = {
        name: "cfjv6",
        styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
    };
    const $84be9f74b61ab22e$var$beforeElementStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).borderRadius})`,
        insetBlockStart: "var(--ds-space-0, 0px)"
    });
    const $84be9f74b61ab22e$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $84be9f74b61ab22e$var$beforeElementStyles : $84be9f74b61ab22e$var$beforeElementStylesOld
        }, elemBefore) : null;
    var $84be9f74b61ab22e$export$2e2bcd8739ae039 = $84be9f74b61ab22e$var$Before;
});
parcelRegister("8IGAQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c3efa8d2799ec7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $hFKXd;
    var $8PIsm;
    function $78c3efa8d2799ec7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $78c3efa8d2799ec7$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("8PIsm")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        paddingInlineEnd: (0, (0, parcelRequire("8PIsm")).defaultTextPadding),
        paddingInlineStart: (0, (0, parcelRequire("8PIsm")).defaultTextPadding),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $78c3efa8d2799ec7$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("8PIsm")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $78c3efa8d2799ec7$var$linkStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.text.link})`,
        pointerEvents: 'auto',
        textDecoration: 'none',
        '&:hover': {
            color: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.text.hover})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(${(0, (0, parcelRequire("8PIsm")).cssVar).color.text.active})`,
            textDecoration: 'underline'
        },
        '&:focus': {
            outline: 'none'
        }
    });
    const $78c3efa8d2799ec7$var$linkStyles = {
        name: "1e5oc06",
        styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
    };
    const $78c3efa8d2799ec7$var$hasAfterStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("8PIsm")).maxTextWidthUnitless) - (0, (0, parcelRequire("8PIsm")).buttonWidthUnitless)}px`,
        paddingInlineEnd: (0, (0, parcelRequire("8PIsm")).textPaddingRight)
    });
    const $78c3efa8d2799ec7$var$hasAfterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("8PIsm")).maxTextWidthUnitless) - (0, (0, parcelRequire("8PIsm")).buttonWidthUnitless)}px`
    });
    const $78c3efa8d2799ec7$var$hasBeforeStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: (0, (0, parcelRequire("8PIsm")).textMarginLeft)
    });
    const $78c3efa8d2799ec7$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
        const Link = linkComponent ?? 'a';
        if (href) return (0, (0, parcelRequire("f8Sb3")).jsx)(Link, {
            href: href,
            "data-color": color,
            css: [
                (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$baseStyles : $78c3efa8d2799ec7$var$baseStylesOld,
                (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$linkStyles : $78c3efa8d2799ec7$var$linkStylesOld,
                !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') && elemBefore && $78c3efa8d2799ec7$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$hasAfterStylesOld : undefined
            ]
        }, text);
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$baseStyles : $78c3efa8d2799ec7$var$baseStylesOld,
                !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') && elemBefore && $78c3efa8d2799ec7$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("hFKXd")).fg)('platform-component-visual-refresh') ? $78c3efa8d2799ec7$var$hasAfterStylesOld : undefined
            ]
        }, text);
    };
    var $78c3efa8d2799ec7$export$2e2bcd8739ae039 = $78c3efa8d2799ec7$var$Content;
});
parcelRegister("4kK95", function(module, exports) {
    $parcel$export(module.exports, "DateOnly", ()=>$a1048e23edd181e2$export$988b361b394263b6);
    $parcel$export(module.exports, "toDateOnly", ()=>$a1048e23edd181e2$export$b0961ad8aee63b8b);
    const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
    const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    const $a1048e23edd181e2$var$daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
        if ([
            year,
            month,
            day
        ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
        if (year < 0) return false;
        if (month < 1 || month > 12) return false;
        if (day < 1) return false;
        if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
        return true;
    };
    const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
    class $a1048e23edd181e2$export$988b361b394263b6 {
        static isISODateString(dateString) {
            try {
                $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
            } catch (e) {
                if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
                throw e;
            }
            return true;
        }
        static fromISODateString(dateString) {
            const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
            if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            const [, year, month, day] = matches;
            return new $a1048e23edd181e2$export$988b361b394263b6(...[
                year,
                month,
                day
            ].map((s)=>Number.parseInt(s, 10)));
        }
        static fromDateAccordingToLocalTime(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
        static fromDateAccordingToUTC(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        }
        static compare(a, b) {
            if (a.year === b.year) {
                if (a.month === b.month) {
                    if (a.day === b.day) return 0;
                    return a.day < b.day ? -1 : 1;
                }
                return a.month < b.month ? -1 : 1;
            }
            return a.year < b.year ? -1 : 1;
        }
        constructor(year, month, day){
            if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            this.year = year;
            this.month = month;
            this.day = day;
        }
        getYear() {
            return this.year;
        }
        getMonth() {
            return this.month;
        }
        getDay() {
            return this.day;
        }
        toISOString() {
            return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
        }
        toUTCDate() {
            return new Date(Date.UTC(this.year, this.month - 1, this.day));
        }
        toLocalDate() {
            const localDate = new Date();
            const currentMonth = localDate.getMonth();
            localDate.setFullYear(this.year);
            localDate.setHours(0);
            localDate.setMinutes(0);
            localDate.setSeconds(0);
            localDate.setMilliseconds(0);
            localDate.setDate(this.day);
            if (localDate.getMonth() !== currentMonth) {
                localDate.setMonth(this.month - 1);
                localDate.setDate(this.day);
            } else localDate.setMonth(this.month - 1);
            return localDate;
        }
        equals(dateOnly) {
            return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
        }
    }
    const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;
});
parcelRegister("lKBOQ", function(module, exports) {
    $parcel$export(module.exports, "KeyCell", ()=>$8a4617f763806264$export$4d17c2f4d9bbf823);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lxThX;
    const $8a4617f763806264$export$4d17c2f4d9bbf823 = (0, $5uXOq.memo)(({ issueKey: issueKey })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _o5721q9c _k48p1pd9 _4bfu1fxt _43ds1fxt _oxk41fxt _1cay1fxt _1o7v1fxt _59381fxt _rfqo1fxt _qfs11fxt _1udh1fxt"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lxThX")).default), {
            appearance: "subtle",
            href: `/browse/${issueKey}`
        }, issueKey)));
    const $8a4617f763806264$var$nowrapStyle = null;
});
parcelRegister("jcy2W", function(module, exports) {
    $parcel$export(module.exports, "SelectCell", ()=>$eacb77be3383cf6e$export$9bd5f7aae57b2fd6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $9uNxp;
    var $58lzA;
    const $eacb77be3383cf6e$export$9bd5f7aae57b2fd6 = (0, $5uXOq.memo)(({ isChecked: isChecked, issueId: issueId, pageNumber: pageNumber, isDisabled: isDisabled })=>{
        const { selectIssue: selectIssue, deselectIssue: deselectIssue } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const onChange = ()=>{
            if (!isChecked) selectIssue({
                issueId: issueId,
                pageNumber: pageNumber
            });
            else deselectIssue({
                issueId: issueId,
                pageNumber: pageNumber
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9uNxp")).default), {
            isChecked: isChecked,
            onChange: onChange,
            value: "Archives table checkbox",
            name: "archives-table-checkbox",
            isDisabled: isDisabled
        }));
    });
    const $eacb77be3383cf6e$var$selectCellStyles = null;
});
parcelRegister("au3pr", function(module, exports) {
    $parcel$export(module.exports, "TextCell", ()=>$f327d3e9557baeb9$export$765aced31cc89655);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    const $f327d3e9557baeb9$export$765aced31cc89655 = (0, $5uXOq.memo)(({ text: text })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1osq"
            ])
        }, text));
    const $f327d3e9557baeb9$var$textCellStyles = null;
});
parcelRegister("5CSl3", function(module, exports) {
    $parcel$export(module.exports, "TypeCell", ()=>$a9955eac9e66f3db$export$1034b01824b6a80);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $jjlQu;
    const $a9955eac9e66f3db$export$1034b01824b6a80 = (0, $5uXOq.memo)(({ iconUrl: iconUrl, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1y6m"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
            url: iconUrl,
            alt: name
        })));
    const $a9955eac9e66f3db$var$typeCellStyles = null;
});
parcelRegister("jjlQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f7206d8a029d15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $e65Lk;
    var $ii5wQ;
    var $gwIPs;
    var $4R6GH;
    const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                url: undefined,
                title: undefined,
                alt: undefined,
                width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                fallback: undefined
            };
        }
        render() {
            const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
            const width = this.convertSize(this.props.width);
            const height = this.convertSize(this.props.height);
            if (this.state.isBroken && fallback) return fallback();
            if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
                src: url,
                width: width,
                height: height,
                title: title ?? undefined,
                alt: alt ?? '',
                onError: this.onError,
                draggable: false
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('jfp-1020-use-compiled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
                xcss: $e7f7206d8a029d15$var$placeholderStyles,
                style: {
                    height: height,
                    width: width
                },
                backgroundColor: "color.background.input.hovered",
                testId: "common-components-async-icon.placeholder"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
                width: width,
                height: height,
                "data-testid": "common-components-async-icon.placeholder"
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isBroken: false
            };
            this.onError = ()=>{
                this.setState({
                    isBroken: true
                });
            };
            this.convertSize = (size)=>size ? `${size}px` : '0';
        }
    }
    const $e7f7206d8a029d15$var$ImagePlaceholder = (0, $47bDC.default).span.withConfig({
        componentId: "owe24v-0"
    })((props)=>({
            height: props.height,
            width: props.width,
            backgroundColor: (0, $dbda9f692ace54dd$exports).N30,
            borderRadius: '3px',
            display: 'flex',
            flex: 'none'
        }));
    const $e7f7206d8a029d15$var$placeholderStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    });
    const $e7f7206d8a029d15$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cURsR", function(module, exports) {
    $parcel$export(module.exports, "UserCell", ()=>$0c9bd85fc20d741b$export$dc0ef711c0db7c30);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hPOvW;
    var $e65Lk;
    var $ii5wQ;
    const $0c9bd85fc20d741b$export$dc0ef711c0db7c30 = (0, $5uXOq.memo)(({ user: user })=>(0, ($parcel$interopDefault($5uXOq))).createElement($0c9bd85fc20d741b$var$NameWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0c9bd85fc20d741b$var$AvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hPOvW")).default), {
            name: user.name,
            src: user.avatarUrl,
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-archival-archives.ui.archives-table.rows.user-cell.user-name"
        }, user.name)));
    const $0c9bd85fc20d741b$var$NameWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($0c9bd85fc20d741b$var$NameWrapperStyles, null, children);
    const $0c9bd85fc20d741b$var$AvatarWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: $0c9bd85fc20d741b$var$avatarWrapperStyles
        }, children);
    const $0c9bd85fc20d741b$var$avatarWrapperStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        marginInlineEnd: 'space.100'
    });
    const $0c9bd85fc20d741b$var$NameWrapperStyles = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("Jc0QV", function(module, exports) {
    $parcel$export(module.exports, "IssueManageBar", ()=>$efd4be3ad1800ce8$export$ddd77f66a6f50d43);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    var $9vM59;
    var $koVbs;
    var $fRizh;
    var $58lzA;
    var $84j7q;
    var $7gHQ7;
    var $9wdSi;
    const $efd4be3ad1800ce8$export$ddd77f66a6f50d43 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fullscreen = (0, (0, parcelRequire("fRizh")).useFullscreenQueryParameter)();
        const state = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const selectedIssueCount = (0, (0, parcelRequire("84j7q")).getNumberOfSelectedIssues)({
            state: state
        });
        const { clearAllSelections: clearAllSelections } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        if (selectedIssueCount === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-archival-archives.ui.manage-bars.issue-manage-bar",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _94n51jfw _1pby11wp _1ltv1mfg _1bsb1osq _p12f10k2 _1e0c1txw _1bah1h6o",
                fullscreen && "_1ltvidpf _p12f1osq"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _94n5idpf _11q71b6k _16qs77ho _2rkoftgi _1yt4u2gc _syaz15cr _1e0c1txw _4cvr1fhb _d32v1gfe _4pkp1gfe _8yco1bsc _1sfy1gfe _g2chcdhy _t8d3pf9b"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc _u5f3u2gc"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            appearance: "subtle",
            spacing: "none",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9vM59"))))), {
                label: formatMessage((0, (0, parcelRequire("7gHQ7")).messages).closeButtonLabel),
                size: "medium"
            }),
            onClick: ()=>clearAllSelections()
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81il0 _u5f3pxbi"
            ])
        }, formatMessage((0, (0, parcelRequire("7gHQ7")).messages).label, {
            count: selectedIssueCount
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1n261g80 _zulpu2gc _19bvu2gc _u5f3u2gc _kqswh2mm _1kt9b3bt _1auk1l7b _1cs8stnw _19wo1l7b _1mp4t94y _qnecidpf _1s6kz9xs"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wdSi")).default), null))));
    };
    const $efd4be3ad1800ce8$var$controlsButtonContainerBaseStyles = null;
    const $efd4be3ad1800ce8$var$controlsButtonContainerFullScreenStyles = null;
    const $efd4be3ad1800ce8$var$ControlsButtonContent = null;
    const $efd4be3ad1800ce8$var$ButtonsWrapper = null;
    const $efd4be3ad1800ce8$var$LabelContainer = null;
    const $efd4be3ad1800ce8$var$Label = null;
});
parcelRegister("9vM59", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6ecc4e6192c42545$var$_react = $6ecc4e6192c42545$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $hD6Dj;
    var $6ecc4e6192c42545$var$_close = $6ecc4e6192c42545$var$_interopRequireDefault((parcelRequire("k3dcS")));
    function $6ecc4e6192c42545$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6ecc4e6192c42545$var$EditorCloseIcon = (props)=>$6ecc4e6192c42545$var$_react.default.createElement((0, parcelRequire("hD6Dj")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $6ecc4e6192c42545$var$_close.default
        }));
    $6ecc4e6192c42545$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $6ecc4e6192c42545$var$_default = module.exports.default = $6ecc4e6192c42545$var$EditorCloseIcon;
});
parcelRegister("fRizh", function(module, exports) {
    $parcel$export(module.exports, "PolarisRouteContainer", ()=>$c08285dcce84bfe5$export$835836449342021c);
    $parcel$export(module.exports, "usePolarisQuery", ()=>$c08285dcce84bfe5$export$a0561749ea6366a9);
    $parcel$export(module.exports, "useFullscreenQueryParameter", ()=>$c08285dcce84bfe5$export$c3af6aa037072338);
    $parcel$export(module.exports, "useSelectedIssueQueryParameter", ()=>$c08285dcce84bfe5$export$567c36d062d58de4);
    $parcel$export(module.exports, "useIsIssueOpenInFullscreen", ()=>$c08285dcce84bfe5$export$605125b912bc3cb9);
    $parcel$export(module.exports, "useIsIssueOpenInSidebar", ()=>$c08285dcce84bfe5$export$d889138060b442eb);
    $parcel$export(module.exports, "useIssueViewLayout", ()=>$c08285dcce84bfe5$export$8ae00b4e58626e94);
    $parcel$export(module.exports, "useIssueViewSection", ()=>$c08285dcce84bfe5$export$711cefe410e03ef5);
    $parcel$export(module.exports, "useCurrentPolarisRoute", ()=>$c08285dcce84bfe5$export$fd6cdb023846ec7a);
    $parcel$export(module.exports, "useCurrentPolarisRouteSection", ()=>$c08285dcce84bfe5$export$144b5fe3cd41790c);
    $parcel$export(module.exports, "usePolarisRouter", ()=>$c08285dcce84bfe5$export$b98a36d9fd4e7222);
    var $5uXOq = parcelRequire("5uXOq");
    var $6ToME;
    var $j6tVh;
    var $dIdda = parcelRequire("dIdda");
    var $lyWlc;
    var $dsqpj;
    var $DHjM0;
    var $14GyY;
    var $53DcZ;
    var $9YiOu;
    var $aXZGL;
    var $6HVnB;
    const $c08285dcce84bfe5$var$initialState = {
        containerProps: undefined
    };
    const $c08285dcce84bfe5$export$feb26c1e73b87394 = (0, (0, parcelRequire("j6tVh")).createPolarisStore)({
        initialState: $c08285dcce84bfe5$var$initialState,
        actions: (0, parcelRequire("DHjM0")),
        name: 'PolarisRouteStore'
    });
    const { Container: $c08285dcce84bfe5$var$Container, useActions: $c08285dcce84bfe5$var$useActions, createHook: $c08285dcce84bfe5$var$createHook } = (0, (0, parcelRequire("6ToME")).createJpdContainer)($c08285dcce84bfe5$export$feb26c1e73b87394, {
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, parcelRequire("14GyY")).init());
                dispatch((0, parcelRequire("53DcZ")).updateDebouncedRouterActions());
            },
        onUpdate: ()=>({ dispatch: dispatch })=>{
                dispatch((0, parcelRequire("53DcZ")).updateDebouncedRouterActions());
            }
    });
    const $c08285dcce84bfe5$export$835836449342021c = (props)=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        const section = (0, (0, parcelRequire("6HVnB")).useUrlSection)();
        const resource = (0, (0, parcelRequire("6HVnB")).useUrlResource)();
        const { push: push, replace: replace } = (0, $dIdda.useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c08285dcce84bfe5$var$Container, {
            ...props,
            query: query,
            section: section,
            resource: resource,
            useNativePushMethod: push,
            useNativeReplaceMethod: replace
        }, props.children);
    };
    const $c08285dcce84bfe5$export$a0561749ea6366a9 = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector));
    const $c08285dcce84bfe5$export$c3af6aa037072338 = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getFullscreenQueryParameter));
    const $c08285dcce84bfe5$export$567c36d062d58de4 = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getSelectedIssueQueryParameter));
    const $c08285dcce84bfe5$export$605125b912bc3cb9 = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getIsIssueOpenInFullscreen));
    const $c08285dcce84bfe5$export$d889138060b442eb = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getIsIssueOpenInSidebar));
    const $c08285dcce84bfe5$export$8ae00b4e58626e94 = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getIssueViewLayout));
    const $c08285dcce84bfe5$export$885b67caee31103a = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getIssueViewSection));
    const $c08285dcce84bfe5$export$711cefe410e03ef5 = ()=>{
        const issueViewSection = $c08285dcce84bfe5$export$885b67caee31103a();
        const isSharedView = (0, (0, parcelRequire("lyWlc")).useIsSharedView)();
        const sharingSettings = (0, (0, parcelRequire("dsqpj")).useCurrentViewSharingSettings)();
        if (!isSharedView) return issueViewSection;
        if (!sharingSettings?.showIdeaComments && issueViewSection === 'comments' || !sharingSettings?.showIdeaInsights && issueViewSection === 'capture') return 0, (0, parcelRequire("aXZGL")).DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR;
        return issueViewSection;
    };
    const $c08285dcce84bfe5$export$fd6cdb023846ec7a = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getCurrentRouteSelector));
    const $c08285dcce84bfe5$export$144b5fe3cd41790c = $c08285dcce84bfe5$var$createHook((0, (0, parcelRequire("9YiOu")).getCurrentRouteSectionSelector));
    const $c08285dcce84bfe5$export$b98a36d9fd4e7222 = ()=>{
        const { routeTo: routeTo, setQuery: setQuery, closeIssueView: closeIssueView, openIssueView: openIssueView } = $c08285dcce84bfe5$var$useActions();
        return {
            routeTo: routeTo,
            setQuery: setQuery,
            closeIssueView: closeIssueView,
            openIssueView: openIssueView
        };
    };
});
parcelRegister("6ToME", function(module, exports) {
    $parcel$export(module.exports, "createJpdContainer", ()=>$23346b108d18c150$export$7ed5db99dcc39128);
    var $gJBT6 = parcelRequire("gJBT6");
    var $jYn8S;
    var $7JoAD = parcelRequire("7JoAD");
    var $5vOOL;
    const $23346b108d18c150$var$createSelectorHook = (store, selector)=>{
        const innerHook = (0, $7JoAD.createHook)(store, {
            selector: (state)=>selector(state, state.containerProps)
        });
        return ()=>{
            const [val] = innerHook();
            return val;
        };
    };
    const $23346b108d18c150$export$757252247e722815 = (store, selectorCreator)=>{
        const memoizedSelectorCreator = (0, (0, parcelRequire("jYn8S")).cacheSelectorCreator)(selectorCreator);
        const monadicSelectorCreatorMemoized = (0, ($parcel$interopDefault($gJBT6)))(selectorCreator);
        const rssHook = (0, $7JoAD.createHook)(store, {
            selector: (state, args)=>{
                if (args.length <= 1) return monadicSelectorCreatorMemoized(...args)(state, state.containerProps);
                return memoizedSelectorCreator(...args)(state, state.containerProps);
            }
        });
        return (...args)=>{
            const [val] = rssHook(args);
            return val;
        };
    };
    const $23346b108d18c150$export$7ed5db99dcc39128 = (store, options)=>{
        const Container = (0, (0, parcelRequire("5vOOL")).createContainerWithContext)(store, options);
        const useEmptyState = (0, $7JoAD.createHook)(store, {
            selector: null
        });
        const useActions = ()=>{
            const [, actions] = useEmptyState();
            return actions;
        };
        return {
            createHook: (selector)=>$23346b108d18c150$var$createSelectorHook(store, selector),
            createHigherLevelHook: (selectorCreator)=>$23346b108d18c150$export$757252247e722815(store, selectorCreator),
            useActions: useActions,
            Container: Container
        };
    };
});
parcelRegister("jYn8S", function(module, exports) {
    $parcel$export(module.exports, "cacheSelectorCreator", ()=>$904e561f620684de$export$413433974f0869c3);
    $parcel$export(module.exports, "getCacheValue", ()=>$904e561f620684de$export$e15acfbd8ab989dd);
    let $904e561f620684de$var$cache = new WeakMap();
    let $904e561f620684de$var$jsonEqualityMap = new WeakMap();
    const $904e561f620684de$var$getValueFromJsonEqualityCache = (f, value, options)=>{
        if (options?.useJsonEquality !== true) return value;
        if (!$904e561f620684de$var$jsonEqualityMap.has(f)) $904e561f620684de$var$jsonEqualityMap.set(f, new Map());
        const storage = $904e561f620684de$var$jsonEqualityMap.get(f);
        try {
            const key = JSON.stringify(value);
            if (storage.has(key)) return storage.get(key);
            storage.set(key, value);
        } catch  {}
        return value;
    };
    function $904e561f620684de$export$413433974f0869c3(f, options) {
        if (f.__isCachedSelectorCreator === true) return f;
        const cacheFunction = (...args)=>{
            if ($904e561f620684de$var$cache.has(f)) {
                let lastNode = $904e561f620684de$var$cache.get(f);
                for(let i = 0; i < args.length; i += 1){
                    const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                    if (!lastNode.args.has(value)) {
                        lastNode = null;
                        break;
                    }
                    lastNode = lastNode.args.get(value);
                }
                if (lastNode?.selector) return lastNode.selector;
            }
            const maybeSelector = f(...args);
            if (typeof maybeSelector?.resultFunc === 'function' || typeof maybeSelector === 'function') {
                if (!$904e561f620684de$var$cache.has(f)) $904e561f620684de$var$cache.set(f, {
                    args: new Map(),
                    selector: null
                });
                let lastNode = $904e561f620684de$var$cache.get(f);
                for(let i = 0; i < args.length; i += 1){
                    const value = $904e561f620684de$var$getValueFromJsonEqualityCache(f, args[i], options);
                    if (!lastNode.args.has(value)) lastNode.args.set(value, {
                        args: new Map(),
                        selector: null
                    });
                    lastNode = lastNode.args.get(value);
                }
                lastNode.selector = maybeSelector;
            }
            return maybeSelector;
        };
        cacheFunction.__isCachedSelectorCreator = true;
        cacheFunction.__origin = f;
        cacheFunction.displayName = f.name || f.displayName;
        return cacheFunction;
    }
    const $904e561f620684de$export$e2575ed62a2f107b = ()=>$904e561f620684de$var$cache;
    const $904e561f620684de$export$e15acfbd8ab989dd = (key)=>$904e561f620684de$var$cache.get(key);
    const $904e561f620684de$export$6e5dca841bdf93e3 = ()=>{
        $904e561f620684de$var$cache = new WeakMap();
        $904e561f620684de$var$jsonEqualityMap = new WeakMap();
    };
});
parcelRegister("5vOOL", function(module, exports) {
    $parcel$export(module.exports, "createContainerWithContext", ()=>$3e805df79a9b7626$export$ce6d80db779db7dc);
    var $7JoAD = parcelRequire("7JoAD");
    var $battw;
    const $3e805df79a9b7626$export$ce6d80db779db7dc = (store, options)=>(0, $7JoAD.createContainer)(store, {
            ...options,
            onInit: ()=>(api, containerProps)=>{
                    (0, (0, parcelRequire("battw")).batchStateUpdates)(({ dispatch: dispatch, setState: setState }, props)=>{
                        setState({
                            containerProps: props
                        });
                        options?.onInit && dispatch(options.onInit());
                    })(api, containerProps);
                },
            onUpdate: ()=>(api, containerProps)=>{
                    (0, (0, parcelRequire("battw")).batchStateUpdates)(({ dispatch: dispatch, setState: setState, getState: getState }, props)=>{
                        const prevContainerProps = getState().containerProps;
                        setState({
                            containerProps: props,
                            prevContainerProps: prevContainerProps
                        });
                        options?.onUpdate && dispatch(options.onUpdate());
                    })(api, containerProps);
                }
        });
});
parcelRegister("battw", function(module, exports) {
    $parcel$export(module.exports, "batchStateUpdates", ()=>$cbff8929059d4af1$export$4f8b20404a906ca3);
    const $cbff8929059d4af1$export$4f8b20404a906ca3 = (cb)=>(api, containerProps)=>{
            let finalized = false;
            let localState = api.getState();
            const setState = (newState)=>{
                if (finalized) {
                    api.setState(newState);
                    return;
                }
                localState = {
                    ...localState,
                    ...newState
                };
            };
            const getState = ()=>finalized ? api.getState() : localState;
            const dispatch = (action)=>finalized ? action(api, containerProps) : action({
                    dispatch: dispatch,
                    setState: setState,
                    getState: getState
                }, containerProps);
            const patchedApi = {
                setState: setState,
                getState: getState,
                dispatch: dispatch
            };
            cb(patchedApi, containerProps);
            finalized = true;
            api.setState({
                ...localState
            });
            localState = null;
        };
});
parcelRegister("j6tVh", function(module, exports) {
    $parcel$export(module.exports, "createPolarisStore", ()=>$45fc3d01ddfa9253$export$425650453fa3c52a);
    var $dPSWJ = parcelRequire("dPSWJ");
    var $7JoAD = parcelRequire("7JoAD");
    const $45fc3d01ddfa9253$export$425650453fa3c52a = ({ initialState: initialState, actions: actions, name: name })=>{
        const wrappedActions = (0, ($parcel$interopDefault($dPSWJ)))(actions, (actionCreator)=>(...args)=>{
                try {
                    const actionFct = actionCreator(...args);
                    return (storeAction, props)=>{
                        try {
                            return actionFct(storeAction, props);
                        } catch (error) {
                            props.onActionFailed(error);
                            throw error;
                        }
                    };
                } catch (error) {
                    return (storeAction, props)=>{
                        props.onActionFailed(error);
                        throw error;
                    };
                }
            });
        return (0, $7JoAD.createStore)({
            initialState: initialState,
            actions: wrappedActions,
            name: name
        });
    };
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
parcelRegister("lyWlc", function(module, exports) {
    $parcel$export(module.exports, "PolarisEnvironmentContainer", ()=>$85f6c037aef11ab5$export$ab892b38d9838cc4);
    $parcel$export(module.exports, "useIsEmbedded", ()=>$85f6c037aef11ab5$export$77140ffa938f9fd1);
    $parcel$export(module.exports, "useIsSharedView", ()=>$85f6c037aef11ab5$export$19a346ab6c5052b2);
    $parcel$export(module.exports, "useIsCollectionView", ()=>$85f6c037aef11ab5$export$653454b45dadb2a8);
    var $7JoAD = parcelRequire("7JoAD");
    const $85f6c037aef11ab5$var$initialState = {};
    const $85f6c037aef11ab5$var$actions = {
        getContainerProps: ()=>(ops, props)=>props
    };
    const $85f6c037aef11ab5$export$108e035982ac1f7b = (0, $7JoAD.createStore)({
        initialState: $85f6c037aef11ab5$var$initialState,
        actions: $85f6c037aef11ab5$var$actions,
        name: 'PolarisEnvironmentStore'
    });
    const $85f6c037aef11ab5$export$ab892b38d9838cc4 = (0, $7JoAD.createContainer)($85f6c037aef11ab5$export$108e035982ac1f7b);
    const $85f6c037aef11ab5$var$useActions = (0, $7JoAD.createActionsHook)($85f6c037aef11ab5$export$108e035982ac1f7b);
    const $85f6c037aef11ab5$var$useProps = ()=>{
        const { getContainerProps: getContainerProps } = $85f6c037aef11ab5$var$useActions();
        return getContainerProps();
    };
    const $85f6c037aef11ab5$export$77140ffa938f9fd1 = ()=>{
        const { embedded: embedded } = $85f6c037aef11ab5$var$useProps();
        return embedded === true;
    };
    const $85f6c037aef11ab5$export$19a346ab6c5052b2 = ()=>{
        const { isSharedView: isSharedView } = $85f6c037aef11ab5$var$useProps();
        return isSharedView === true;
    };
    const $85f6c037aef11ab5$export$653454b45dadb2a8 = ()=>{
        const { isCollectionView: isCollectionView } = $85f6c037aef11ab5$var$useProps();
        return isCollectionView === true;
    };
});
parcelRegister("dsqpj", function(module, exports) {
    $parcel$export(module.exports, "useIsCurrentViewSharingSettingsInitialLoading", ()=>$8bcf6327eed5a750$export$24d19581f52b2bac);
    $parcel$export(module.exports, "useIsCurrentViewSharingInitialLoading", ()=>$8bcf6327eed5a750$export$e060903268c10657);
    $parcel$export(module.exports, "useCurrentViewSharingSettings", ()=>$8bcf6327eed5a750$export$e010169e1bebed20);
    $parcel$export(module.exports, "useCurrentViewSharingStakeholders", ()=>$8bcf6327eed5a750$export$8afacc6445a9f29d);
    $parcel$export(module.exports, "usePublicSharingControls", ()=>$8bcf6327eed5a750$export$f5e51b1e513c7a19);
    $parcel$export(module.exports, "useIdeaDescriptionFieldKey", ()=>$8bcf6327eed5a750$export$a95feff8ba9c77d2);
    $parcel$export(module.exports, "useHasCurrentViewSharingSettingsError", ()=>$8bcf6327eed5a750$export$a4c4a7f472c1449a);
    $parcel$export(module.exports, "useHasCurrentViewSharingError", ()=>$8bcf6327eed5a750$export$ed37db0f58966dec);
    $parcel$export(module.exports, "useIsSharingOnSiteEnabled", ()=>$8bcf6327eed5a750$export$5603541acb0905d);
    $parcel$export(module.exports, "useIsSharingSiteConfigLoading", ()=>$8bcf6327eed5a750$export$cd795923d8f612d5);
    $parcel$export(module.exports, "useProjectAccessLevel", ()=>$8bcf6327eed5a750$export$e262f937bd216199);
    $parcel$export(module.exports, "useIsPublishDialogContentLoading", ()=>$8bcf6327eed5a750$export$4a54198358826b6b);
    $parcel$export(module.exports, "useIsSitePublicSharingLoading", ()=>$8bcf6327eed5a750$export$f1d239607895ab30);
    $parcel$export(module.exports, "useIsCurrentViewPublicSharingEnabled", ()=>$8bcf6327eed5a750$export$9e4ecc370892bc0b);
    $parcel$export(module.exports, "useIsSitePublicSharingEnabled", ()=>$8bcf6327eed5a750$export$c2bf49dff0e5754f);
    var $j7ruN;
    var $5cEDG;
    const $8bcf6327eed5a750$export$24d19581f52b2bac = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingSettingsInitialLoading));
    const $8bcf6327eed5a750$export$e060903268c10657 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingInitialLoading));
    const $8bcf6327eed5a750$export$e010169e1bebed20 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getCurrentViewSharingSettings));
    const $8bcf6327eed5a750$export$8afacc6445a9f29d = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getCurrentViewSharingStakeholders));
    const $8bcf6327eed5a750$export$f5e51b1e513c7a19 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getPublicSharingControls));
    const $8bcf6327eed5a750$export$a95feff8ba9c77d2 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIdeaDescriptionFieldKey));
    const $8bcf6327eed5a750$export$a4c4a7f472c1449a = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).hasCurrentViewSharingSettingsError));
    const $8bcf6327eed5a750$export$ed37db0f58966dec = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).hasCurrentViewSharingError));
    const $8bcf6327eed5a750$export$5603541acb0905d = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsSharingOnSiteEnabled));
    const $8bcf6327eed5a750$export$cd795923d8f612d5 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsSharingSiteConfigLoading));
    const $8bcf6327eed5a750$export$e262f937bd216199 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getProjectAccessLevel));
    const $8bcf6327eed5a750$export$4a54198358826b6b = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsPublishDialogContentLoading));
    const $8bcf6327eed5a750$export$f1d239607895ab30 = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsSitePublicSharingLoading));
    const $8bcf6327eed5a750$export$9e4ecc370892bc0b = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsCurrentViewPublicSharingEnabled));
    const $8bcf6327eed5a750$export$c2bf49dff0e5754f = (0, (0, parcelRequire("j7ruN")).createSharingHook)((0, (0, parcelRequire("5cEDG")).getIsSitePublicSharingEnabled));
});
parcelRegister("j7ruN", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$c8a37b772f734c4c$export$42a852a2b6b56249);
    $parcel$export(module.exports, "createSharingHook", ()=>$c8a37b772f734c4c$export$80a8f4ec77855db9);
    $parcel$export(module.exports, "useSharingActions", ()=>$c8a37b772f734c4c$export$45260f05810c82ae);
    var $co1wz;
    var $6ToME;
    var $j6tVh;
    var $4wfKP;
    parcelRequire("klYyU");
    var $hWBQg;
    var $6AMVG;
    var $klYyU;
    const $c8a37b772f734c4c$export$d4c72bab9d6cc13a = Object.freeze({
        sharingSettings: {},
        sharingStakeholders: {},
        siteConfig: {
            isEnabled: false,
            isLoading: false,
            error: undefined
        },
        sitePublicSharingConfig: {
            isEnabled: false,
            isLoading: false,
            error: undefined
        },
        projectAccessLevel: undefined,
        containerProps: undefined,
        prevContainerProps: undefined
    });
    const $c8a37b772f734c4c$var$SharingStore = (0, (0, parcelRequire("j6tVh")).createPolarisStore)({
        initialState: $c8a37b772f734c4c$export$d4c72bab9d6cc13a,
        actions: (0, (0, parcelRequire("klYyU")).publicActions),
        name: 'SharingStore'
    });
    const $c8a37b772f734c4c$var$onInit = ()=>({ dispatch: dispatch, setState: setState }, { edition: edition, permissions: permissions })=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('polaris.sharing-enabled')) return;
            if ((0, (0, parcelRequire("4wfKP")).publishFeatureDisabled)(edition)) return;
            dispatch((0, parcelRequire("6AMVG")).loadSharingSiteConfig());
            if ((0, (0, parcelRequire("co1wz")).ff)('polaris.published-view-public-links_dj5gi')) {
                setState({
                    permissions: permissions
                });
                dispatch((0, (0, parcelRequire("klYyU")).privateActions).loadSitePublicSharingConfig());
            }
            dispatch((0, parcelRequire("hWBQg")).loadProjectAccessLevel());
        };
    const $c8a37b772f734c4c$var$onUpdate = ()=>({ setState: setState }, { permissions: permissions })=>{
            if ((0, (0, parcelRequire("co1wz")).ff)('polaris.published-view-public-links_dj5gi')) setState({
                permissions: permissions
            });
        };
    const { Container: $c8a37b772f734c4c$export$42a852a2b6b56249, createHook: $c8a37b772f734c4c$var$createHook, useActions: $c8a37b772f734c4c$var$useActions } = (0, (0, parcelRequire("6ToME")).createJpdContainer)($c8a37b772f734c4c$var$SharingStore, {
        onInit: $c8a37b772f734c4c$var$onInit,
        onUpdate: $c8a37b772f734c4c$var$onUpdate
    });
    const $c8a37b772f734c4c$export$80a8f4ec77855db9 = $c8a37b772f734c4c$var$createHook;
    const $c8a37b772f734c4c$export$45260f05810c82ae = $c8a37b772f734c4c$var$useActions;
});
parcelRegister("4wfKP", function(module, exports) {
    $parcel$export(module.exports, "publishFeatureDisabled", ()=>$3bc1b7a0bd01541d$export$941f8069ccf8e337);
    var $ldyPw;
    const $3bc1b7a0bd01541d$export$941f8069ccf8e337 = (edition)=>edition && [
            (0, (0, parcelRequire("ldyPw")).UNLICENSED),
            (0, (0, parcelRequire("ldyPw")).FREE_EDITION)
        ].includes(edition);
});
parcelRegister("klYyU", function(module, exports) {
    $parcel$export(module.exports, "privateActions", ()=>$681a27a9308f8e67$export$3f1be494d407b77a);
    $parcel$export(module.exports, "publicActions", ()=>$681a27a9308f8e67$export$8705b583fa097d24);
    $parcel$export(module.exports, "loadSharingSiteConfig", ()=>(parcelRequire("6AMVG")).loadSharingSiteConfig);
    $parcel$export(module.exports, "loadProjectAccessLevel", ()=>(parcelRequire("hWBQg")).loadProjectAccessLevel);
    var $fAR4j;
    var $hWBQg;
    var $1DaQu;
    var $6AMVG;
    var $GdbJn;
    var $aOR78;
    const $681a27a9308f8e67$export$3f1be494d407b77a = {
        loadSitePublicSharingConfig: (0, parcelRequire("fAR4j")).loadSitePublicSharingConfig
    };
    const $681a27a9308f8e67$export$8705b583fa097d24 = {
        loadSharingSettings: (0, parcelRequire("1DaQu")).loadSharingSettings,
        updateSharingSettings: (0, parcelRequire("1DaQu")).updateSharingSettings,
        addSharingStakeholders: (0, parcelRequire("GdbJn")).addSharingStakeholders,
        loadSharingStakeholders: (0, parcelRequire("GdbJn")).loadSharingStakeholders,
        removeSharingStakeholders: (0, parcelRequire("GdbJn")).removeSharingStakeholders,
        loadSharingSiteConfig: (0, parcelRequire("6AMVG")).loadSharingSiteConfig,
        setProjectAccessLevel: (0, parcelRequire("hWBQg")).setProjectAccessLevel,
        loadProjectAccessLevel: (0, parcelRequire("hWBQg")).loadProjectAccessLevel,
        deletePublishedView: (0, parcelRequire("aOR78")).deletePublishedView
    };
});
parcelRegister("fAR4j", function(module, exports) {
    $parcel$export(module.exports, "loadSitePublicSharingConfig", ()=>$16d730ecdd0e42b1$export$85d654471364d5f1);
    var $jcw0u;
    var $eiARp;
    var $1As78;
    var $aiePb;
    var $ks1lh;
    const $16d730ecdd0e42b1$export$85d654471364d5f1 = ()=>async ({ setState: setState })=>{
            setState({
                sitePublicSharingConfig: {
                    isEnabled: false,
                    isLoading: true,
                    error: undefined
                }
            });
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSitePublicSharingConfig.start();
                const { enabled: enabled } = await (0, (0, parcelRequire("ks1lh")).fetchSitePublicSharingConfig)();
                setState({
                    sitePublicSharingConfig: {
                        isEnabled: enabled,
                        isLoading: false,
                        error: undefined
                    }
                });
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSitePublicSharingConfig.success();
            } catch (error) {
                setState({
                    sitePublicSharingConfig: {
                        isEnabled: false,
                        isLoading: false,
                        error: error
                    }
                });
                if ((0, (0, parcelRequire("aiePb")).isPermissionError)(error) || (0, (0, parcelRequire("aiePb")).isNotFoundError)(error)) (0, (0, parcelRequire("eiARp")).experience).sharing.loadSitePublicSharingConfig.abort(error);
                else {
                    (0, (0, parcelRequire("eiARp")).experience).sharing.loadSitePublicSharingConfig.failure(error);
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.load-site-public-sharing-config-action', error));
                }
            }
        };
});
parcelRegister("eiARp", function(module, exports) {
    $parcel$export(module.exports, "experience", ()=>$197962e595787fdc$export$45794d16c9d83fe2);
    var $j7O7S;
    var $g4YUd;
    var $5aZmE;
    var $1vklt;
    var $hsleu;
    var $a6HzE;
    var $fL5Br;
    var $3BB7g;
    var $7fAfw;
    var $hZFBk;
    var $7OYCX;
    var $aLKMx;
    var $kKtJE;
    var $izXrc;
    var $fziiF;
    var $5vb9d;
    var $eP0jx;
    var $5jGaO;
    var $2fH9t;
    var $brO00;
    var $kCQpt;
    const $197962e595787fdc$export$45794d16c9d83fe2 = {
        listView: (0, parcelRequire("7OYCX")).default,
        formulaField: (0, parcelRequire("hsleu")).default,
        headerView: (0, parcelRequire("fL5Br")).default,
        boardView: (0, parcelRequire("j7O7S")).default,
        ideaView: (0, parcelRequire("3BB7g")).default,
        ideaViewBentoSidebar: (0, parcelRequire("7fAfw")).default,
        matrixView: (0, parcelRequire("aLKMx")).default,
        navBar: (0, parcelRequire("kKtJE")).default,
        project: (0, parcelRequire("eP0jx")).default,
        timelineView: (0, parcelRequire("2fH9t")).default,
        fieldsSidebar: (0, parcelRequire("1vklt")).default,
        issues: (0, parcelRequire("hZFBk")).default,
        deliveryItems: (0, parcelRequire("5aZmE")).default,
        sharing: (0, parcelRequire("5jGaO")).default,
        productAccess: (0, parcelRequire("5vb9d")).default,
        globalFieldsAdministration: (0, parcelRequire("a6HzE")).default,
        playSidepanel: (0, parcelRequire("fziiF")).default,
        noViewsScreen: (0, parcelRequire("izXrc")).default,
        view: (0, parcelRequire("brO00")).default,
        viewPermissions: (0, parcelRequire("kCQpt")).default,
        collections: (0, parcelRequire("g4YUd")).default
    };
});
parcelRegister("j7O7S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$713aabc44094d1be$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $713aabc44094d1be$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.board-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $713aabc44094d1be$var$scrollPerformance = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.board-view.scroll-performance', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).Custom
    }));
    var $713aabc44094d1be$export$2e2bcd8739ae039 = {
        scrollPerformance: $713aabc44094d1be$var$scrollPerformance,
        pageSegmentLoad: $713aabc44094d1be$var$pageSegmentLoad
    };
});
parcelRegister("jDD5V", function(module, exports) {
    $parcel$export(module.exports, "createMarkedJpdExperience", ()=>$d337991d320bf50a$export$bffa5dc83c7b8f85);
    $parcel$export(module.exports, "createJpdExperience", ()=>$d337991d320bf50a$export$2510480a5584184);
    $parcel$export(module.exports, "wrapPromiseWithExperience", ()=>$d337991d320bf50a$export$745ef3600a4acb32);
    $parcel$export(module.exports, "wrapWithExperience", ()=>$d337991d320bf50a$export$9527dfc663dbb238);
    var $agVdz = parcelRequire("agVdz");
    var $jcw0u;
    var $jJZqs;
    var $fZneA;
    const $d337991d320bf50a$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
            ...$d337991d320bf50a$export$2510480a5584184(ufoExperience),
            marks: marks
        });
    const $d337991d320bf50a$var$handleReason = (handler, error)=>{
        if (error === undefined) {
            handler();
            return;
        }
        if (typeof error === 'object' && 'statusCode' in error && 'message' in error) {
            handler({
                metadata: {
                    error: `status: ${error.statusCode} message: ${error.message} name: ${error.name}`,
                    errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                        if (typeof err === 'string') return err;
                        if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                        return '';
                    }).join(', ') : undefined
                }
            });
            return;
        }
        if (error instanceof Error) {
            handler({
                metadata: {
                    error: error.message
                }
            });
            return;
        }
        if ((0, ($parcel$interopDefault($agVdz)))(error)) {
            handler({
                metadata: {
                    error: error
                }
            });
            return;
        }
        handler(error);
    };
    const $d337991d320bf50a$export$2510480a5584184 = (ufoExperience)=>({
            ufoExperience: ufoExperience,
            start: (startTime)=>{
                ufoExperience.start();
                if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                    ...ufoExperience.metrics,
                    startTime: startTime
                });
            },
            mark: (mark)=>{
                ufoExperience.mark(mark);
            },
            success: (meta, endTime)=>{
                ufoExperience.success(meta);
                if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                    ...ufoExperience.metrics,
                    endTime: endTime
                });
            },
            successWithReason: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.success(meta), reason);
            },
            failure: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.failure(meta), reason);
            },
            abort: (reason)=>{
                $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.abort(meta), reason);
            }
        });
    const $d337991d320bf50a$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId)=>{
        experience.start();
        return promise.then((response)=>{
            experience.success();
            return response;
        }).catch((error)=>{
            if (errorAnalyticsId) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: errorAnalyticsId,
                    teamName: 'polaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) {
                experience.abort(error);
                throw error;
            }
            if ((0, (0, parcelRequire("jJZqs")).isValidationError)(error)) {
                experience.abort(error);
                throw error;
            }
            experience.failure(error);
            throw error;
        });
    };
    const $d337991d320bf50a$export$9527dfc663dbb238 = (experience, callback)=>{
        experience.start();
        return callback().then((result)=>{
            experience.success();
            return result;
        }).catch((error)=>{
            if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) {
                experience.abort(error);
                throw error;
            }
            if (error instanceof Error) experience.failure(error);
            throw error;
        });
    };
});
parcelRegister("g4YUd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f47dfcedb9a9cd64$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $f47dfcedb9a9cd64$var$pageLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f47dfcedb9a9cd64$var$create = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollections = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-collections', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadViewCount = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-view-count', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadUsers = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-users', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadProjects = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-projects', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$createCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.create-collection', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$copyCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.copy-collection', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$deleteCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.delete-collection', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$updateCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.update-collection', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollection = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-collection', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollectionViews = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-collection-views', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$loadCollectionDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.load-collection-description', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$updateCollectionDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.update-collection-description', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.create-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $f47dfcedb9a9cd64$var$deleteView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.collections.delete-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $f47dfcedb9a9cd64$export$2e2bcd8739ae039 = {
        pageLoad: $f47dfcedb9a9cd64$var$pageLoad,
        create: $f47dfcedb9a9cd64$var$create,
        loadCollections: $f47dfcedb9a9cd64$var$loadCollections,
        loadViewCount: $f47dfcedb9a9cd64$var$loadViewCount,
        loadUsers: $f47dfcedb9a9cd64$var$loadUsers,
        loadProjects: $f47dfcedb9a9cd64$var$loadProjects,
        createCollection: $f47dfcedb9a9cd64$var$createCollection,
        copyCollection: $f47dfcedb9a9cd64$var$copyCollection,
        loadCollection: $f47dfcedb9a9cd64$var$loadCollection,
        loadCollectionViews: $f47dfcedb9a9cd64$var$loadCollectionViews,
        deleteCollection: $f47dfcedb9a9cd64$var$deleteCollection,
        updateCollection: $f47dfcedb9a9cd64$var$updateCollection,
        loadCollectionDescription: $f47dfcedb9a9cd64$var$loadCollectionDescription,
        updateCollectionDescription: $f47dfcedb9a9cd64$var$updateCollectionDescription,
        createView: $f47dfcedb9a9cd64$var$createView,
        deleteView: $f47dfcedb9a9cd64$var$deleteView
    };
});
parcelRegister("5aZmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8039a4f9b6c69dfe$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $8039a4f9b6c69dfe$var$loadChildIssues = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.childIssues', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $8039a4f9b6c69dfe$export$2e2bcd8739ae039 = {
        loadChildIssues: $8039a4f9b6c69dfe$var$loadChildIssues,
        loadAggregatedDeliveryProgressBasedOnProjectId: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId,
        loadAggregatedDeliveryProgress: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress,
        loadLinkedDeliveryTickets: $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets,
        loadTransitiveChildrenArjHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy,
        loadTransitiveChildrenInTwoLevelCoreHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy
    };
});
parcelRegister("1vklt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dea1a79ad34e84c$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $5dea1a79ad34e84c$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.load', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $5dea1a79ad34e84c$var$fieldToggle = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-toggle', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldHide = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-hide', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldDelete = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-delete', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldRegularCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-regular-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldFormulaCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-formula-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $5dea1a79ad34e84c$var$fieldPlayCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.fields-sidebar.field-play-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $5dea1a79ad34e84c$export$2e2bcd8739ae039 = {
        fieldToggle: $5dea1a79ad34e84c$var$fieldToggle,
        fieldHide: $5dea1a79ad34e84c$var$fieldHide,
        fieldDelete: $5dea1a79ad34e84c$var$fieldDelete,
        fieldRegularCreate: $5dea1a79ad34e84c$var$fieldRegularCreate,
        fieldFormulaCreate: $5dea1a79ad34e84c$var$fieldFormulaCreate,
        fieldPlayCreate: $5dea1a79ad34e84c$var$fieldPlayCreate,
        pageSegmentLoad: $5dea1a79ad34e84c$var$pageSegmentLoad
    };
});
parcelRegister("hsleu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ada778994f5f2fe$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $6ada778994f5f2fe$export$2e2bcd8739ae039 = {
        precalculateFormulaFieldAllValuesSelector: $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector
    };
});
parcelRegister("a6HzE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43bb153204899b03$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $43bb153204899b03$var$globalFieldCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldDelete = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-delete', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldAssociate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-associate', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUnassociate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-unassociate', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldCheckViewsUsage = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-update', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldUpdateConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-update-config', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$globalFieldCheckProjectUsage = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadGlobalFields = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.load-fields', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadGlobalLabels = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.load-global-labels', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadJpdProjects = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$loadProjectsWithField = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldAddOptions = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-add-options', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldDeleteOption = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-delete-option', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldRenameOption = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-rename-option', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$fieldMoveOptions = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.field-move-options', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $43bb153204899b03$var$copyValues = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global-fields-administration.copy-values', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $43bb153204899b03$export$2e2bcd8739ae039 = {
        globalFieldCreate: $43bb153204899b03$var$globalFieldCreate,
        globalFieldDelete: $43bb153204899b03$var$globalFieldDelete,
        globalFieldAssociate: $43bb153204899b03$var$globalFieldAssociate,
        globalFieldUnassociate: $43bb153204899b03$var$globalFieldUnassociate,
        globalFieldCheckViewsUsage: $43bb153204899b03$var$globalFieldCheckViewsUsage,
        globalFieldUpdate: $43bb153204899b03$var$globalFieldUpdate,
        globalFieldUpdateConfig: $43bb153204899b03$var$globalFieldUpdateConfig,
        globalFieldCheckProjectUsage: $43bb153204899b03$var$globalFieldCheckProjectUsage,
        loadGlobalFields: $43bb153204899b03$var$loadGlobalFields,
        loadGlobalLabels: $43bb153204899b03$var$loadGlobalLabels,
        loadJpdProjects: $43bb153204899b03$var$loadJpdProjects,
        loadProjectsWithField: $43bb153204899b03$var$loadProjectsWithField,
        fieldAddOptions: $43bb153204899b03$var$fieldAddOptions,
        fieldDeleteOption: $43bb153204899b03$var$fieldDeleteOption,
        fieldRenameOption: $43bb153204899b03$var$fieldRenameOption,
        fieldMoveOptions: $43bb153204899b03$var$fieldMoveOptions,
        copyValues: $43bb153204899b03$var$copyValues
    };
});
parcelRegister("fL5Br", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db9a3be9cda48e16$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $db9a3be9cda48e16$var$updateViewDescription = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.header-view.update-view-description', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewGroupBy = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.header-view.view-group-by', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewSort = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.header-view.view-sort', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $db9a3be9cda48e16$var$viewFilter = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.header-view.view-filter', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $db9a3be9cda48e16$export$2e2bcd8739ae039 = {
        updateViewDescription: $db9a3be9cda48e16$var$updateViewDescription,
        viewGroupBy: $db9a3be9cda48e16$var$viewGroupBy,
        viewSort: $db9a3be9cda48e16$var$viewSort,
        viewFilter: $db9a3be9cda48e16$var$viewFilter
    };
});
parcelRegister("3BB7g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa811d79693859dc$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $aa811d79693859dc$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$directPageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view-direct', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$summaryUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.summary-update', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$descriptionUpdate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.description-update', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$deliveryTicketCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.delivery-ticket-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$commentCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.comment-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$insightCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.insight-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$issueLinkCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.issue-link-create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$commentsSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.comments', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$insightsSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.insights', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $aa811d79693859dc$var$fileAttach = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.attach-file', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $aa811d79693859dc$var$makeFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view.field-update', {
            type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
        }));
    var $aa811d79693859dc$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $aa811d79693859dc$var$pageSegmentLoad,
        directPageSegmentLoad: $aa811d79693859dc$var$directPageSegmentLoad,
        summaryUpdate: $aa811d79693859dc$var$summaryUpdate,
        descriptionUpdate: $aa811d79693859dc$var$descriptionUpdate,
        deliveryTicketCreate: $aa811d79693859dc$var$deliveryTicketCreate,
        commentCreate: $aa811d79693859dc$var$commentCreate,
        insightCreate: $aa811d79693859dc$var$insightCreate,
        issueLinkCreate: $aa811d79693859dc$var$issueLinkCreate,
        commentsSegmentLoad: $aa811d79693859dc$var$commentsSegmentLoad,
        insightsSegmentLoad: $aa811d79693859dc$var$insightsSegmentLoad,
        fileAttach: $aa811d79693859dc$var$fileAttach,
        makeFieldUpdate: $aa811d79693859dc$var$makeFieldUpdate
    };
});
parcelRegister("7fAfw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed8cbb8d1e75d594$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $ed8cbb8d1e75d594$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.idea-view-bento-sidebar', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $ed8cbb8d1e75d594$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $ed8cbb8d1e75d594$var$pageSegmentLoad
    };
});
parcelRegister("hZFBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93f260704cbd9bf2$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $93f260704cbd9bf2$var$loadIssuesRestBatched = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issues.load.rest-batched', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssueRest = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue.load.rest', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issues.load.jpd-api', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssueJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue.load.jpd-api', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesRanksRestBatched = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issues.ranks.load.rest-batched', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuesRanksJpdApi = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issues.ranks.load.jpd-api', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$rankIssue = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue.rank', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$loadIssuePickerIssuesRest = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue-picker.load', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $93f260704cbd9bf2$var$globalJpdIssueCreate = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.global.jpd.create-issue', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $93f260704cbd9bf2$export$2e2bcd8739ae039 = {
        loadIssuesRanksRestBatched: $93f260704cbd9bf2$var$loadIssuesRanksRestBatched,
        loadIssuesRanksJpdApi: $93f260704cbd9bf2$var$loadIssuesRanksJpdApi,
        loadIssuesRestBatched: $93f260704cbd9bf2$var$loadIssuesRestBatched,
        loadIssuesJpdApi: $93f260704cbd9bf2$var$loadIssuesJpdApi,
        loadIssueJpdApi: $93f260704cbd9bf2$var$loadIssueJpdApi,
        loadIssueRest: $93f260704cbd9bf2$var$loadIssueRest,
        rankIssue: $93f260704cbd9bf2$var$rankIssue,
        loadIssuePickerIssuesRest: $93f260704cbd9bf2$var$loadIssuePickerIssuesRest,
        globalJpdIssueCreate: $93f260704cbd9bf2$var$globalJpdIssueCreate
    };
});
parcelRegister("7OYCX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b79ce5313c591e2$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $9b79ce5313c591e2$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $9b79ce5313c591e2$var$createIdeaInline = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view.create-idea-inline', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $9b79ce5313c591e2$var$createIdeaInlineClickResponse = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).Custom
    }));
    const $9b79ce5313c591e2$var$changeViewName = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view.change-view-name', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $9b79ce5313c591e2$var$listScrollPerformance = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view.scroll-performance', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).Custom
    }));
    const $9b79ce5313c591e2$var$makeFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.list-view.field-update', {
            type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult,
            timings: [
                {
                    key: 'internal_state',
                    endMark: 'backend_request_start'
                },
                {
                    key: 'backend_request',
                    startMark: 'backend_request_start'
                }
            ]
        }));
    var $9b79ce5313c591e2$export$2e2bcd8739ae039 = {
        changeViewName: $9b79ce5313c591e2$var$changeViewName,
        createIdeaInline: $9b79ce5313c591e2$var$createIdeaInline,
        createIdeaInlineClickResponse: $9b79ce5313c591e2$var$createIdeaInlineClickResponse,
        listScrollPerformance: $9b79ce5313c591e2$var$listScrollPerformance,
        pageSegmentLoad: $9b79ce5313c591e2$var$pageSegmentLoad,
        makeFieldUpdate: $9b79ce5313c591e2$var$makeFieldUpdate
    };
});
parcelRegister("aLKMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3e34426082afc38$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $c3e34426082afc38$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.matrix-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $c3e34426082afc38$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $c3e34426082afc38$var$pageSegmentLoad
    };
});
parcelRegister("kKtJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30ef3794d6f0e57e$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $30ef3794d6f0e57e$var$changeViewName = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.nav-bar.change-view-name', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $30ef3794d6f0e57e$var$changeViewRank = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.nav-bar.change-view-rank', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $30ef3794d6f0e57e$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.nav-bar.create-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $30ef3794d6f0e57e$export$2e2bcd8739ae039 = {
        changeViewName: $30ef3794d6f0e57e$var$changeViewName,
        changeViewRank: $30ef3794d6f0e57e$var$changeViewRank,
        createView: $30ef3794d6f0e57e$var$createView
    };
});
parcelRegister("izXrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2aec2d2eb41963e$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $c2aec2d2eb41963e$var$createView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.no-views-screen.create-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $c2aec2d2eb41963e$export$2e2bcd8739ae039 = {
        createView: $c2aec2d2eb41963e$var$createView
    };
});
parcelRegister("fziiF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$971b7c6c0f6a6248$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $971b7c6c0f6a6248$var$updatePlayField = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.play-sidepanel.field-update', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $971b7c6c0f6a6248$export$2e2bcd8739ae039 = {
        updatePlayField: $971b7c6c0f6a6248$var$updatePlayField
    };
});
parcelRegister("5vb9d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54872f75c13964ef$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $54872f75c13964ef$var$loadSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.product-access.load-publish-config', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $54872f75c13964ef$var$updateSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.product-access.update-publish-config', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $54872f75c13964ef$export$2e2bcd8739ae039 = {
        loadSharingConfig: $54872f75c13964ef$var$loadSharingConfig,
        updateSharingConfig: $54872f75c13964ef$var$updateSharingConfig
    };
});
parcelRegister("eP0jx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9663d0cc0faff39$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $f9663d0cc0faff39$var$applyTemplateMarks = {
        APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
        APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
    };
    const $f9663d0cc0faff39$var$pageLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.project', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f9663d0cc0faff39$var$pageLoadWithRateLimit = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.project.rate-limit', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageLoad
    }));
    const $f9663d0cc0faff39$var$applyTemplate = (0, (0, parcelRequire("jDD5V")).createMarkedJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.project.apply-template', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).Custom,
        featureFlags: [
            'polaris.project.creation.template'
        ],
        timings: [
            {
                key: 'apply_template_polling',
                startMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_START_MARK,
                endMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_STOP_MARK
            }
        ]
    }), $f9663d0cc0faff39$var$applyTemplateMarks);
    const $f9663d0cc0faff39$var$create = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.project.create', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $f9663d0cc0faff39$export$2e2bcd8739ae039 = {
        pageLoad: $f9663d0cc0faff39$var$pageLoad,
        pageLoadWithRateLimit: $f9663d0cc0faff39$var$pageLoadWithRateLimit,
        applyTemplate: $f9663d0cc0faff39$var$applyTemplate,
        create: $f9663d0cc0faff39$var$create
    };
});
parcelRegister("5jGaO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8256c1be52a9ff31$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $8256c1be52a9ff31$var$dialogLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.control-dialog-load', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $8256c1be52a9ff31$var$loadStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.load-stakeholders', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$addStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.add-stakeholders', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$removeStakeholders = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.remove-stakeholders', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSettings = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.load-settings', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$updateSettings = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.update-settings', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSiteConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.load-site-config', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $8256c1be52a9ff31$var$loadSitePublicSharingConfig = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.shared.load-site-public-sharing-config', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $8256c1be52a9ff31$export$2e2bcd8739ae039 = {
        dialogLoad: $8256c1be52a9ff31$var$dialogLoad,
        loadStakeholders: $8256c1be52a9ff31$var$loadStakeholders,
        addStakeholders: $8256c1be52a9ff31$var$addStakeholders,
        removeStakeholders: $8256c1be52a9ff31$var$removeStakeholders,
        loadSettings: $8256c1be52a9ff31$var$loadSettings,
        updateSettings: $8256c1be52a9ff31$var$updateSettings,
        loadSiteConfig: $8256c1be52a9ff31$var$loadSiteConfig,
        loadSitePublicSharingConfig: $8256c1be52a9ff31$var$loadSitePublicSharingConfig
    };
});
parcelRegister("2fH9t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4089a9b61ccedd94$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $4089a9b61ccedd94$var$pageSegmentLoad = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.timeline-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    var $4089a9b61ccedd94$export$2e2bcd8739ae039 = {
        pageSegmentLoad: $4089a9b61ccedd94$var$pageSegmentLoad
    };
});
parcelRegister("brO00", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b36fcf167fca27fa$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $b36fcf167fca27fa$var$getView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view.get-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$updateView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view.update-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$deleteView = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view.delete-view', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate = ()=>(0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue-update.field', {
            type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult,
            timings: [
                {
                    key: 'internal_state',
                    endMark: 'backend_request_start'
                },
                {
                    key: 'backend_request',
                    startMark: 'backend_request_start'
                }
            ]
        }));
    const $b36fcf167fca27fa$var$updateIssueFields = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.issue-update.fields', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
    var $b36fcf167fca27fa$export$2e2bcd8739ae039 = {
        getView: $b36fcf167fca27fa$var$getView,
        updateView: $b36fcf167fca27fa$var$updateView,
        deleteView: $b36fcf167fca27fa$var$deleteView,
        makeGenericIssueFieldUpdate: $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate,
        updateIssueFields: $b36fcf167fca27fa$var$updateIssueFields
    };
});
parcelRegister("kCQpt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28eb3963187c0ff9$export$2e2bcd8739ae039);
    var $ivxS0;
    var $n3syj;
    var $jDD5V;
    const $28eb3963187c0ff9$var$openDialog = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.open-dialog', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).PageSegmentLoad
    }));
    const $28eb3963187c0ff9$var$loadViewAccess = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.load-view-access', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$updateViewAccess = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.update-view-access', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$addPrincipals = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.add-principals', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$changePrincipalRole = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.set-principal-role', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    const $28eb3963187c0ff9$var$removePrincipal = (0, (0, parcelRequire("jDD5V")).createJpdExperience)(new (0, (0, parcelRequire("n3syj")).UFOExperience)('jpd.view-permissions.remove-principal', {
        type: (0, (0, parcelRequire("ivxS0")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("ivxS0")).ExperiencePerformanceTypes).InlineResult
    }));
    var $28eb3963187c0ff9$export$2e2bcd8739ae039 = {
        openDialog: $28eb3963187c0ff9$var$openDialog,
        loadViewAccess: $28eb3963187c0ff9$var$loadViewAccess,
        updateViewAccess: $28eb3963187c0ff9$var$updateViewAccess,
        addPrincipals: $28eb3963187c0ff9$var$addPrincipals,
        changePrincipalRole: $28eb3963187c0ff9$var$changePrincipalRole,
        removePrincipal: $28eb3963187c0ff9$var$removePrincipal
    };
});
parcelRegister("1As78", function(module, exports) {
    $parcel$export(module.exports, "createErrorAnalytics", ()=>$7cf658edd2cdbf14$export$9841879b4fea885b);
    $parcel$export(module.exports, "useErrorHandlers", ()=>$7cf658edd2cdbf14$export$e0b4869c7401cacb);
    $parcel$export(module.exports, "useOnCyclicFormulaFieldError", ()=>$7cf658edd2cdbf14$export$4e01d30cacaf82b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cqSx;
    var $6tQSl;
    var $jcw0u;
    var $koVbs;
    var $eW55R;
    var $lH8Ty;
    var $l6caf;
    var $aiePb;
    const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error)=>({
            meta: {
                id: id
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
        callback && callback((0, (0, parcelRequire("aiePb")).getMetadata)(errorObject));
    };
    const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).serverLoadFailedDescription)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
            const entityLimitError = (0, (0, parcelRequire("lH8Ty")).getEntityLimitError)(errorObject);
            if (entityLimitError) {
                const errorMessage = (0, (0, parcelRequire("lH8Ty")).getErrorMessageDescriptor)(entityLimitError);
                return errorMessage ? customFlag({
                    title: formatMessage((0, (0, parcelRequire("l6caf")).default).entityLimitErrorTitle),
                    description: formatMessage(errorMessage, {
                        item: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6tQSl")).default), null, chunks)
                    }),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2cqSx"))))), {
                        label: "Error",
                        primaryColor: `var(--ds-icon-danger, ${(0, $dbda9f692ace54dd$export$4a7404f376229999)})`
                    })
                }) : null;
            }
            if ((0, (0, parcelRequire("aiePb")).isPermissionError)(errorObject)) return error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).permissionErrorDescription)
            });
            if ((0, (0, parcelRequire("aiePb")).isConfigError)(errorObject)) return error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).configErrorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).configErrorDescription)
            });
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).serverUpdateFailedDescription)
            });
        }, [
            customFlag,
            error,
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).errorDescription)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { errorWithRefresh: errorWithRefresh } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((errorObject, callback)=>{
            $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
            errorWithRefresh({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).errorPossibleAccessLoss)
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
        }, [
            errorWithRefresh,
            formatMessage
        ]);
    };
    const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
        const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
        const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
        const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
        const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
        return (0, $5uXOq.useMemo)(()=>({
                possibleAccessLossError: possibleAccessLossError,
                generalActionFailedError: generalActionFailedError,
                generalDataUpdateFailedError: generalDataUpdateFailedError,
                generalDataLoadingFailedError: generalDataLoadingFailedError
            }), [
            possibleAccessLossError,
            generalActionFailedError,
            generalDataUpdateFailedError,
            generalDataLoadingFailedError
        ]);
    };
    const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { error: error } = (0, (0, parcelRequire("eW55R")).useNotifications)();
        return (0, $5uXOq.useCallback)((fieldLabels)=>{
            error({
                title: formatMessage((0, (0, parcelRequire("l6caf")).default).errorTitle),
                description: formatMessage((0, (0, parcelRequire("l6caf")).default).cyclicFormulaFieldDescription, {
                    fieldLabels: fieldLabels.join(', ')
                })
            });
            (0, (0, parcelRequire("jcw0u")).default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
        }, [
            error,
            formatMessage
        ]);
    };
});
parcelRegister("eW55R", function(module, exports) {
    $parcel$export(module.exports, "useNotifications", ()=>$3e7591c0992d0e62$export$53d5ca6c3f53e109);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $kRaKz;
    var $2cqSx;
    var $7R4eB;
    var $d4xRU;
    var $7HGHK;
    var $pa9q9;
    const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
        const id = (0, ($parcel$interopDefault($7Jxgt)))();
        return {
            id: id,
            render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                    id: id,
                    ...notification,
                    onDismissed: (flagId)=>onDismiss(flagId),
                    ...props
                })
        };
    };
    const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, (0, parcelRequire("d4xRU")).default));
    const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, (0, parcelRequire("7R4eB")).default));
    const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: notification.actions?.map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kRaKz"))))), {
                label: "Success icon",
                primaryColor: `var(--ds-icon-success, ${(0, $dbda9f692ace54dd$exports).G300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.success'
        }, onDismiss);
    const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: [
                ...notification.actions || [],
                {
                    content: 'Refresh',
                    testId: 'refresh',
                    onClick: ()=>window.location.reload()
                }
            ].map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2cqSx"))))), {
                label: "Error",
                primaryColor: `var(--ds-icon-danger, ${(0, $dbda9f692ace54dd$exports).R300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.error-refresh'
        }, onDismiss);
    const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
            title: notification.title,
            description: notification.description,
            actions: notification.actions?.map((action, index)=>({
                    ...action,
                    testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
                })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2cqSx"))))), {
                label: "Error",
                primaryColor: `var(--ds-icon-danger, ${(0, $dbda9f692ace54dd$exports).R300})`
            }),
            appearance: 'normal',
            testId: 'polaris-lib-notifications.controllers.notification.error'
        }, onDismiss);
    const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useMemo)(()=>({
                customFlag: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                success: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                errorWithRefresh: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                error: (notification)=>{
                    const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                    return ()=>dismissFlag(flagId);
                },
                showFlag: (flag)=>{
                    const id = flag.id !== undefined ? flag.id : (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt)))());
                    const flagId = showFlag({
                        ...flag,
                        id: id,
                        key: id
                    });
                    return ()=>dismissFlag(flagId);
                },
                showCustomFlag: (flag)=>{
                    const id = flag.id !== undefined ? flag.id : (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt)))());
                    const flagId = showFlag({
                        ...flag,
                        id: id
                    });
                    return ()=>dismissFlag(flagId);
                },
                dismissFlag: dismissFlag
            }), [
            showFlag,
            dismissFlag
        ]);
    };
});
parcelRegister("7R4eB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$435170f9f2349b2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            isAutoDismiss: true,
            ...props,
            flagType: "info"
        }));
    var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $7B17s;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("7B17s")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("7B17s")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("7B17s")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("7B17s")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("lH8Ty", function(module, exports) {
    $parcel$export(module.exports, "EntityLimitError", ()=>$bbaa521f44d79b10$export$c4e01b2c2ba95919);
    $parcel$export(module.exports, "getEntityLimitError", ()=>$bbaa521f44d79b10$export$13f6f9a6b905ebbd);
    $parcel$export(module.exports, "getErrorMessageDescriptor", ()=>$bbaa521f44d79b10$export$cf58cbb2768ea4f);
    var $e3a3O;
    var $ht021;
    var $j7a90;
    var $lTDxG;
    class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, (0, parcelRequire("ht021")).default) {
        constructor(message, errors = [], statusCode = null, type){
            super(message, {
                cause: errors[0]
            });
            this.name = 'EntityLimitError';
            this.errors = errors;
            this.statusCode = statusCode;
            this.type = type;
        }
    }
    const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
        if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
        if (!(error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError))) return null;
        const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
        if (!entityLimitError?.extensions) return null;
        const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
        const entityLimitErrorType = (0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE)[limitType];
        return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
            {
                error: entityLimitError.message
            }
        ], statusCode, entityLimitErrorType);
    };
    const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, (0, parcelRequire("j7a90")).default)[error.type] || null;
});
parcelRegister("j7a90", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6233b95581c40425$export$2e2bcd8739ae039);
    var $7VHMR;
    var $lTDxG;
    var $6233b95581c40425$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
            "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
            "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
            "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
            "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
            "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
            "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
            "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
        },
        [(0, (0, parcelRequire("lTDxG")).ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
            "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
            "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
        }
    });
});
parcelRegister("lTDxG", function(module, exports) {
    $parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", ()=>$557259e823a7e117$export$a197d88688faa32c);
    const $557259e823a7e117$export$a197d88688faa32c = {
        COMMENTS_PER_VIEW: 'commentsPerView',
        FIELDS_PER_VIEW: 'fieldsPerView',
        FIELDS_PER_PROJECT: 'fieldsPerProject',
        INSIGHTS_PER_IDEA: 'insightsPerIdea',
        INSIGHTS_PER_PROJECT: 'insightsPerProject',
        LABELS_PER_SNIPPET: 'labelsPerSnippet',
        OPTIONS_PER_FIELD: 'optionsPerField',
        PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
        PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
        PLAYS_PER_PROJECT: 'playsPerProject',
        SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
        VIEWS_PER_PROJECT: 'viewsPerProject',
        VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
    };
});
parcelRegister("l6caf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$891c8f37fb7de7f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "polaris-lib-errors.controllers.error-title",
            "defaultMessage": "Something went wrong."
        },
        permissionErrorDescription: {
            "id": "polaris-lib-errors.controllers.permission-error-description",
            "defaultMessage": "You may not have the permissions required to perform this operation."
        },
        configErrorTitle: {
            "id": "polaris-lib-errors.controllers.config-error-title",
            "defaultMessage": "We couldn't save that."
        },
        configErrorDescription: {
            "id": "polaris-lib-errors.controllers.config-error-description",
            "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
        },
        serverLoadFailedDescription: {
            "id": "polaris-lib-errors.controllers.server-load-failed-description",
            "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
        },
        serverUpdateFailedDescription: {
            "id": "polaris-lib-errors.controllers.server-update-failed-description",
            "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
        },
        errorDescription: {
            "id": "polaris-lib-errors.controllers.error-description",
            "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
        },
        workflowLoadingFailedDescription: {
            "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
            "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
        },
        errorPossibleAccessLoss: {
            "id": "polaris-lib-errors.controllers.error-possible-access-loss",
            "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
        },
        cyclicFormulaFieldDescription: {
            "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
            "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
        },
        entityLimitErrorTitle: {
            "id": "polaris-lib-errors.controllers.entity-limit-error-title",
            "defaultMessage": "You\u2019ve hit a limit"
        }
    });
});
parcelRegister("aiePb", function(module, exports) {
    $parcel$export(module.exports, "isPermissionError", ()=>$b7e19fcceac7c31b$export$e11674744930cd15);
    $parcel$export(module.exports, "isRateLimitError", ()=>$b7e19fcceac7c31b$export$a8908c3867f6f20b);
    $parcel$export(module.exports, "isAccessForbiddenError", ()=>$b7e19fcceac7c31b$export$443ae86cf12ba84);
    $parcel$export(module.exports, "isNotFoundError", ()=>$b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
    $parcel$export(module.exports, "isClientClosedError", ()=>$b7e19fcceac7c31b$export$ce14333297f1d017);
    $parcel$export(module.exports, "isBadRequest", ()=>$b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
    $parcel$export(module.exports, "isConfigError", ()=>$b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
    $parcel$export(module.exports, "getMetadata", ()=>$b7e19fcceac7c31b$export$8548546c0aa631e6);
    var $561FV = parcelRequire("561FV");
    var $8LQ84 = parcelRequire("8LQ84");
    var $icGZu = parcelRequire("icGZu");
    const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 401 || errorObject.statusCode === 403;
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, ($parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) return (0, ($parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
            const safeMessage = error.message || '';
            return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || safeMessage.includes('status code 403');
        });
        return false;
    };
    const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
        const safeMessage = error?.message || '';
        return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
    };
    const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
        return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
    };
    const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 403;
        return false;
    };
    const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 404;
        return false;
    };
    const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode')) return errorObject.statusCode === 499;
        return false;
    };
    const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
        if (errorObject?.statusCode) return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
        return false;
    };
    const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
        if ((0, ($parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, ($parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
        return false;
    };
    const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
            metadata: {
                error: errorObject.message
            }
        });
});
parcelRegister("icGZu", function(module, exports) {
    var $2k3l6 = parcelRequire("2k3l6");
    var $bxDef = parcelRequire("bxDef");
    var $6kYP8 = parcelRequire("6kYP8");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4rDUz = parcelRequire("4rDUz");
    function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
        var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
        if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
        return func(collection, $bxDef(predicate, 3));
    }
    module.exports = $d40ab2104a331ebd$var$some;
});
parcelRegister("6kYP8", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    function $49d3cab0435826ab$var$baseSome(collection, predicate) {
        var result;
        $e7pfQ(collection, function(value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
        });
        return !!result;
    }
    module.exports = $49d3cab0435826ab$var$baseSome;
});
parcelRegister("ks1lh", function(module, exports) {
    $parcel$export(module.exports, "fetchSiteSharingConfig", ()=>$e7a7fc6c342c1e8f$export$28c58aa760b45b2f);
    $parcel$export(module.exports, "enableSharingOnSite", ()=>$e7a7fc6c342c1e8f$export$9a5ce37e4cd6948a);
    $parcel$export(module.exports, "disableSharingOnSite", ()=>$e7a7fc6c342c1e8f$export$20b3e963cde336ea);
    $parcel$export(module.exports, "updateSiteSharingAudience", ()=>$e7a7fc6c342c1e8f$export$28086ca9cd40b9a);
    $parcel$export(module.exports, "fetchSitePublicSharingConfig", ()=>$e7a7fc6c342c1e8f$export$d88e9e9de94a1689);
    $parcel$export(module.exports, "enablePublicSharingOnSite", ()=>$e7a7fc6c342c1e8f$export$a39f2019d2db95d2);
    $parcel$export(module.exports, "disablePublicSharingOnSite", ()=>$e7a7fc6c342c1e8f$export$5c0263c3f0e2deff);
    var $7f4tk;
    var $eusud;
    var $edYbh;
    const $e7a7fc6c342c1e8f$export$28c58aa760b45b2f = ()=>(0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL));
    const $e7a7fc6c342c1e8f$export$9a5ce37e4cd6948a = ()=>(0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/enable`);
    const $e7a7fc6c342c1e8f$export$20b3e963cde336ea = ()=>(0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/disable`);
    const $e7a7fc6c342c1e8f$export$28086ca9cd40b9a = (audience)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/audience`, {
            body: JSON.stringify({
                audience: audience
            })
        });
    const $e7a7fc6c342c1e8f$export$d88e9e9de94a1689 = ()=>(0, (0, parcelRequire("7f4tk")).default)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/public`);
    const $e7a7fc6c342c1e8f$export$a39f2019d2db95d2 = ()=>(0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/public/enable`);
    const $e7a7fc6c342c1e8f$export$5c0263c3f0e2deff = ()=>(0, (0, parcelRequire("eusud")).performPutRequest)(`${(0, (0, parcelRequire("edYbh")).SITE_SHARING_CONFIG_URL)}/public/disable`);
});
parcelRegister("edYbh", function(module, exports) {
    $parcel$export(module.exports, "SITE_SHARING_AUDIENCE", ()=>$58e5bb18f058231d$export$d3c2b1c9aa071f82);
    $parcel$export(module.exports, "SITE_SHARING_CONFIG_URL", ()=>$58e5bb18f058231d$export$f27e6cd6ae0b6f49);
    const $58e5bb18f058231d$export$d3c2b1c9aa071f82 = {
        ANYONE: 'ANYONE',
        ORGANIZATION: 'ORGANIZATION'
    };
    const $58e5bb18f058231d$export$f27e6cd6ae0b6f49 = '/rest/polaris/views/sharing/config';
});
parcelRegister("hWBQg", function(module, exports) {
    $parcel$export(module.exports, "loadProjectAccessLevel", ()=>$f27294ab93ee5d9d$export$16808681673565f0);
    $parcel$export(module.exports, "setProjectAccessLevel", ()=>$f27294ab93ee5d9d$export$89aeb751af3ee244);
    var $jcw0u;
    var $1As78;
    var $iZcO6;
    const $f27294ab93ee5d9d$export$16808681673565f0 = ()=>async ({ setState: setState }, { isSharedView: isSharedView, projectId: projectId })=>{
            if (isSharedView || !projectId) return;
            try {
                const level = await (0, (0, parcelRequire("iZcO6")).fetchProjectAccessLevel)(projectId);
                setState({
                    projectAccessLevel: level?.type
                });
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.load-project-access-level', error));
            }
        };
    const $f27294ab93ee5d9d$export$89aeb751af3ee244 = (projectAccessLevel)=>({ setState: setState })=>{
            setState({
                projectAccessLevel: projectAccessLevel
            });
        };
});
parcelRegister("iZcO6", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectAccessLevel", ()=>$5003ae2c28548a26$export$c1e51f4f79456e2e);
    var $7f4tk;
    const $5003ae2c28548a26$var$transformType = (value)=>value === 'OPEN' || value === 'LIMITED' || value === 'PRIVATE' || value === 'FREE' ? value : 'UNKNOWN';
    const $5003ae2c28548a26$var$transform = (response)=>{
        if (response.accessLevel === undefined) return undefined;
        return {
            type: $5003ae2c28548a26$var$transformType(response.accessLevel.value),
            label: response.accessLevel.displayName,
            description: response.accessLevel.description,
            iconName: response.accessLevel.iconName
        };
    };
    const $5003ae2c28548a26$export$c1e51f4f79456e2e = (projectId)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
            method: 'GET'
        }).then($5003ae2c28548a26$var$transform);
});
parcelRegister("1DaQu", function(module, exports) {
    $parcel$export(module.exports, "updateSharingSettings", ()=>$1f66d335a1a40f0e$export$69a9d91d9040f402);
    $parcel$export(module.exports, "loadSharingSettings", ()=>$1f66d335a1a40f0e$export$38e4cff581c355ad);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $eiARp;
    var $1BW2P;
    var $1As78;
    var $aiePb;
    var $8zOmE;
    var $5cEDG;
    var $5bBlt;
    const $1f66d335a1a40f0e$var$getUpdateSettings = (settings, fields)=>{
        const newSettings = {
            ...settings
        };
        if (newSettings.ideaDescription.fieldKey) {
            const descriptionFieldExists = fields.some(({ key: key })=>key === newSettings.ideaDescription.fieldKey);
            if (!descriptionFieldExists) {
                const { ideaDescription: ideaDescription, ...rest } = newSettings;
                return rest;
            }
        }
        return newSettings;
    };
    const $1f66d335a1a40f0e$var$sanitizeSettings = (settings, fields)=>{
        if (settings.ideaDescription.fieldKey) {
            const descriptionFieldExists = fields.some(({ key: key })=>key === settings.ideaDescription.fieldKey);
            if (!descriptionFieldExists) {
                const { ideaDescription: ideaDescription, ...rest } = settings;
                return rest;
            }
        }
        return settings;
    };
    const $1f66d335a1a40f0e$var$callSharingSettingsServices = async (viewRemote, viewUUID, newSettings, oldSettings)=>{
        const { publicSharingEnabled: newValueOfPublicSharingEnabled, ...incomingSettings } = newSettings;
        const { publicSharingEnabled: oldValueOfPublicSharingEnabled, ...existingSettings } = oldSettings ?? {};
        const requestPromises = [];
        const result = {
            publicAccessChanged: false,
            publishedChanged: false
        };
        if (newValueOfPublicSharingEnabled !== undefined && newValueOfPublicSharingEnabled !== oldValueOfPublicSharingEnabled) {
            requestPromises.push(viewRemote.updatePublicSharingSettings(viewUUID, {
                enabled: newValueOfPublicSharingEnabled
            }));
            result.publicAccessChanged = true;
        }
        if (!(0, ($parcel$interopDefault($ajpes)))(incomingSettings, existingSettings)) {
            requestPromises.push(viewRemote.updateSharingSettings(viewUUID, newSettings));
            result.publishedChanged = true;
        }
        await Promise.all(requestPromises);
        return result;
    };
    const $1f66d335a1a40f0e$var$getSettingsUpdateOutcome = async (prevSettings, newSettings)=>{
        const wasSharedPublicly = prevSettings?.publicSharingEnabled === true && prevSettings?.sharingLinkEnabled === true;
        if (wasSharedPublicly) {
            const willStopBeingShared = newSettings.publicSharingEnabled === false || newSettings?.sharingLinkEnabled === false;
            if (willStopBeingShared) return 'PUBLIC_SHARING_DISABLED';
        } else {
            const combinedPublicSharingSettings = {
                publicSharingEnabled: newSettings.publicSharingEnabled ?? prevSettings?.publicSharingEnabled ?? false,
                sharingLinkEnabled: newSettings.sharingLinkEnabled ?? prevSettings?.sharingLinkEnabled ?? false
            };
            const willBecomeSharedPublicly = combinedPublicSharingSettings.publicSharingEnabled === true && combinedPublicSharingSettings.sharingLinkEnabled === true;
            if (willBecomeSharedPublicly) return 'PUBLIC_SHARING_ENABLED';
        }
        return 'PUBLIC_SHARING_UNCHANGED';
    };
    const $1f66d335a1a40f0e$export$69a9d91d9040f402 = (viewUUID, settings)=>async ({ dispatch: dispatch, getState: getState }, { viewRemote: viewRemote, onActionFailed: onActionFailed, fields: fields = [], createAnalyticsEvent: createAnalyticsEvent })=>{
            const prevSettings = (0, (0, parcelRequire("5cEDG")).getCurrentViewSharingSettings)(getState());
            const newSettings = (0, (0, parcelRequire("co1wz")).ff)('polaris.published-view-public-links_dj5gi') ? $1f66d335a1a40f0e$var$sanitizeSettings(settings, fields) : $1f66d335a1a40f0e$var$getUpdateSettings(settings, fields);
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.updateSettings.start();
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingSettingsForView)(viewUUID, {
                    settings: settings
                }));
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris.published-view-public-links_dj5gi')) {
                    const { publicAccessChanged: publicAccessChanged, publishedChanged: publishedChanged } = await $1f66d335a1a40f0e$var$callSharingSettingsServices(viewRemote, viewUUID, newSettings, prevSettings);
                    const isPublic = newSettings.publicSharingEnabled === true;
                    const isPublished = newSettings.sharingLinkEnabled === true;
                    if (publicAccessChanged) {
                        const eventName = isPublic ? 'view becomesPublic' : 'view becomesNotPublic';
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                            isPublished: isPublished
                        });
                        (0, (0, parcelRequire("1BW2P")).sendPendoTrackEvent)({
                            actionSubjectAndAction: eventName,
                            attributes: {
                                isPublished: isPublished
                            }
                        });
                    }
                    if (publishedChanged) {
                        const eventName = isPublished ? 'view published' : 'view unpublished';
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), eventName, {
                            isPublic: isPublic
                        });
                        (0, (0, parcelRequire("1BW2P")).sendPendoTrackEvent)({
                            actionSubjectAndAction: eventName,
                            attributes: {
                                isPublic: isPublic
                            }
                        });
                    }
                } else await viewRemote.updateSharingSettings(viewUUID, newSettings);
                (0, (0, parcelRequire("eiARp")).experience).sharing.updateSettings.success();
            } catch (error) {
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingSettingsForView)(viewUUID, {
                    settings: prevSettings
                }));
                (0, (0, parcelRequire("eiARp")).experience).sharing.updateSettings.failure(error);
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.update-settings-action', error));
                onActionFailed(error);
            }
            if ((0, (0, parcelRequire("co1wz")).ff)('polaris.publish.replace-view-icon-when-publishing')) {
                const publicSharingControls = (0, (0, parcelRequire("5cEDG")).getPublicSharingControls)(getState());
                const isPublicSharingDisabledByGlobalConfig = publicSharingControls.status === 'disabled' && publicSharingControls.reason === 'global-configuration';
                if (!isPublicSharingDisabledByGlobalConfig) return {
                    publicSharingStatus: await $1f66d335a1a40f0e$var$getSettingsUpdateOutcome(prevSettings, settings)
                };
            }
        };
    const $1f66d335a1a40f0e$export$38e4cff581c355ad = (viewUUID)=>async ({ getState: getState, dispatch: dispatch }, { isSharedView: isSharedView, onLoadFailed: onLoadFailed, onLoadViewComments: onLoadViewComments, viewRemote: viewRemote })=>{
            const isSharingSettingsInitialLoading = (0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingSettingsInitialLoading)(getState());
            const isSharingSettingsLoading = (0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingSettingLoading)(getState());
            if (!isSharingSettingsInitialLoading && isSharingSettingsLoading) return;
            dispatch((0, (0, parcelRequire("5bBlt")).setSharingSettingsForView)(viewUUID, {
                isLoading: true
            }));
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSettings.start();
                const settings = await viewRemote.fetchSharingSettings(viewUUID);
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingSettingsForView)(viewUUID, {
                    settings: settings
                }));
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSettings.success();
                if (isSharedView && settings.showViewComments) onLoadViewComments?.();
            } catch (error) {
                if ((0, (0, parcelRequire("aiePb")).isNotFoundError)(error) || (0, (0, parcelRequire("aiePb")).isClientClosedError)(error) && (0, (0, parcelRequire("4R6GH")).fg)('polaris-ignore-client-closed-error')) (0, (0, parcelRequire("eiARp")).experience).sharing.loadSettings.abort(error);
                else {
                    (0, (0, parcelRequire("eiARp")).experience).sharing.loadSettings.failure(error);
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.load-settings-action', error));
                }
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingSettingsForView)(viewUUID, {
                    settings: undefined,
                    error: error
                }));
                if (isSharedView) onLoadFailed(error);
            }
        };
});
parcelRegister("1BW2P", function(module, exports) {
    $parcel$export(module.exports, "sendPendoTrackEvent", ()=>$76c604c1de726c59$export$c6da4636619f7369);
    $parcel$export(module.exports, "updatePendoVisitorOptions", ()=>$76c604c1de726c59$export$862313c5bc1d6788);
    var $4Jd69;
    const $76c604c1de726c59$var$QUEUE_LIMIT = 50;
    let $76c604c1de726c59$var$queue = [];
    const $76c604c1de726c59$var$interval = setInterval(()=>{
        if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) {
            $76c604c1de726c59$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
            $76c604c1de726c59$var$queue = [];
            clearInterval($76c604c1de726c59$var$interval);
        }
    }, 1000);
    function $76c604c1de726c59$export$c6da4636619f7369(event, properties) {
        let pendoEvent;
        let attributes;
        if (typeof event === 'string') {
            pendoEvent = event;
            attributes = properties;
        } else {
            const fullEvent = [
                event.source,
                event.actionSubjectAndAction,
                event.actionSubjectId
            ].filter((part)=>part !== undefined).join(' - ');
            pendoEvent = fullEvent;
            attributes = event.attributes;
        }
        try {
            if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) window.pendo.track(pendoEvent, attributes);
            else $76c604c1de726c59$var$queue.length < $76c604c1de726c59$var$QUEUE_LIMIT && $76c604c1de726c59$var$queue.push([
                pendoEvent,
                attributes
            ]);
        } catch (err) {
            (0, (0, parcelRequire("4Jd69")).logError)('pendoTrackEvent', err);
        }
    }
    const $76c604c1de726c59$export$862313c5bc1d6788 = (metadata)=>{
        try {
            if ((0, (0, parcelRequire("4Jd69")).isPendoReady)()) window.pendo.updateOptions(metadata);
        } catch (err) {
            (0, (0, parcelRequire("4Jd69")).logError)('pendoUpdateOptions', err);
        }
    };
});
parcelRegister("4Jd69", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$a4ab8bc78cddcb09$export$58da9968c3170cb1);
    $parcel$export(module.exports, "isPendoReady", ()=>$a4ab8bc78cddcb09$export$3f386d356f8c718f);
    var $dJl1T;
    var $jcw0u;
    const $a4ab8bc78cddcb09$export$58da9968c3170cb1 = (errorSubject, error)=>{
        const ERROR_ID = 'polaris-error';
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: ERROR_ID,
                teamName: 'polaris'
            },
            attributes: {
                subject: errorSubject
            },
            error: error
        });
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(`${ERROR_ID}.${errorSubject}`, error.message, error);
    };
    const $a4ab8bc78cddcb09$export$3f386d356f8c718f = ()=>window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();
});
parcelRegister("5cEDG", function(module, exports) {
    $parcel$export(module.exports, "getIsSharingSiteConfigLoading", ()=>$b28b004245684760$export$c9bef8b7e68b15aa);
    $parcel$export(module.exports, "getIsSitePublicSharingLoading", ()=>$b28b004245684760$export$e6d8b7b929ecf8e8);
    $parcel$export(module.exports, "getIsSitePublicSharingEnabled", ()=>$b28b004245684760$export$80cfe27fbdebd361);
    $parcel$export(module.exports, "getIsCurrentViewPublicSharingEnabled", ()=>$b28b004245684760$export$9da2ae248c7e3039);
    $parcel$export(module.exports, "getProjectAccessLevel", ()=>$b28b004245684760$export$f5f97c28ee230e06);
    $parcel$export(module.exports, "getIsSharingOnSiteEnabled", ()=>$b28b004245684760$export$2a292862c2d52f48);
    $parcel$export(module.exports, "getCurrentViewSharingSettings", ()=>$b28b004245684760$export$731dc0886ad97eeb);
    $parcel$export(module.exports, "getPublicSharingControls", ()=>$b28b004245684760$export$188eeb7105615837);
    $parcel$export(module.exports, "getCurrentViewSharingStakeholders", ()=>$b28b004245684760$export$65f25f8b5bc681f);
    $parcel$export(module.exports, "getIsCurrentViewSharingSettingLoading", ()=>$b28b004245684760$export$6f058b53c796dd7a);
    $parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersLoading", ()=>$b28b004245684760$export$ff4eae65813c5f5e);
    $parcel$export(module.exports, "getIsCurrentViewSharingSettingsInitialLoading", ()=>$b28b004245684760$export$9fc5badc0a169630);
    $parcel$export(module.exports, "getIsCurrentViewSharingStakeholdersInitialLoading", ()=>$b28b004245684760$export$5b5786000e919f7);
    $parcel$export(module.exports, "getIsCurrentViewSharingInitialLoading", ()=>$b28b004245684760$export$787ffe6cfb2ef381);
    $parcel$export(module.exports, "getIdeaDescriptionFieldKey", ()=>$b28b004245684760$export$7b92127bf4e36b2d);
    $parcel$export(module.exports, "getCurrentViewSharingLinkEnabled", ()=>$b28b004245684760$export$3b2e0cd80d69f473);
    $parcel$export(module.exports, "hasCurrentViewSharingSettingsError", ()=>$b28b004245684760$export$57ba084aec18bf70);
    $parcel$export(module.exports, "hasCurrentViewSharingError", ()=>$b28b004245684760$export$a11d8d14f5a90504);
    $parcel$export(module.exports, "getIsPublishDialogContentLoading", ()=>$b28b004245684760$export$b74c50d75ffb3249);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $b28b004245684760$var$getCurrentViewUUID = (state)=>state.containerProps?.viewUUID;
    const $b28b004245684760$var$getViewsSharingSettings = (state)=>state.sharingSettings;
    const $b28b004245684760$var$getViewsSharingStakeholders = (state)=>state.sharingStakeholders;
    const $b28b004245684760$var$getPermissions = (state)=>state.permissions;
    const $b28b004245684760$var$getCurrentViewSettings = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewUUID, $b28b004245684760$var$getViewsSharingSettings, (viewUUID, sharingSettings)=>viewUUID ? sharingSettings[viewUUID] : undefined);
    const $b28b004245684760$var$getCurrentViewStakeholders = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewUUID, $b28b004245684760$var$getViewsSharingStakeholders, (viewUUID, sharingStakeholders)=>viewUUID ? sharingStakeholders[viewUUID] : undefined);
    const $b28b004245684760$var$getSharingSiteConfig = (state)=>state.siteConfig;
    const $b28b004245684760$export$c9bef8b7e68b15aa = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSharingSiteConfig, (config)=>config.isLoading);
    const $b28b004245684760$var$getSitePublicSharingConfig = (state)=>state.sitePublicSharingConfig;
    const $b28b004245684760$export$e6d8b7b929ecf8e8 = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSitePublicSharingConfig, ({ isLoading: isLoading })=>isLoading);
    const $b28b004245684760$export$80cfe27fbdebd361 = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSitePublicSharingConfig, ({ isEnabled: isEnabled })=>isEnabled);
    const $b28b004245684760$var$getSitePublicSharingError = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSitePublicSharingConfig, ({ error: error })=>error);
    const $b28b004245684760$export$9da2ae248c7e3039 = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewSettings, (sharing)=>sharing?.settings?.publicSharingEnabled === true);
    const $b28b004245684760$export$f5f97c28ee230e06 = (state)=>state.projectAccessLevel;
    const $b28b004245684760$var$getSharingSiteConfigError = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSharingSiteConfig, (config)=>config.error);
    const $b28b004245684760$export$2a292862c2d52f48 = (0, $dGvGJ.createSelector)($b28b004245684760$var$getSharingSiteConfig, (config)=>config.isEnabled);
    const $b28b004245684760$export$731dc0886ad97eeb = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewSettings, $b28b004245684760$export$f5f97c28ee230e06, (sharing, projectAccessLevel)=>{
        if (!sharing?.settings) return;
        const { settings: settings } = sharing;
        const hasSiteAccessLevel = projectAccessLevel && [
            'OPEN',
            'LIMITED'
        ].includes(projectAccessLevel);
        return {
            ...settings,
            generalAccessLevel: hasSiteAccessLevel ? (0, $b902ad3bd2c89c9b$export$41147fc9605520e9) : settings.generalAccessLevel
        };
    });
    const $b28b004245684760$export$188eeb7105615837 = (0, $dGvGJ.createSelector)([
        $b28b004245684760$export$80cfe27fbdebd361,
        $b28b004245684760$var$getPermissions
    ], (isSitePublicSharingEnabled, permissions)=>{
        if (isSitePublicSharingEnabled === false) return {
            status: 'disabled',
            reason: 'global-configuration'
        };
        if (permissions?.canPublishPublicDiscoveryViews !== true) return {
            status: 'disabled',
            reason: 'missing-permissions'
        };
        return {
            status: 'enabled'
        };
    });
    const $b28b004245684760$export$65f25f8b5bc681f = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewStakeholders, (sharing)=>sharing?.stakeholders);
    const $b28b004245684760$export$6f058b53c796dd7a = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewSettings, (sharingSettings)=>sharingSettings?.isLoading !== false);
    const $b28b004245684760$export$ff4eae65813c5f5e = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewStakeholders, (sharingStakeholders)=>sharingStakeholders?.isLoading !== false);
    const $b28b004245684760$export$9fc5badc0a169630 = (0, $dGvGJ.createSelector)($b28b004245684760$export$6f058b53c796dd7a, $b28b004245684760$export$731dc0886ad97eeb, (isLoading, settings)=>isLoading && settings === undefined);
    const $b28b004245684760$export$5b5786000e919f7 = (0, $dGvGJ.createSelector)($b28b004245684760$export$ff4eae65813c5f5e, $b28b004245684760$export$65f25f8b5bc681f, (isLoading, stakeholders)=>isLoading && stakeholders === undefined);
    const $b28b004245684760$export$787ffe6cfb2ef381 = (0, $dGvGJ.createSelector)($b28b004245684760$export$9fc5badc0a169630, $b28b004245684760$export$5b5786000e919f7, (isSettingsInitialLoading, isStakeholdersInitialLoading)=>isSettingsInitialLoading || isStakeholdersInitialLoading);
    const $b28b004245684760$export$7b92127bf4e36b2d = (0, $dGvGJ.createSelector)($b28b004245684760$export$731dc0886ad97eeb, (settings)=>settings?.ideaDescription.fieldKey);
    const $b28b004245684760$export$3b2e0cd80d69f473 = (0, $dGvGJ.createSelector)($b28b004245684760$export$731dc0886ad97eeb, (settings)=>settings?.sharingLinkEnabled);
    const $b28b004245684760$export$57ba084aec18bf70 = (0, $dGvGJ.createSelector)($b28b004245684760$var$getCurrentViewSettings, $b28b004245684760$var$getSharingSiteConfigError, $b28b004245684760$var$getSitePublicSharingError, (sharingSettings, siteConfigError, sitePublicSharingError)=>sharingSettings?.error && sharingSettings.error.statusCode !== 404 || siteConfigError !== undefined || sitePublicSharingError !== undefined);
    const $b28b004245684760$export$a11d8d14f5a90504 = (0, $dGvGJ.createSelector)($b28b004245684760$export$57ba084aec18bf70, $b28b004245684760$var$getCurrentViewStakeholders, (hasSettingsError, sharingStakeholders)=>sharingStakeholders?.error && sharingStakeholders.error.statusCode !== 404 || hasSettingsError);
    const $b28b004245684760$export$b74c50d75ffb3249 = (0, $dGvGJ.createSelector)($b28b004245684760$export$2a292862c2d52f48, $b28b004245684760$export$80cfe27fbdebd361, $b28b004245684760$export$787ffe6cfb2ef381, $b28b004245684760$export$c9bef8b7e68b15aa, $b28b004245684760$export$e6d8b7b929ecf8e8, (isSharingEnabledOnSite, isSitePublicSharingEnabled, isSharingInitialLoading, isSharingSiteConfigLoading, isSitePublicSharingLoading)=>isSharingEnabledOnSite && isSitePublicSharingEnabled && isSharingInitialLoading || isSharingSiteConfigLoading || isSitePublicSharingLoading);
});
const $b902ad3bd2c89c9b$export$41147fc9605520e9 = 'SITE';
const $b902ad3bd2c89c9b$export$137f231420cea7e9 = 'PROJECT';
parcelRegister("5bBlt", function(module, exports) {
    $parcel$export(module.exports, "setSharingSettingsForView", ()=>$672643b96e8e26cf$export$eb537ef0ff4cef7b);
    $parcel$export(module.exports, "setSharingStakeholdersForView", ()=>$672643b96e8e26cf$export$efe3b3704c70e658);
    const $672643b96e8e26cf$export$eb537ef0ff4cef7b = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const viewSharingToUpdate = state.sharingSettings[viewUUID];
            setState({
                sharingSettings: {
                    ...state.sharingSettings,
                    [viewUUID]: {
                        isLoading: sharing.isLoading || false,
                        settings: sharing.settings || viewSharingToUpdate?.settings,
                        error: sharing.error
                    }
                }
            });
        };
    const $672643b96e8e26cf$export$efe3b3704c70e658 = (viewUUID, sharing = {})=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const viewSharingToUpdate = state.sharingStakeholders[viewUUID];
            setState({
                sharingStakeholders: {
                    ...state.sharingStakeholders,
                    [viewUUID]: {
                        isLoading: sharing.isLoading || false,
                        stakeholders: sharing.stakeholders || viewSharingToUpdate?.stakeholders,
                        error: sharing.error
                    }
                }
            });
        };
});
parcelRegister("6AMVG", function(module, exports) {
    $parcel$export(module.exports, "loadSharingSiteConfig", ()=>$8a9a584bacf1b908$export$85c251450f7886f9);
    var $jcw0u;
    var $eiARp;
    var $1As78;
    var $aiePb;
    var $ks1lh;
    const $8a9a584bacf1b908$export$85c251450f7886f9 = ()=>async ({ setState: setState }, { isSharedView: isSharedView })=>{
            if (isSharedView) {
                setState({
                    siteConfig: {
                        isEnabled: true,
                        isLoading: false,
                        error: undefined
                    }
                });
                return;
            }
            setState({
                siteConfig: {
                    isEnabled: false,
                    isLoading: true,
                    error: undefined
                }
            });
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSiteConfig.start();
                const { enabled: enabled } = await (0, (0, parcelRequire("ks1lh")).fetchSiteSharingConfig)();
                setState({
                    siteConfig: {
                        isEnabled: enabled,
                        isLoading: false,
                        error: undefined
                    }
                });
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadSiteConfig.success();
            } catch (error) {
                setState({
                    siteConfig: {
                        isEnabled: false,
                        isLoading: false,
                        error: error
                    }
                });
                if ((0, (0, parcelRequire("aiePb")).isPermissionError)(error) || (0, (0, parcelRequire("aiePb")).isNotFoundError)(error)) (0, (0, parcelRequire("eiARp")).experience).sharing.loadSiteConfig.abort(error);
                else {
                    (0, (0, parcelRequire("eiARp")).experience).sharing.loadSiteConfig.failure(error);
                    (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.load-sharing-site-config-action', error));
                }
            }
        };
});
parcelRegister("GdbJn", function(module, exports) {
    $parcel$export(module.exports, "loadSharingStakeholders", ()=>$ec87e8704a27c417$export$98e678eadf48ced1);
    $parcel$export(module.exports, "addSharingStakeholders", ()=>$ec87e8704a27c417$export$60473b7d5ed25db0);
    $parcel$export(module.exports, "removeSharingStakeholders", ()=>$ec87e8704a27c417$export$4938ea46db8995e9);
    var $jcw0u;
    var $eiARp;
    var $1BW2P;
    var $1As78;
    var $8zOmE;
    var $5cEDG;
    var $5bBlt;
    const $ec87e8704a27c417$export$98e678eadf48ced1 = (viewUUID, { viewAri: viewAri, viewKind: viewKind })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, createAnalyticsEvent: createAnalyticsEvent })=>{
            const isSharingStakeholdersLoading = (0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingStakeholdersLoading)(getState());
            const isSharingStakeholdersInitialLoading = (0, (0, parcelRequire("5cEDG")).getIsCurrentViewSharingStakeholdersInitialLoading)(getState());
            if (!isSharingStakeholdersInitialLoading && isSharingStakeholdersLoading) return;
            dispatch((0, (0, parcelRequire("5bBlt")).setSharingStakeholdersForView)(viewUUID, {
                isLoading: true
            }));
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadStakeholders.start();
                const stakeholders = await viewRemote.fetchSharingStakeholders(viewUUID);
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingStakeholdersForView)(viewUUID, {
                    stakeholders: stakeholders
                }));
                const sharingLinkEnabled = (0, (0, parcelRequire("5cEDG")).getCurrentViewSharingLinkEnabled)(getState());
                const analyticsAttributes = {
                    stakeholdersCount: stakeholders.users.length,
                    groupsCount: stakeholders.groups.length,
                    isPublished: sharingLinkEnabled === true
                };
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                    containers: {
                        view: {
                            id: viewAri || '',
                            type: viewKind?.toLowerCase() || ''
                        }
                    }
                }), 'stakeholdersList loaded', analyticsAttributes);
                (0, (0, parcelRequire("1BW2P")).sendPendoTrackEvent)({
                    actionSubjectAndAction: 'stakeholdersList loaded',
                    attributes: analyticsAttributes
                });
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadStakeholders.success();
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.load-stakeholders-action', error));
                (0, (0, parcelRequire("eiARp")).experience).sharing.loadStakeholders.failure(error);
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingStakeholdersForView)(viewUUID, {
                    stakeholders: undefined,
                    error: error
                }));
            }
        };
    const $ec87e8704a27c417$export$60473b7d5ed25db0 = (viewUUID, { accountIds: accountIds, emails: emails, groupIds: groupIds }, viewAnalyticsData)=>async ({ dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.addStakeholders.start();
                const { failures: failures } = await viewRemote.addSharingStakeholders(viewUUID, {
                    accountIds: accountIds,
                    emails: emails,
                    groupIds: groupIds
                });
                await dispatch($ec87e8704a27c417$export$98e678eadf48ced1(viewUUID, viewAnalyticsData));
                (0, (0, parcelRequire("eiARp")).experience).sharing.addStakeholders.success();
                return [
                    ...failures?.accountIds || [],
                    ...failures?.emails || []
                ];
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.add-stakeholders-action', error));
                (0, (0, parcelRequire("eiARp")).experience).sharing.addStakeholders.failure(error);
                onActionFailed(error);
                return [
                    ...accountIds,
                    ...emails,
                    ...groupIds
                ];
            }
        };
    const $ec87e8704a27c417$export$4938ea46db8995e9 = (viewUUID, { accountIds: accountIds, groupIds: groupIds })=>async ({ getState: getState, dispatch: dispatch }, { viewRemote: viewRemote, onActionFailed: onActionFailed })=>{
            const state = getState();
            const stakeholders = state.sharingStakeholders[viewUUID]?.stakeholders;
            if (!stakeholders) return;
            try {
                (0, (0, parcelRequire("eiARp")).experience).sharing.removeStakeholders.start();
                await viewRemote.removeSharingStakeholders(viewUUID, {
                    accountIds: accountIds,
                    groupIds: groupIds
                });
                dispatch((0, (0, parcelRequire("5bBlt")).setSharingStakeholdersForView)(viewUUID, {
                    stakeholders: {
                        users: stakeholders.users.filter(({ id: id })=>!accountIds.includes(id)),
                        groups: stakeholders.groups.filter(({ id: id })=>!groupIds.includes(id))
                    }
                }));
                (0, (0, parcelRequire("eiARp")).experience).sharing.removeStakeholders.success();
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.remove-stakeholders-action', error));
                (0, (0, parcelRequire("eiARp")).experience).sharing.removeStakeholders.failure(error);
                onActionFailed(error);
            }
        };
});
parcelRegister("aOR78", function(module, exports) {
    $parcel$export(module.exports, "deletePublishedView", ()=>$4069cc59176d565b$export$221f60f553707aa8);
    var $jcw0u;
    var $1As78;
    const $4069cc59176d565b$export$221f60f553707aa8 = (viewUUID)=>async (_, { viewRemote: viewRemote })=>{
            try {
                await viewRemote.deletePublishedView(viewUUID);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)((0, (0, parcelRequire("1As78")).createErrorAnalytics)('polaris.view-sharing.delete-published-view-action', error));
            }
        };
});
parcelRegister("DHjM0", function(module, exports) {
    $parcel$export(module.exports, "setQuery", ()=>(parcelRequire("fvIsF")).setQuery);
    $parcel$export(module.exports, "routeTo", ()=>(parcelRequire("cEpGT")).routeTo);
    $parcel$export(module.exports, "updateDebouncedRouterActions", ()=>(parcelRequire("53DcZ")).updateDebouncedRouterActions);
    $parcel$export(module.exports, "init", ()=>(parcelRequire("14GyY")).init);
    $parcel$export(module.exports, "closeIssueView", ()=>(parcelRequire("aZGMU")).closeIssueView);
    $parcel$export(module.exports, "openIssueView", ()=>(parcelRequire("gwcq0")).openIssueView);
    var $fvIsF;
    var $cEpGT;
    var $53DcZ;
    var $14GyY;
    var $aZGMU;
    var $gwcq0;
});
parcelRegister("fvIsF", function(module, exports) {
    $parcel$export(module.exports, "setQuery", ()=>$18259e130252c9cb$export$f3b215b0b382f63b);
    var $ajpes = parcelRequire("ajpes");
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $9YiOu;
    var $ba0OE;
    const $18259e130252c9cb$export$f3b215b0b382f63b = (newQuery, updateMethod = 'push')=>({ getState: getState })=>{
            const currentQuery = (0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector)(getState());
            if ((0, ($parcel$interopDefault($ajpes)))((0, ($parcel$interopDefault($9xWGk)))(currentQuery, (0, ($parcel$interopDefault($cjFoH)))), (0, ($parcel$interopDefault($9xWGk)))(newQuery, (0, ($parcel$interopDefault($cjFoH)))))) return;
            const updatedQuery = newQuery === undefined ? {} : {
                ...currentQuery,
                ...newQuery
            };
            if (updateMethod === 'push') (0, (0, parcelRequire("ba0OE")).default).push(null, updatedQuery);
            else if (updateMethod === 'replace') (0, (0, parcelRequire("ba0OE")).default).replace(null, updatedQuery);
        };
});
parcelRegister("9YiOu", function(module, exports) {
    $parcel$export(module.exports, "getCurrentRouteSelector", ()=>$09b84c54d06d4b60$export$6ed54c4577135f20);
    $parcel$export(module.exports, "getCurrentRouteSectionSelector", ()=>$09b84c54d06d4b60$export$e89b8890e02ec45e);
    $parcel$export(module.exports, "getPolarisQuerySelector", ()=>$09b84c54d06d4b60$export$22f15478f7158013);
    $parcel$export(module.exports, "getFullscreenQueryParameter", ()=>$09b84c54d06d4b60$export$2f80254b69843b80);
    $parcel$export(module.exports, "getSelectedIssueQueryParameter", ()=>$09b84c54d06d4b60$export$98dec4fb5dc92495);
    $parcel$export(module.exports, "getIssueViewLayout", ()=>$09b84c54d06d4b60$export$bef822310ccdf5ea);
    $parcel$export(module.exports, "getIsIssueOpenInFullscreen", ()=>$09b84c54d06d4b60$export$654211dcd797740);
    $parcel$export(module.exports, "getIsIssueOpenInSidebar", ()=>$09b84c54d06d4b60$export$2f14425c0214c341);
    $parcel$export(module.exports, "getIssueViewSection", ()=>$09b84c54d06d4b60$export$efd29462b8885d3b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $aXZGL;
    const $09b84c54d06d4b60$export$52f9a505981b3b1a = (state)=>state.containerProps;
    const $09b84c54d06d4b60$var$getConfiguredRouteSelector = (0, $dGvGJ.createSelector)((state)=>state.containerProps?.resource, (state)=>state.containerProps?.section, (state)=>state.routeFromStorage, (resource, section, routeFromStorage)=>{
        if (section !== undefined && section !== null) return {
            section: section,
            resource: resource
        };
        return routeFromStorage;
    });
    const $09b84c54d06d4b60$var$getDefaultRouteSelector = (0, $dGvGJ.createSelector)((state)=>state.containerProps?.defaultSection, (state)=>state.containerProps?.defaultResource, (section, resource)=>({
            section: section || (0, $41a08749b0faf83e$export$4fce57eba3db1f42),
            resource: resource
        }));
    const $09b84c54d06d4b60$var$getHasSelectedIssueQueryParameter = (0, $dGvGJ.createSelector)((state)=>state.containerProps?.query.selectedIssue, (selectedIssue)=>selectedIssue !== undefined && !!(0, (0, parcelRequire("aXZGL")).POLARIS_QUERY_VALID_VALUES).selectedIssue(selectedIssue));
    const $09b84c54d06d4b60$export$6ed54c4577135f20 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$var$getDefaultRouteSelector, $09b84c54d06d4b60$var$getConfiguredRouteSelector, $09b84c54d06d4b60$var$getHasSelectedIssueQueryParameter, (state)=>state.containerProps?.allowedSections, (defaultRoute, configuredRoute, hasSelectedIssueQueryParam, allowedSections)=>{
        if (configuredRoute !== undefined && configuredRoute.section !== undefined && allowedSections?.includes(configuredRoute.section) && !(configuredRoute.section !== (0, $41a08749b0faf83e$export$4fce57eba3db1f42) && hasSelectedIssueQueryParam)) return configuredRoute;
        return defaultRoute;
    });
    const $09b84c54d06d4b60$export$e89b8890e02ec45e = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$6ed54c4577135f20, (currentRoute)=>currentRoute.section);
    const $09b84c54d06d4b60$var$getQueryValidValues = (state)=>state.containerProps?.queryValidValues;
    const $09b84c54d06d4b60$export$22f15478f7158013 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$var$getQueryValidValues, (0, $dGvGJ.createStructuredSelector)(Object.keys((0, (0, parcelRequire("aXZGL")).POLARIS_QUERY_VALID_VALUES)).reduce((result, key)=>Object.assign(result, {
            [key]: (0, $dGvGJ.createSelector)((state)=>state.containerProps?.query[key], (queryValue)=>{
                if (!queryValue) return undefined;
                const validator = (0, (0, parcelRequire("aXZGL")).POLARIS_QUERY_VALID_VALUES)[key];
                return validator(queryValue) ? queryValue : undefined;
            })
        }), {})), (queryValidValues, values)=>{
        const query = {};
        if (!queryValidValues) return query;
        return Object.keys(queryValidValues).reduce((result, key)=>{
            if (values[key] !== undefined) return Object.assign(result, {
                [key]: values[key]
            });
            return result;
        }, query);
    });
    const $09b84c54d06d4b60$export$3c0b42d742ff4f88 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$22f15478f7158013, (query)=>query.issueViewLayout);
    const $09b84c54d06d4b60$export$12070c9eae7402b0 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$22f15478f7158013, (query)=>query.issueViewSection);
    const $09b84c54d06d4b60$export$2f80254b69843b80 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$22f15478f7158013, (query)=>query.fullscreen === 'true');
    const $09b84c54d06d4b60$export$98dec4fb5dc92495 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$22f15478f7158013, (query)=>query.selectedIssue);
    const $09b84c54d06d4b60$export$bef822310ccdf5ea = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$3c0b42d742ff4f88, (issueViewLayout)=>issueViewLayout === (0, (0, parcelRequire("aXZGL")).POLARIS_QUERY_ISSUE_VIEW_SIDEBAR) ? issueViewLayout : undefined);
    const $09b84c54d06d4b60$export$654211dcd797740 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$bef822310ccdf5ea, $09b84c54d06d4b60$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout === undefined && selectedIssue !== undefined);
    const $09b84c54d06d4b60$export$2f14425c0214c341 = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$bef822310ccdf5ea, $09b84c54d06d4b60$export$98dec4fb5dc92495, (issueViewLayout, selectedIssue)=>issueViewLayout !== undefined && selectedIssue !== undefined);
    const $09b84c54d06d4b60$export$efd29462b8885d3b = (0, $dGvGJ.createSelector)($09b84c54d06d4b60$export$2f14425c0214c341, $09b84c54d06d4b60$export$12070c9eae7402b0, $09b84c54d06d4b60$export$98dec4fb5dc92495, (isIssueOpenInSidebar, issueViewSection, selectedIssue)=>{
        if (selectedIssue === undefined) return undefined;
        return isIssueOpenInSidebar ? issueViewSection ?? (0, (0, parcelRequire("aXZGL")).DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR) : issueViewSection ?? (0, (0, parcelRequire("aXZGL")).DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
    });
});
const $41a08749b0faf83e$export$4fce57eba3db1f42 = 'view';
parcelRegister("aXZGL", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR", ()=>$6c98a6755818ffc4$export$fc856e90af6063b7);
    $parcel$export(module.exports, "DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN", ()=>$6c98a6755818ffc4$export$44ed4fbe898cb41a);
    $parcel$export(module.exports, "POLARIS_QUERY_ISSUE_VIEW_SIDEBAR", ()=>$6c98a6755818ffc4$export$66d4646147c88e69);
    $parcel$export(module.exports, "POLARIS_QUERY_VALID_VALUES", ()=>$6c98a6755818ffc4$export$f6bbbc8ed0d13331);
    const $6c98a6755818ffc4$export$fc856e90af6063b7 = 'overview';
    const $6c98a6755818ffc4$export$44ed4fbe898cb41a = 'comments';
    const $6c98a6755818ffc4$export$66d4646147c88e69 = 'sidebar';
    const $6c98a6755818ffc4$export$739b790c57338820 = [
        'overview',
        'capture',
        'comments',
        'deliver',
        'history'
    ].reduce((result, section)=>Object.assign(result, {
            [section]: true
        }), {});
    const $6c98a6755818ffc4$export$f6bbbc8ed0d13331 = {
        selectedIssue: (value)=>typeof value === 'string',
        issueViewLayout: (value)=>value === $6c98a6755818ffc4$export$66d4646147c88e69,
        issueViewSection: (value)=>$6c98a6755818ffc4$export$739b790c57338820[value],
        fullscreen: (value)=>value === 'true',
        viewCommentId: (value)=>typeof value === 'string',
        previewRole: (value)=>typeof value === 'string',
        landingViewRank: (value)=>typeof value === 'string',
        openIdeaCreationModal: (value)=>value === 'true'
    };
    const $6c98a6755818ffc4$export$e8a474851aa3ed4a = [
        'landingViewRank'
    ];
});
parcelRegister("ba0OE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbb47c8c3b213e97$export$2e2bcd8739ae039);
    var $kHzJt;
    class $cbb47c8c3b213e97$export$843577d117cf4ba3 {
        constructor(){
            this.pushTimeout = undefined;
            this.replaceTimeout = undefined;
            this.currentPath = undefined;
            this.currentQuery = undefined;
            this.newPath = undefined;
            this.newQuery = undefined;
            this.nativePush = undefined;
            this.nativeReplace = undefined;
        }
        setCurrentState(currentPath, currentQuery) {
            this.currentPath = currentPath;
            this.currentQuery = currentQuery;
        }
        setNativeRouterMethods(nativePush, nativeReplace) {
            this.nativePush = nativePush;
            this.nativeReplace = nativeReplace;
        }
        setNewState(newPath, newQuery) {
            this.newQuery = newQuery ?? this.newQuery ?? this.currentQuery ?? {};
            this.newPath = newPath ?? this.newPath ?? this.currentPath;
        }
        resetNewState() {
            this.newQuery = undefined;
            this.newPath = undefined;
        }
        getNewUrl() {
            return `${this.newPath ?? ''}${(0, (0, parcelRequire("kHzJt")).createQueryStringPostfix)(this.newQuery ?? {})}`;
        }
        clearTimeouts() {
            clearTimeout(this.pushTimeout);
            clearTimeout(this.replaceTimeout);
        }
        push(newPath, newQuery) {
            this.setNewState(newPath, newQuery);
            this.clearTimeouts();
            this.pushTimeout = setTimeout(()=>{
                this.pushTimeout = undefined;
                this.nativePush?.(this.getNewUrl());
                this.resetNewState();
            }, 0);
        }
        replace(newPath, newQuery) {
            this.setNewState(newPath, newQuery);
            this.clearTimeouts();
            this.replaceTimeout = setTimeout(()=>{
                this.replaceTimeout = undefined;
                this.nativeReplace?.(this.getNewUrl());
                this.resetNewState();
            }, 0);
        }
    }
    const $cbb47c8c3b213e97$var$debouncedRouterActions = new $cbb47c8c3b213e97$export$843577d117cf4ba3();
    var $cbb47c8c3b213e97$export$2e2bcd8739ae039 = $cbb47c8c3b213e97$var$debouncedRouterActions;
});
parcelRegister("kHzJt", function(module, exports) {
    $parcel$export(module.exports, "createQueryStringPostfix", ()=>$0f9d254adc46f921$export$c6cd7780eb5a242f);
    var $6ov1M = parcelRequire("6ov1M");
    var $27NS3 = parcelRequire("27NS3");
    const $0f9d254adc46f921$export$c6cd7780eb5a242f = (query, keysToDrop)=>{
        const paramsList = (0, ($parcel$interopDefault($27NS3)))(query, (agg, val, key)=>{
            if (val === undefined || keysToDrop && keysToDrop.includes(key)) return agg;
            return [
                ...agg,
                `${key}=${val}`
            ];
        }, []);
        if (paramsList.length === 0) return '';
        const flatGetParams = (0, ($parcel$interopDefault($6ov1M)))(paramsList, '&');
        return `?${flatGetParams}`;
    };
});
parcelRegister("6ov1M", function(module, exports) {
    var $4a7d0d67f8ea04be$var$arrayProto = Array.prototype;
    var $4a7d0d67f8ea04be$var$nativeJoin = $4a7d0d67f8ea04be$var$arrayProto.join;
    function $4a7d0d67f8ea04be$var$join(array, separator) {
        return array == null ? '' : $4a7d0d67f8ea04be$var$nativeJoin.call(array, separator);
    }
    module.exports = $4a7d0d67f8ea04be$var$join;
});
parcelRegister("27NS3", function(module, exports) {
    var $2YkAc = parcelRequire("2YkAc");
    var $e7pfQ = parcelRequire("e7pfQ");
    var $bxDef = parcelRequire("bxDef");
    var $87mh8 = parcelRequire("87mh8");
    var $8LQ84 = parcelRequire("8LQ84");
    function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
        var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
        return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
    }
    module.exports = $18c2eb891b6f17d9$var$reduce;
});
parcelRegister("87mh8", function(module, exports) {
    function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    module.exports = $5e90419f1ca7764f$var$baseReduce;
});
parcelRegister("cEpGT", function(module, exports) {
    $parcel$export(module.exports, "routeTo", ()=>$c2b42f295b52eb5f$export$7464a66e30a44643);
    var $9YiOu;
    var $ba0OE;
    var $kHzJt;
    var $2mPb7;
    const $c2b42f295b52eb5f$export$7464a66e30a44643 = (route, params)=>({ getState: getState }, { getAppUrl: getAppUrl, storageKey: storageKey, useNativeReplaceMethod: useNativeReplaceMethod })=>{
            const routeParams = {
                clearParameters: true,
                replaceInHistory: false,
                saveStorageRouteSlug: true,
                ...params
            };
            const { clearParameters: clearParameters, replaceInHistory: replaceInHistory, saveStorageRouteSlug: saveStorageRouteSlug } = routeParams;
            const currentRoute = (0, (0, parcelRequire("9YiOu")).getCurrentRouteSelector)(getState());
            const currentQuery = (0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector)(getState());
            if (route.section === currentRoute.section && route.resource === currentRoute.resource) return;
            const url = `${getAppUrl(route)}${clearParameters ? '' : (0, (0, parcelRequire("kHzJt")).createQueryStringPostfix)(currentQuery)}`;
            if (replaceInHistory) useNativeReplaceMethod(url);
            else (0, (0, parcelRequire("ba0OE")).default).push(getAppUrl(route), clearParameters ? {} : undefined);
            if (saveStorageRouteSlug && storageKey !== undefined) (0, (0, parcelRequire("2mPb7")).setStorageRouteSlug)({
                ...route,
                storageKey: storageKey
            });
        };
});
parcelRegister("2mPb7", function(module, exports) {
    $parcel$export(module.exports, "setStorageRouteSlug", ()=>$f8dc056637d967cf$export$a22fe837277f4dd0);
    $parcel$export(module.exports, "getStorageRouteSlugWithLegacySupport", ()=>$f8dc056637d967cf$export$ca6a8f450b3093a6);
    var $bSSG7;
    const $f8dc056637d967cf$var$storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('polaris');
    const $f8dc056637d967cf$export$a22fe837277f4dd0 = (route)=>{
        $f8dc056637d967cf$var$storage.set('routeslug', route);
    };
    const $f8dc056637d967cf$export$ca6a8f450b3093a6 = ()=>{
        const localRouteSlug = $f8dc056637d967cf$var$storage.get('routeslug');
        if (localRouteSlug !== null && localRouteSlug !== undefined) return localRouteSlug;
        const legacyLocalRouteSlug = $f8dc056637d967cf$var$storage.get('viewslug');
        if (legacyLocalRouteSlug !== null && legacyLocalRouteSlug !== undefined) return {
            section: legacyLocalRouteSlug.section,
            resource: legacyLocalRouteSlug.id
        };
        return undefined;
    };
});
parcelRegister("53DcZ", function(module, exports) {
    $parcel$export(module.exports, "updateDebouncedRouterActions", ()=>$e66d4bdbc39c05ec$export$e203da31a87d8a65);
    var $9YiOu;
    var $ba0OE;
    const $e66d4bdbc39c05ec$export$e203da31a87d8a65 = ()=>({ getState: getState }, { getAppUrl: getAppUrl, useNativePushMethod: useNativePushMethod, useNativeReplaceMethod: useNativeReplaceMethod })=>{
            (0, (0, parcelRequire("ba0OE")).default).setNativeRouterMethods(useNativePushMethod, useNativeReplaceMethod);
            const currentQuery = (0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector)(getState());
            const currentRoute = (0, (0, parcelRequire("9YiOu")).getCurrentRouteSelector)(getState());
            const path = getAppUrl?.(currentRoute);
            if (getAppUrl !== undefined) (0, (0, parcelRequire("ba0OE")).default).setCurrentState(path, currentQuery);
        };
});
parcelRegister("14GyY", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$147984b5a56397b3$export$2cd8252107eb640b);
    var $9YiOu;
    var $kHzJt;
    var $2mPb7;
    const $147984b5a56397b3$export$2cd8252107eb640b = ()=>({ getState: getState, setState: setState }, { getAppUrl: getAppUrl, storageKey: storageKey, section: section, useNativeReplaceMethod: useNativeReplaceMethod })=>{
            const storage = (0, (0, parcelRequire("2mPb7")).getStorageRouteSlugWithLegacySupport)();
            if (storage && storage.storageKey === storageKey) {
                setState({
                    routeFromStorage: {
                        section: storage.section,
                        resource: storage.resource
                    }
                });
                const currentQuery = (0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector)(getState());
                if (storage === undefined || section !== undefined || storage.section === 'settings' && storage.resource === 'workflow' || storage.section !== (0, $41a08749b0faf83e$export$4fce57eba3db1f42) && currentQuery.selectedIssue || storage.storageKey !== undefined && storage.storageKey !== storageKey || storageKey === undefined || getAppUrl === undefined) return;
                useNativeReplaceMethod(`${getAppUrl({
                    resource: storage.resource,
                    section: storage.section
                })}${(0, (0, parcelRequire("kHzJt")).createQueryStringPostfix)(currentQuery)}`);
            }
        };
});
parcelRegister("aZGMU", function(module, exports) {
    $parcel$export(module.exports, "closeIssueView", ()=>$33b51f53b83016d7$export$ba15dd71fa7afe95);
    var $fvIsF;
    const $33b51f53b83016d7$export$ba15dd71fa7afe95 = ()=>({ dispatch: dispatch })=>{
            dispatch((0, (0, parcelRequire("fvIsF")).setQuery)({
                selectedIssue: undefined,
                issueViewLayout: undefined,
                issueViewSection: undefined,
                viewCommentId: undefined
            }));
        };
});
parcelRegister("gwcq0", function(module, exports) {
    $parcel$export(module.exports, "openIssueView", ()=>$065df2967a66e91f$export$611cbcf98e4cfb6e);
    var $eiARp;
    var $9YiOu;
    var $aXZGL;
    var $fvIsF;
    const $065df2967a66e91f$var$getNextSection = ({ layout: layout, section: ideaViewSection }, currSidebarSection)=>{
        if (layout === 'sidebar') return ideaViewSection ?? currSidebarSection ?? (0, (0, parcelRequire("aXZGL")).DEFAULT_ISSUE_VIEW_SECTION_SIDEBAR);
        return ideaViewSection ?? (0, (0, parcelRequire("aXZGL")).DEFAULT_ISSUE_VIEW_SECTION_FULLSCREEN);
    };
    const $065df2967a66e91f$export$611cbcf98e4cfb6e = (issueKey, { layout: layout, section: ideaViewSection } = {})=>({ dispatch: dispatch, getState: getState }, { section: section })=>{
            const query = (0, (0, parcelRequire("9YiOu")).getPolarisQuerySelector)(getState());
            const updateQueryMethod = issueKey === query?.selectedIssue && layout === query?.issueViewLayout && section !== query?.issueViewSection ? 'replace' : 'push';
            if (updateQueryMethod === 'push') {
                (0, (0, parcelRequire("eiARp")).experience).ideaView.pageSegmentLoad.abort();
                (0, (0, parcelRequire("eiARp")).experience).ideaView.pageSegmentLoad.start();
            }
            dispatch((0, (0, parcelRequire("fvIsF")).setQuery)({
                selectedIssue: issueKey,
                issueViewLayout: layout,
                issueViewSection: $065df2967a66e91f$var$getNextSection({
                    layout: layout,
                    section: ideaViewSection
                }, query.issueViewSection),
                viewCommentId: undefined
            }, updateQueryMethod));
        };
});
parcelRegister("6HVnB", function(module, exports) {
    $parcel$export(module.exports, "useUrlSection", ()=>$f84060fe67a36691$export$47d0b879d0f8a136);
    $parcel$export(module.exports, "useUrlResource", ()=>$f84060fe67a36691$export$cf5a91dc1cc71b53);
    var $dIdda = parcelRequire("dIdda");
    const $f84060fe67a36691$export$47d0b879d0f8a136 = ()=>{
        const [section] = (0, $dIdda.usePathParam)('section');
        return section === 'views' ? 'view' : section;
    };
    const $f84060fe67a36691$export$cf5a91dc1cc71b53 = ()=>{
        const [resource] = (0, $dIdda.usePathParam)('resource');
        return resource;
    };
});
parcelRegister("7gHQ7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e929df7921bf1f4c$export$defe85febe8b728c);
    var $7VHMR;
    const $e929df7921bf1f4c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "issue-archival-archives.manage-bars.label",
            "defaultMessage": "{count} {count, plural, one {item} other {items}} selected"
        },
        closeButtonLabel: {
            "id": "issue-archival-archives.manage-bars.close-button-label",
            "defaultMessage": "Close"
        }
    });
});
parcelRegister("9wdSi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac0648afa0b676a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    var $koVbs;
    var $8eJ0l;
    var $58lzA;
    var $84j7q;
    var $yaW34;
    const $ac0648afa0b676a0$var$UnarchiveIssues = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const state = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const allSelectedIssuesWithDetails = (0, (0, parcelRequire("84j7q")).getAllSelectedIssuesWithDetails)({
            state: state
        });
        const { openUnarchiveIssuesModal: openUnarchiveIssuesModal } = (0, (0, parcelRequire("8eJ0l")).useUnarchiveIssueModalActions)();
        const { clearAllSelections: clearAllSelections, setRefetchArchivesIssuesData: setRefetchArchivesIssuesData } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const onClick = ()=>{
            openUnarchiveIssuesModal({
                selectedIssuesDetails: allSelectedIssuesWithDetails,
                onSuccessCallback: ()=>{
                    clearAllSelections();
                    setRefetchArchivesIssuesData(true);
                },
                showViewIssueActionInSuccessFlag: true
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            id: "issue-archival-archives.manage-bars.unarchive-issues.button",
            appearance: "subtle",
            onClick: onClick
        }, formatMessage((0, (0, parcelRequire("yaW34")).messages).buttonLabel));
    };
    var $ac0648afa0b676a0$export$2e2bcd8739ae039 = $ac0648afa0b676a0$var$UnarchiveIssues;
});
parcelRegister("8eJ0l", function(module, exports) {
    $parcel$export(module.exports, "UnarchiveIssueModalStore", ()=>$7e486f48bf8ad020$export$15ae11a500a318ea);
    $parcel$export(module.exports, "useUnarchiveIssueModalActions", ()=>$7e486f48bf8ad020$export$a62f9f14820c45d1);
    var $7JoAD = parcelRequire("7JoAD");
    var $kTYfT;
    var $kXGVS;
    const $7e486f48bf8ad020$export$15ae11a500a318ea = (0, $7JoAD.createStore)({
        initialState: (0, parcelRequire("kXGVS")).initialState,
        actions: (0, (0, parcelRequire("kTYfT")).UnarchiveIssueModalActions),
        name: 'unarchiveIssueModalStore'
    });
    const $7e486f48bf8ad020$export$a62f9f14820c45d1 = (0, $7JoAD.createActionsHook)($7e486f48bf8ad020$export$15ae11a500a318ea);
});
parcelRegister("kTYfT", function(module, exports) {
    $parcel$export(module.exports, "UnarchiveIssueModalActions", ()=>$fb2b00f42d3a92ee$export$c18e6ef1c7bdce79);
    var $8Rkzz = parcelRequire("8Rkzz");
    const $fb2b00f42d3a92ee$export$c18e6ef1c7bdce79 = {
        openUnarchiveIssueModal: (issueKey)=>({ setState: setState })=>{
                setState({
                    isUnarchiveIssueModalOpen: true,
                    issueKey: issueKey
                });
            },
        closeUnarchiveIssueModal: ()=>({ setState: setState })=>{
                setState({
                    isUnarchiveIssueModalOpen: false,
                    issueKey: null
                });
            },
        openUnarchiveIssuesModal: ({ selectedIssuesDetails: selectedIssuesDetails, onSuccessCallback: onSuccessCallback, onErrorCallback: onErrorCallback, showViewIssueActionInSuccessFlag: showViewIssueActionInSuccessFlag })=>({ setState: setState })=>{
                setState({
                    isUnarchiveIssueModalOpen: true,
                    selectedIssuesDetails: selectedIssuesDetails,
                    onSuccessCallback: onSuccessCallback || (0, ($parcel$interopDefault($8Rkzz))),
                    onErrorCallback: onErrorCallback || (0, ($parcel$interopDefault($8Rkzz))),
                    showViewIssueActionInSuccessFlag: showViewIssueActionInSuccessFlag || false
                });
            },
        closeUnarchiveIssuesModal: ()=>({ setState: setState })=>{
                setState({
                    isUnarchiveIssueModalOpen: false,
                    selectedIssuesDetails: [],
                    onSuccessCallback: (0, ($parcel$interopDefault($8Rkzz))),
                    onErrorCallback: (0, ($parcel$interopDefault($8Rkzz))),
                    showViewIssueActionInSuccessFlag: false
                });
            }
    };
});
parcelRegister("kXGVS", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$b26457d85086a5c9$export$d4c72bab9d6cc13a);
    var $8Rkzz = parcelRequire("8Rkzz");
    const $b26457d85086a5c9$export$d4c72bab9d6cc13a = {
        isUnarchiveIssueModalOpen: false,
        issueKey: null,
        selectedIssuesDetails: [],
        onSuccessCallback: (0, ($parcel$interopDefault($8Rkzz))),
        onErrorCallback: (0, ($parcel$interopDefault($8Rkzz))),
        showViewIssueActionInSuccessFlag: false
    };
});
parcelRegister("yaW34", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$14da3eb649eac943$export$defe85febe8b728c);
    var $7VHMR;
    const $14da3eb649eac943$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        buttonLabel: {
            "id": "issue-archival-archives.manage-bars.unarchive-issues.button-label",
            "defaultMessage": "Restore"
        },
        issueUnarchivalSuccessFlagTitleViewIssue: {
            "id": "issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title-view-issue",
            "defaultMessage": "View issue"
        },
        issueUnarchivalErrorFlagTitle: {
            "id": "issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-error-flag-title",
            "defaultMessage": "Something went wrong at our end. We couldn\u2019t restore the issues. Refresh and try again."
        },
        issueUnarchivalSuccessFlagTitle: {
            "id": "issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title",
            "defaultMessage": "The issue ({issueKey}) has been restored."
        },
        issueUnarchivalSuccessFlagTitleForMultipleIssues: {
            "id": "issue-archival-archives.manage-bars.unarchive-issues.issue-unarchival-success-flag-title-for-multiple-issues",
            "defaultMessage": "The selected issues have been restored."
        }
    });
});
parcelRegister("h5kQv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e1a0497deb82dd8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jDrwg;
    var $2xSAL;
    var $58lzA;
    var $84j7q;
    var $bFzaj;
    const $9e1a0497deb82dd8$var$Search = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const inputRef = (0, $5uXOq.useRef)(null);
        const { setSearchBy: setSearchBy } = (0, (0, parcelRequire("58lzA")).useArchiveIssueActions)();
        const { searchBy: searchBy } = (0, (0, parcelRequire("84j7q")).useArchiveIssueStates)();
        const [debouncedQuery] = (0, (0, parcelRequire("jDrwg")).default)((query)=>{
            setSearchBy(query);
        }, 500);
        (0, $5uXOq.useEffect)(()=>{
            if (searchBy === '' && inputRef.current && inputRef.current.nextSibling) inputRef.current.nextSibling.childNodes[0]?.click();
        }, [
            searchBy
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            inputRef: inputRef,
            isAlwaysExpanded: true,
            placeholderAlwaysVisible: true,
            placeholder: formatMessage((0, (0, parcelRequire("bFzaj")).default).searchIssuesMessage),
            value: searchBy,
            onChange: (query)=>debouncedQuery(query),
            testId: "issue-archival-archives.ui.search.search-input"
        });
    };
    var $9e1a0497deb82dd8$export$2e2bcd8739ae039 = $9e1a0497deb82dd8$var$Search;
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2Dcc2;
    var $dvaUE;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2Dcc2")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dvaUE")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("dvaUE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a76b2dcab00efc18$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7UFJi;
    var $0xqmn;
    const $a76b2dcab00efc18$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $a76b2dcab00efc18$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$a76b2dcab00efc18$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("7UFJi")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$a76b2dcab00efc18$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("0xqmn")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("0xqmn")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $a76b2dcab00efc18$export$2e2bcd8739ae039 = $a76b2dcab00efc18$var$Textfield;
});
parcelRegister("0xqmn", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$4debfbd4861889ad$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$4debfbd4861889ad$export$3eeb47dc8e6249d9);
    const $4debfbd4861889ad$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $dbda9f692ace54dd$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $dbda9f692ace54dd$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $dbda9f692ace54dd$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $4debfbd4861889ad$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $4debfbd4861889ad$var$backgroundColor[appearance],
            borderColor: $4debfbd4861889ad$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $dbda9f692ace54dd$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $4debfbd4861889ad$var$backgroundColorHover[appearance],
                borderColor: $4debfbd4861889ad$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $4debfbd4861889ad$var$backgroundColorFocus[appearance],
                borderColor: $4debfbd4861889ad$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$4debfbd4861889ad$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $dbda9f692ace54dd$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $dbda9f692ace54dd$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $dbda9f692ace54dd$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $dbda9f692ace54dd$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $dbda9f692ace54dd$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $dbda9f692ace54dd$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $dbda9f692ace54dd$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $4debfbd4861889ad$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $4debfbd4861889ad$var$getMaxWidth = (width)=>!width ? `100%` : width in $4debfbd4861889ad$var$widthMap ? $4debfbd4861889ad$var$widthMap[width] : +width;
    const $4debfbd4861889ad$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$4debfbd4861889ad$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $4debfbd4861889ad$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $4debfbd4861889ad$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $dbda9f692ace54dd$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $dbda9f692ace54dd$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Cygm;
    var $k3dcS;
    var $e65Lk;
    var $eYa7e;
    var $ii5wQ;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Cygm")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("k3dcS")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("ii5wQ")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("eYa7e")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $goLm2;
    var $k05Uv;
    var $gDOB9;
    var $7lk8z;
    var $e65Lk;
    var $eYa7e;
    var $ii5wQ;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gDOB9"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("goLm2")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k05Uv"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e65Lk")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7lk8z"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("ii5wQ")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("eYa7e")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("ii5wQ")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("eYa7e")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("ii5wQ")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("eYa7e")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("bFzaj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ad1f619d7565eb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4ad1f619d7565eb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchIssuesMessage: {
            "id": "issue-archival-archives.search.search-issues-message",
            "defaultMessage": "Search issues"
        }
    });
});
parcelRegister("gA8E0", function(module, exports) {
    $parcel$export(module.exports, "LayoutMainWrapper", ()=>$3d0b44929bacf260$export$712225703044cda);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $3d0b44929bacf260$export$712225703044cda = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3d0b44929bacf260$var$LayoutMainWrapperStyle, null, children);
    const $3d0b44929bacf260$var$LayoutMainWrapperStyle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bsb16n6 _v5641fl4 _4t3i1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $6BZYo;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("6BZYo")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
